//INICIO JSON SILLAS
const sillasTotal =
[
    {
        "sillaId": 5514,
        "colorId": 0,
        "numero": "01-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "478.38",
        "coordenadaY": "1364.11",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5515,
        "colorId": 0,
        "numero": "02-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "502.55",
        "coordenadaY": "1353.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5516,
        "colorId": 0,
        "numero": "03-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "526.71",
        "coordenadaY": "1345.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5517,
        "colorId": 0,
        "numero": "04-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "550.87",
        "coordenadaY": "1336.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5518,
        "colorId": 0,
        "numero": "05-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "575.04",
        "coordenadaY": "1328.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5519,
        "colorId": 0,
        "numero": "06-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "599.20",
        "coordenadaY": "1320.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5520,
        "colorId": 0,
        "numero": "07-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "623.36",
        "coordenadaY": "1311.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5521,
        "colorId": 0,
        "numero": "08-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "647.53",
        "coordenadaY": "1304.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5522,
        "colorId": 0,
        "numero": "09-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "671.69",
        "coordenadaY": "1298.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5523,
        "colorId": 0,
        "numero": "10-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "695.85",
        "coordenadaY": "1291.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5524,
        "colorId": 0,
        "numero": "11-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "720.02",
        "coordenadaY": "1284.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5525,
        "colorId": 0,
        "numero": "12-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "744.18",
        "coordenadaY": "1278.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5526,
        "colorId": 0,
        "numero": "13-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "768.34",
        "coordenadaY": "1271.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5527,
        "colorId": 0,
        "numero": "14-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "792.51",
        "coordenadaY": "1266.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5528,
        "colorId": 0,
        "numero": "15-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "816.67",
        "coordenadaY": "1261.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5529,
        "colorId": 0,
        "numero": "16-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "840.84",
        "coordenadaY": "1256.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5530,
        "colorId": 0,
        "numero": "17-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "865.00",
        "coordenadaY": "1251.46",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5531,
        "colorId": 0,
        "numero": "18-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "976.65",
        "coordenadaY": "1225.96",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5532,
        "colorId": 0,
        "numero": "19-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1002.49",
        "coordenadaY": "1222.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5533,
        "colorId": 0,
        "numero": "20-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1028.34",
        "coordenadaY": "1218.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5534,
        "colorId": 0,
        "numero": "21-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1054.18",
        "coordenadaY": "1215.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5535,
        "colorId": 0,
        "numero": "22-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1080.02",
        "coordenadaY": "1213.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5536,
        "colorId": 0,
        "numero": "23-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1105.86",
        "coordenadaY": "1211.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5537,
        "colorId": 0,
        "numero": "24-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1131.70",
        "coordenadaY": "1207.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5538,
        "colorId": 0,
        "numero": "25-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1157.54",
        "coordenadaY": "1204.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5539,
        "colorId": 0,
        "numero": "26-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1183.38",
        "coordenadaY": "1202.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5540,
        "colorId": 0,
        "numero": "27-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1209.22",
        "coordenadaY": "1201.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5541,
        "colorId": 0,
        "numero": "28-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1235.06",
        "coordenadaY": "1201.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5542,
        "colorId": 0,
        "numero": "29-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1260.90",
        "coordenadaY": "1200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5543,
        "colorId": 0,
        "numero": "30-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1286.74",
        "coordenadaY": "1200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5544,
        "colorId": 0,
        "numero": "31-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1312.58",
        "coordenadaY": "1199.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5545,
        "colorId": 0,
        "numero": "32-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1338.42",
        "coordenadaY": "1199.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5546,
        "colorId": 0,
        "numero": "33-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1364.26",
        "coordenadaY": "1199.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5547,
        "colorId": 0,
        "numero": "34-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1390.11",
        "coordenadaY": "1199.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5548,
        "colorId": 0,
        "numero": "35-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1415.95",
        "coordenadaY": "1200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5549,
        "colorId": 0,
        "numero": "36-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1441.78",
        "coordenadaY": "1200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5550,
        "colorId": 0,
        "numero": "37-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1467.62",
        "coordenadaY": "1200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5551,
        "colorId": 0,
        "numero": "38-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1493.46",
        "coordenadaY": "1201.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5552,
        "colorId": 0,
        "numero": "39-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1519.30",
        "coordenadaY": "1202.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5553,
        "colorId": 0,
        "numero": "40-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1545.15",
        "coordenadaY": "1204.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5554,
        "colorId": 0,
        "numero": "41-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1570.99",
        "coordenadaY": "1207.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5555,
        "colorId": 0,
        "numero": "42-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1596.83",
        "coordenadaY": "1210.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5556,
        "colorId": 0,
        "numero": "43-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1622.67",
        "coordenadaY": "1212.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5557,
        "colorId": 0,
        "numero": "44-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1648.51",
        "coordenadaY": "1214.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5558,
        "colorId": 0,
        "numero": "45-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1674.35",
        "coordenadaY": "1218.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5559,
        "colorId": 0,
        "numero": "46-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1700.19",
        "coordenadaY": "1222.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5560,
        "colorId": 0,
        "numero": "47-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1726.03",
        "coordenadaY": "1225.96",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5561,
        "colorId": 0,
        "numero": "48-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1840.38",
        "coordenadaY": "1248.16",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5562,
        "colorId": 0,
        "numero": "49-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1868.30",
        "coordenadaY": "1254.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5563,
        "colorId": 0,
        "numero": "50-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1895.33",
        "coordenadaY": "1261.01",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5564,
        "colorId": 0,
        "numero": "51-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1922.21",
        "coordenadaY": "1267.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5565,
        "colorId": 0,
        "numero": "52-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1948.21",
        "coordenadaY": "1274.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5566,
        "colorId": 0,
        "numero": "53-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1973.24",
        "coordenadaY": "1280.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5567,
        "colorId": 0,
        "numero": "54-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2001.16",
        "coordenadaY": "1287.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5568,
        "colorId": 0,
        "numero": "55-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2026.19",
        "coordenadaY": "1294.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5569,
        "colorId": 0,
        "numero": "56-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2051.22",
        "coordenadaY": "1302.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5570,
        "colorId": 0,
        "numero": "57-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2077.21",
        "coordenadaY": "1309.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5571,
        "colorId": 0,
        "numero": "58-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2104.17",
        "coordenadaY": "1318.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5572,
        "colorId": 0,
        "numero": "59-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2129.20",
        "coordenadaY": "1327.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5573,
        "colorId": 0,
        "numero": "60-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2154.23",
        "coordenadaY": "1336.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5574,
        "colorId": 0,
        "numero": "61-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2180.23",
        "coordenadaY": "1343.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5575,
        "colorId": 0,
        "numero": "62-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2206.22",
        "coordenadaY": "1353.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5576,
        "colorId": 0,
        "numero": "63-A",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "A",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2230.29",
        "coordenadaY": "1362.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5577,
        "colorId": 0,
        "numero": "01-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "454.38",
        "coordenadaY": "1295.78",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5578,
        "colorId": 0,
        "numero": "02-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "479.25",
        "coordenadaY": "1287.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5579,
        "colorId": 0,
        "numero": "03-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "504.12",
        "coordenadaY": "1278.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5580,
        "colorId": 0,
        "numero": "04-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "528.99",
        "coordenadaY": "1270.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5581,
        "colorId": 0,
        "numero": "05-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "553.85",
        "coordenadaY": "1262.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5582,
        "colorId": 0,
        "numero": "06-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "578.72",
        "coordenadaY": "1255.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5583,
        "colorId": 0,
        "numero": "07-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "603.58",
        "coordenadaY": "1247.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5584,
        "colorId": 0,
        "numero": "08-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "628.45",
        "coordenadaY": "1241.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5585,
        "colorId": 0,
        "numero": "09-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "653.32",
        "coordenadaY": "1233.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5586,
        "colorId": 0,
        "numero": "10-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "678.19",
        "coordenadaY": "1225.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5587,
        "colorId": 0,
        "numero": "11-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "703.05",
        "coordenadaY": "1218.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5588,
        "colorId": 0,
        "numero": "12-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "728.87",
        "coordenadaY": "1211.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5589,
        "colorId": 0,
        "numero": "13-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "752.79",
        "coordenadaY": "1205.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5590,
        "colorId": 0,
        "numero": "14-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "777.65",
        "coordenadaY": "1199.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5591,
        "colorId": 0,
        "numero": "15-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "802.52",
        "coordenadaY": "1194.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5592,
        "colorId": 0,
        "numero": "16-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "827.39",
        "coordenadaY": "1188.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5593,
        "colorId": 0,
        "numero": "17-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "852.25",
        "coordenadaY": "1184.05",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5594,
        "colorId": 0,
        "numero": "18-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "964.64",
        "coordenadaY": "1157.65",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5595,
        "colorId": 0,
        "numero": "19-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "990.25",
        "coordenadaY": "1153.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5596,
        "colorId": 0,
        "numero": "20-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1015.87",
        "coordenadaY": "1152.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5597,
        "colorId": 0,
        "numero": "21-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1041.49",
        "coordenadaY": "1147.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5598,
        "colorId": 0,
        "numero": "22-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1067.11",
        "coordenadaY": "1145.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5599,
        "colorId": 0,
        "numero": "23-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1092.73",
        "coordenadaY": "1142.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5600,
        "colorId": 0,
        "numero": "24-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1118.35",
        "coordenadaY": "1141.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5601,
        "colorId": 0,
        "numero": "25-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1143.97",
        "coordenadaY": "1138.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5602,
        "colorId": 0,
        "numero": "26-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1169.59",
        "coordenadaY": "1136.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5603,
        "colorId": 0,
        "numero": "27-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1195.21",
        "coordenadaY": "1133.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5604,
        "colorId": 0,
        "numero": "28-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1220.83",
        "coordenadaY": "1131.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5605,
        "colorId": 0,
        "numero": "29-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1246.45",
        "coordenadaY": "1130.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5606,
        "colorId": 0,
        "numero": "30-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1272.06",
        "coordenadaY": "1129.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5607,
        "colorId": 0,
        "numero": "31-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1297.68",
        "coordenadaY": "1128.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5608,
        "colorId": 0,
        "numero": "32-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1323.30",
        "coordenadaY": "1128.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5609,
        "colorId": 0,
        "numero": "33-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1348.92",
        "coordenadaY": "1128.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5610,
        "colorId": 0,
        "numero": "34-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1374.54",
        "coordenadaY": "1128.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5611,
        "colorId": 0,
        "numero": "35-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1400.16",
        "coordenadaY": "1128.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5612,
        "colorId": 0,
        "numero": "36-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1425.78",
        "coordenadaY": "1129.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5613,
        "colorId": 0,
        "numero": "37-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1451.40",
        "coordenadaY": "1129.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5614,
        "colorId": 0,
        "numero": "38-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1477.02",
        "coordenadaY": "1131.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5615,
        "colorId": 0,
        "numero": "39-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1502.64",
        "coordenadaY": "1132.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5616,
        "colorId": 0,
        "numero": "40-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1528.26",
        "coordenadaY": "1133.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5617,
        "colorId": 0,
        "numero": "41-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1553.88",
        "coordenadaY": "1136.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5618,
        "colorId": 0,
        "numero": "42-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1579.49",
        "coordenadaY": "1138.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5619,
        "colorId": 0,
        "numero": "43-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1605.11",
        "coordenadaY": "1141.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5620,
        "colorId": 0,
        "numero": "44-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1630.74",
        "coordenadaY": "1142.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5621,
        "colorId": 0,
        "numero": "45-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1656.35",
        "coordenadaY": "1144.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5622,
        "colorId": 0,
        "numero": "46-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1681.97",
        "coordenadaY": "1148.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5623,
        "colorId": 0,
        "numero": "47-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1707.59",
        "coordenadaY": "1152.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5624,
        "colorId": 0,
        "numero": "48-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1733.21",
        "coordenadaY": "1155.80",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5625,
        "colorId": 0,
        "numero": "49-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1851.05",
        "coordenadaY": "1180.72",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5626,
        "colorId": 0,
        "numero": "50-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1874.14",
        "coordenadaY": "1184.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5627,
        "colorId": 0,
        "numero": "51-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1900.92",
        "coordenadaY": "1189.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5628,
        "colorId": 0,
        "numero": "52-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1925.85",
        "coordenadaY": "1195.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5629,
        "colorId": 0,
        "numero": "53-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1949.86",
        "coordenadaY": "1201.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5630,
        "colorId": 0,
        "numero": "54-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "1974.79",
        "coordenadaY": "1207.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5631,
        "colorId": 0,
        "numero": "55-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2001.57",
        "coordenadaY": "1214.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5632,
        "colorId": 0,
        "numero": "56-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2028.35",
        "coordenadaY": "1222.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5633,
        "colorId": 0,
        "numero": "57-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2053.28",
        "coordenadaY": "1228.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5634,
        "colorId": 0,
        "numero": "58-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2078.21",
        "coordenadaY": "1236.12",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5635,
        "colorId": 0,
        "numero": "59-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2102.22",
        "coordenadaY": "1244.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5636,
        "colorId": 0,
        "numero": "60-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2126.23",
        "coordenadaY": "1252.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5637,
        "colorId": 0,
        "numero": "61-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2151.16",
        "coordenadaY": "1260.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5638,
        "colorId": 0,
        "numero": "62-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2175.17",
        "coordenadaY": "1268.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5639,
        "colorId": 0,
        "numero": "63-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2199.18",
        "coordenadaY": "1277.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5640,
        "colorId": 0,
        "numero": "64-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2225.03",
        "coordenadaY": "1286.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5641,
        "colorId": 0,
        "numero": "65-B",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "B",
        "cantidadSillas": 61,
        "color": "#D03325",
        "coordenadaX": "2250.89",
        "coordenadaY": "1297.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5642,
        "colorId": 0,
        "numero": "01-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "438.16",
        "coordenadaY": "1250.03",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5643,
        "colorId": 0,
        "numero": "02-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "462.11",
        "coordenadaY": "1240.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5644,
        "colorId": 0,
        "numero": "03-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "485.11",
        "coordenadaY": "1231.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5645,
        "colorId": 0,
        "numero": "04-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "508.10",
        "coordenadaY": "1225.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5646,
        "colorId": 0,
        "numero": "05-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "531.10",
        "coordenadaY": "1217.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5647,
        "colorId": 0,
        "numero": "06-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "554.09",
        "coordenadaY": "1210.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5648,
        "colorId": 0,
        "numero": "07-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "576.69",
        "coordenadaY": "1204.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5649,
        "colorId": 0,
        "numero": "08-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "598.73",
        "coordenadaY": "1196.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5650,
        "colorId": 0,
        "numero": "09-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "620.76",
        "coordenadaY": "1189.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5651,
        "colorId": 0,
        "numero": "10-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "642.80",
        "coordenadaY": "1183.12",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5652,
        "colorId": 0,
        "numero": "11-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "664.84",
        "coordenadaY": "1176.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5653,
        "colorId": 0,
        "numero": "12-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "686.88",
        "coordenadaY": "1170.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5654,
        "colorId": 0,
        "numero": "13-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "708.91",
        "coordenadaY": "1164.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5655,
        "colorId": 0,
        "numero": "14-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "730.95",
        "coordenadaY": "1160.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5656,
        "colorId": 0,
        "numero": "15-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "752.99",
        "coordenadaY": "1155.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5657,
        "colorId": 0,
        "numero": "16-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "775.03",
        "coordenadaY": "1149.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5658,
        "colorId": 0,
        "numero": "17-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "797.06",
        "coordenadaY": "1144.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5659,
        "colorId": 0,
        "numero": "18-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "819.10",
        "coordenadaY": "1139.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5660,
        "colorId": 0,
        "numero": "19-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "841.14",
        "coordenadaY": "1134.18",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5661,
        "colorId": 0,
        "numero": "20-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "957.65",
        "coordenadaY": "1113.93",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5662,
        "colorId": 0,
        "numero": "21-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "983.66",
        "coordenadaY": "1109.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5663,
        "colorId": 0,
        "numero": "22-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1009.68",
        "coordenadaY": "1105.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5664,
        "colorId": 0,
        "numero": "23-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1035.69",
        "coordenadaY": "1100.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5665,
        "colorId": 0,
        "numero": "24-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1061.70",
        "coordenadaY": "1097.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5666,
        "colorId": 0,
        "numero": "25-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1087.71",
        "coordenadaY": "1095.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5667,
        "colorId": 0,
        "numero": "26-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1113.73",
        "coordenadaY": "1092.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5668,
        "colorId": 0,
        "numero": "27-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1139.74",
        "coordenadaY": "1090.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5669,
        "colorId": 0,
        "numero": "28-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1165.75",
        "coordenadaY": "1088.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5670,
        "colorId": 0,
        "numero": "29-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1191.77",
        "coordenadaY": "1086.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5671,
        "colorId": 0,
        "numero": "30-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1217.78",
        "coordenadaY": "1085.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5672,
        "colorId": 0,
        "numero": "31-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1243.79",
        "coordenadaY": "1083.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5673,
        "colorId": 0,
        "numero": "32-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1269.80",
        "coordenadaY": "1082.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5674,
        "colorId": 0,
        "numero": "33-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1296.78",
        "coordenadaY": "1081.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5675,
        "colorId": 0,
        "numero": "34-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1322.79",
        "coordenadaY": "1081.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5676,
        "colorId": 0,
        "numero": "35-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1348.81",
        "coordenadaY": "1081.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5677,
        "colorId": 0,
        "numero": "36-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1374.82",
        "coordenadaY": "1081.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5678,
        "colorId": 0,
        "numero": "37-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1400.83",
        "coordenadaY": "1081.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5679,
        "colorId": 0,
        "numero": "38-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1426.84",
        "coordenadaY": "1081.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5680,
        "colorId": 0,
        "numero": "39-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1452.85",
        "coordenadaY": "1083.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5681,
        "colorId": 0,
        "numero": "40-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1478.87",
        "coordenadaY": "1083.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5682,
        "colorId": 0,
        "numero": "41-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1504.88",
        "coordenadaY": "1085.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5683,
        "colorId": 0,
        "numero": "42-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1530.89",
        "coordenadaY": "1086.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5684,
        "colorId": 0,
        "numero": "43-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1556.90",
        "coordenadaY": "1089.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5685,
        "colorId": 0,
        "numero": "44-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1582.92",
        "coordenadaY": "1091.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5686,
        "colorId": 0,
        "numero": "45-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1608.93",
        "coordenadaY": "1093.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5687,
        "colorId": 0,
        "numero": "46-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1634.94",
        "coordenadaY": "1096.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5688,
        "colorId": 0,
        "numero": "47-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1660.96",
        "coordenadaY": "1098.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5689,
        "colorId": 0,
        "numero": "48-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1686.97",
        "coordenadaY": "1101.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5690,
        "colorId": 0,
        "numero": "49-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1712.98",
        "coordenadaY": "1104.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5691,
        "colorId": 0,
        "numero": "50-C",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#D03325",
        "coordenadaX": "1738.99",
        "coordenadaY": "1108.28",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5692,
        "colorId": 0,
        "numero": "51-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1859.42",
        "coordenadaY": "1130.13",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5693,
        "colorId": 0,
        "numero": "52-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1881.59",
        "coordenadaY": "1134.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5694,
        "colorId": 0,
        "numero": "53-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1904.67",
        "coordenadaY": "1140.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5695,
        "colorId": 0,
        "numero": "54-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1927.76",
        "coordenadaY": "1144.9",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5696,
        "colorId": 0,
        "numero": "55-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1951.76",
        "coordenadaY": "1150.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5697,
        "colorId": 0,
        "numero": "56-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1973.93",
        "coordenadaY": "1156.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5698,
        "colorId": 0,
        "numero": "57-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "1997.01",
        "coordenadaY": "1162.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5699,
        "colorId": 0,
        "numero": "58-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2020.1",
        "coordenadaY": "1168.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5700,
        "colorId": 0,
        "numero": "59-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2042.26",
        "coordenadaY": "1174.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5701,
        "colorId": 0,
        "numero": "60-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2065.34",
        "coordenadaY": "1180.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5702,
        "colorId": 0,
        "numero": "61-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2087.51",
        "coordenadaY": "1187.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5703,
        "colorId": 0,
        "numero": "62-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2111.51",
        "coordenadaY": "1195.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5704,
        "colorId": 0,
        "numero": "63-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2132.75",
        "coordenadaY": "1202.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5705,
        "colorId": 0,
        "numero": "64-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2155.84",
        "coordenadaY": "1209.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5706,
        "colorId": 0,
        "numero": "65-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2178",
        "coordenadaY": "1216.93",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5707,
        "colorId": 0,
        "numero": "66-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2199.24",
        "coordenadaY": "1225.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5708,
        "colorId": 0,
        "numero": "67-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2221.4",
        "coordenadaY": "1233.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5709,
        "colorId": 0,
        "numero": "68-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2243.56",
        "coordenadaY": "1241.86",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5710,
        "colorId": 0,
        "numero": "69-C",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "C",
        "cantidadSillas": 69,
        "color": "#3C5B6F",
        "coordenadaX": "2265.72",
        "coordenadaY": "1250.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5711,
        "colorId": 0,
        "numero": "01-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "422.99",
        "coordenadaY": "1201.59",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5712,
        "colorId": 0,
        "numero": "02-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "444.58",
        "coordenadaY": "1191.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5713,
        "colorId": 0,
        "numero": "03-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "466.17",
        "coordenadaY": "1184.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5714,
        "colorId": 0,
        "numero": "04-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "487.76",
        "coordenadaY": "1176.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5715,
        "colorId": 0,
        "numero": "05-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "509.35",
        "coordenadaY": "1170.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5716,
        "colorId": 0,
        "numero": "06-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "530.95",
        "coordenadaY": "1162.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5717,
        "colorId": 0,
        "numero": "07-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "552.54",
        "coordenadaY": "1156.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5718,
        "colorId": 0,
        "numero": "08-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "574.13",
        "coordenadaY": "1149.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5719,
        "colorId": 0,
        "numero": "09-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "595.72",
        "coordenadaY": "1143.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5720,
        "colorId": 0,
        "numero": "10-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "617.31",
        "coordenadaY": "1136.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5721,
        "colorId": 0,
        "numero": "11-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "638.91",
        "coordenadaY": "1129.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5722,
        "colorId": 0,
        "numero": "12-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "660.50",
        "coordenadaY": "1124.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5723,
        "colorId": 0,
        "numero": "13-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "682.09",
        "coordenadaY": "1118.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5724,
        "colorId": 0,
        "numero": "14-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "703.68",
        "coordenadaY": "1112.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5725,
        "colorId": 0,
        "numero": "15-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "725.28",
        "coordenadaY": "1106.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5726,
        "colorId": 0,
        "numero": "16-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "746.87",
        "coordenadaY": "1101.86",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5727,
        "colorId": 0,
        "numero": "17-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "768.46",
        "coordenadaY": "1097.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5728,
        "colorId": 0,
        "numero": "18-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "790.05",
        "coordenadaY": "1092.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5729,
        "colorId": 0,
        "numero": "19-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "811.64",
        "coordenadaY": "1087.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5730,
        "colorId": 0,
        "numero": "20-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "833.24",
        "coordenadaY": "1081.55",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5731,
        "colorId": 0,
        "numero": "21-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "953.29",
        "coordenadaY": "1060.75",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5732,
        "colorId": 0,
        "numero": "22-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "979.95",
        "coordenadaY": "1056.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5733,
        "colorId": 0,
        "numero": "23-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1006.62",
        "coordenadaY": "1051.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5734,
        "colorId": 0,
        "numero": "24-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1033.29",
        "coordenadaY": "1047.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5735,
        "colorId": 0,
        "numero": "25-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1059.96",
        "coordenadaY": "1042.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5736,
        "colorId": 0,
        "numero": "26-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1086.62",
        "coordenadaY": "1039.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5737,
        "colorId": 0,
        "numero": "27-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1113.29",
        "coordenadaY": "1037.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5738,
        "colorId": 0,
        "numero": "28-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1139.96",
        "coordenadaY": "1034.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5739,
        "colorId": 0,
        "numero": "29-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1166.63",
        "coordenadaY": "1030.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5740,
        "colorId": 0,
        "numero": "30-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1193.29",
        "coordenadaY": "1028.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5741,
        "colorId": 0,
        "numero": "31-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1219.96",
        "coordenadaY": "1027.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5742,
        "colorId": 0,
        "numero": "32-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1246.63",
        "coordenadaY": "1026.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5743,
        "colorId": 0,
        "numero": "33-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1273.29",
        "coordenadaY": "1026.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5744,
        "colorId": 0,
        "numero": "34-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1299.96",
        "coordenadaY": "1026.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5745,
        "colorId": 0,
        "numero": "35-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1326.62",
        "coordenadaY": "1025.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5746,
        "colorId": 0,
        "numero": "36-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1353.29",
        "coordenadaY": "1024.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5747,
        "colorId": 0,
        "numero": "37-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1379.94",
        "coordenadaY": "1024.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5748,
        "colorId": 0,
        "numero": "38-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1406.61",
        "coordenadaY": "1024.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5749,
        "colorId": 0,
        "numero": "39-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1433.27",
        "coordenadaY": "1025.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5750,
        "colorId": 0,
        "numero": "40-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1459.94",
        "coordenadaY": "1026.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5751,
        "colorId": 0,
        "numero": "41-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1486.61",
        "coordenadaY": "1026.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5752,
        "colorId": 0,
        "numero": "42-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1513.27",
        "coordenadaY": "1028.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5753,
        "colorId": 0,
        "numero": "43-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1539.94",
        "coordenadaY": "1029.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5754,
        "colorId": 0,
        "numero": "44-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1566.61",
        "coordenadaY": "1032.93",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5755,
        "colorId": 0,
        "numero": "45-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1593.27",
        "coordenadaY": "1034.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5756,
        "colorId": 0,
        "numero": "46-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1619.94",
        "coordenadaY": "1037.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5757,
        "colorId": 0,
        "numero": "47-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1646.61",
        "coordenadaY": "1040.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5758,
        "colorId": 0,
        "numero": "48-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1673.28",
        "coordenadaY": "1044.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5759,
        "colorId": 0,
        "numero": "49-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1699.94",
        "coordenadaY": "1047.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5760,
        "colorId": 0,
        "numero": "50-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1726.61",
        "coordenadaY": "1051.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5761,
        "colorId": 0,
        "numero": "51-D",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1753.28",
        "coordenadaY": "1055.19",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5762,
        "colorId": 0,
        "numero": "52-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1869.11",
        "coordenadaY": "1078.13",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5763,
        "colorId": 0,
        "numero": "53-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1891.22",
        "coordenadaY": "1083.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5764,
        "colorId": 0,
        "numero": "54-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1913.34",
        "coordenadaY": "1088.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5765,
        "colorId": 0,
        "numero": "55-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1935.44",
        "coordenadaY": "1092.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5766,
        "colorId": 0,
        "numero": "56-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1958.46",
        "coordenadaY": "1097.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5767,
        "colorId": 0,
        "numero": "57-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1979.69",
        "coordenadaY": "1103.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5768,
        "colorId": 0,
        "numero": "58-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2001.80",
        "coordenadaY": "1109.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5769,
        "colorId": 0,
        "numero": "59-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2024.80",
        "coordenadaY": "1114.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5770,
        "colorId": 0,
        "numero": "60-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2046.92",
        "coordenadaY": "1119.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5771,
        "colorId": 0,
        "numero": "61-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2068.15",
        "coordenadaY": "1126.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5772,
        "colorId": 0,
        "numero": "62-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2090.27",
        "coordenadaY": "1131.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5773,
        "colorId": 0,
        "numero": "63-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2112.38",
        "coordenadaY": "1139.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5774,
        "colorId": 0,
        "numero": "64-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2134.50",
        "coordenadaY": "1145.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5775,
        "colorId": 0,
        "numero": "65-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2156.62",
        "coordenadaY": "1152.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5776,
        "colorId": 0,
        "numero": "66-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2177.85",
        "coordenadaY": "1159.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5777,
        "colorId": 0,
        "numero": "67-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2199.08",
        "coordenadaY": "1166.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5778,
        "colorId": 0,
        "numero": "68-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2220.31",
        "coordenadaY": "1173.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5779,
        "colorId": 0,
        "numero": "69-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2241.54",
        "coordenadaY": "1180.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5780,
        "colorId": 0,
        "numero": "70-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2262.77",
        "coordenadaY": "1189.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5781,
        "colorId": 0,
        "numero": "71-D",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "D",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2285.46",
        "coordenadaY": "1197.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5782,
        "colorId": 0,
        "numero": "01-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "406.37",
        "coordenadaY": "1148.96",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5783,
        "colorId": 0,
        "numero": "02-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "428.73",
        "coordenadaY": "1141.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5784,
        "colorId": 0,
        "numero": "03-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "451.10",
        "coordenadaY": "1132.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5785,
        "colorId": 0,
        "numero": "04-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "473.47",
        "coordenadaY": "1124.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5786,
        "colorId": 0,
        "numero": "05-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "495.84",
        "coordenadaY": "1118.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5787,
        "colorId": 0,
        "numero": "06-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "518.21",
        "coordenadaY": "1110.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5788,
        "colorId": 0,
        "numero": "07-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "540.58",
        "coordenadaY": "1103.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5789,
        "colorId": 0,
        "numero": "08-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "562.95",
        "coordenadaY": "1097.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5790,
        "colorId": 0,
        "numero": "09-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "585.32",
        "coordenadaY": "1090.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5791,
        "colorId": 0,
        "numero": "10-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "607.69",
        "coordenadaY": "1084.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5792,
        "colorId": 0,
        "numero": "11-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "630.06",
        "coordenadaY": "1078.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5793,
        "colorId": 0,
        "numero": "12-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "652.43",
        "coordenadaY": "1071.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5794,
        "colorId": 0,
        "numero": "13-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "674.80",
        "coordenadaY": "1066.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5795,
        "colorId": 0,
        "numero": "14-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "741.91",
        "coordenadaY": "1050.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5796,
        "colorId": 0,
        "numero": "15-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "719.54",
        "coordenadaY": "1054.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5797,
        "colorId": 0,
        "numero": "16-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "697.17",
        "coordenadaY": "1060.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5798,
        "colorId": 0,
        "numero": "17-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "764.28",
        "coordenadaY": "1044.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5799,
        "colorId": 0,
        "numero": "18-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "786.65",
        "coordenadaY": "1040.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5800,
        "colorId": 0,
        "numero": "19-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "809.02",
        "coordenadaY": "1034.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5801,
        "colorId": 0,
        "numero": "20-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "831.39",
        "coordenadaY": "1029.84",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5802,
        "colorId": 0,
        "numero": "21-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "945.93",
        "coordenadaY": "1004.93",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5803,
        "colorId": 0,
        "numero": "22-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "972.50",
        "coordenadaY": "1002.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5804,
        "colorId": 0,
        "numero": "23-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "999.08",
        "coordenadaY": "998.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5805,
        "colorId": 0,
        "numero": "24-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1025.65",
        "coordenadaY": "996.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5806,
        "colorId": 0,
        "numero": "25-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1052.23",
        "coordenadaY": "992.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5807,
        "colorId": 0,
        "numero": "26-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1078.81",
        "coordenadaY": "990.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5808,
        "colorId": 0,
        "numero": "27-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1105.38",
        "coordenadaY": "988.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5809,
        "colorId": 0,
        "numero": "28-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1126.89",
        "coordenadaY": "988.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5810,
        "colorId": 0,
        "numero": "29-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1153.46",
        "coordenadaY": "985.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5811,
        "colorId": 0,
        "numero": "30-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1180.04",
        "coordenadaY": "984.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5812,
        "colorId": 0,
        "numero": "31-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1206.62",
        "coordenadaY": "982.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5813,
        "colorId": 0,
        "numero": "32-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1233.19",
        "coordenadaY": "981.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5814,
        "colorId": 0,
        "numero": "33-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1259.77",
        "coordenadaY": "980.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5815,
        "colorId": 0,
        "numero": "34-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1286.35",
        "coordenadaY": "980.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5816,
        "colorId": 0,
        "numero": "35-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1312.92",
        "coordenadaY": "980.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5817,
        "colorId": 0,
        "numero": "36-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1339.50",
        "coordenadaY": "981.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5818,
        "colorId": 0,
        "numero": "37-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1366.07",
        "coordenadaY": "980.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5819,
        "colorId": 0,
        "numero": "38-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1392.65",
        "coordenadaY": "981.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5820,
        "colorId": 0,
        "numero": "39-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1419.23",
        "coordenadaY": "981.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5821,
        "colorId": 0,
        "numero": "40-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1446.72",
        "coordenadaY": "981.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5822,
        "colorId": 0,
        "numero": "41-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1473.30",
        "coordenadaY": "981.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5823,
        "colorId": 0,
        "numero": "42-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1499.88",
        "coordenadaY": "983.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5824,
        "colorId": 0,
        "numero": "43-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1526.45",
        "coordenadaY": "985.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5825,
        "colorId": 0,
        "numero": "44-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1552.11",
        "coordenadaY": "985.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5826,
        "colorId": 0,
        "numero": "45-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1578.69",
        "coordenadaY": "987.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5827,
        "colorId": 0,
        "numero": "46-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1607.10",
        "coordenadaY": "990.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5828,
        "colorId": 0,
        "numero": "47-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1634.59",
        "coordenadaY": "992.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5829,
        "colorId": 0,
        "numero": "48-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1660.25",
        "coordenadaY": "995.86",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5830,
        "colorId": 0,
        "numero": "49-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1684.08",
        "coordenadaY": "999.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5831,
        "colorId": 0,
        "numero": "50-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1710.66",
        "coordenadaY": "1001.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5832,
        "colorId": 0,
        "numero": "51-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1734.48",
        "coordenadaY": "1005.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5833,
        "colorId": 0,
        "numero": "52-E",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#D03325",
        "coordenadaX": "1756.48",
        "coordenadaY": "1008.23",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5834,
        "colorId": 0,
        "numero": "53-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1875.56",
        "coordenadaY": "1029.52",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5835,
        "colorId": 0,
        "numero": "54-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1897.78",
        "coordenadaY": "1033.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5836,
        "colorId": 0,
        "numero": "55-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1922.90",
        "coordenadaY": "1038.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5837,
        "colorId": 0,
        "numero": "56-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1946.08",
        "coordenadaY": "1045.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5838,
        "colorId": 0,
        "numero": "57-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1970.23",
        "coordenadaY": "1049.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5839,
        "colorId": 0,
        "numero": "58-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "1996.31",
        "coordenadaY": "1056.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5840,
        "colorId": 0,
        "numero": "59-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2017.56",
        "coordenadaY": "1062.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5841,
        "colorId": 0,
        "numero": "60-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2043.64",
        "coordenadaY": "1070.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5842,
        "colorId": 0,
        "numero": "61-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2064.90",
        "coordenadaY": "1076.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5843,
        "colorId": 0,
        "numero": "62-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2089.05",
        "coordenadaY": "1082.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5844,
        "colorId": 0,
        "numero": "63-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2112.23",
        "coordenadaY": "1089.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5845,
        "colorId": 0,
        "numero": "64-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2136.38",
        "coordenadaY": "1097.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5846,
        "colorId": 0,
        "numero": "65-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2159.56",
        "coordenadaY": "1104.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5847,
        "colorId": 0,
        "numero": "66-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2181.78",
        "coordenadaY": "1112.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5848,
        "colorId": 0,
        "numero": "67-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2205.93",
        "coordenadaY": "1121.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5849,
        "colorId": 0,
        "numero": "68-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2230.08",
        "coordenadaY": "1128.83",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5850,
        "colorId": 0,
        "numero": "69-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2252.30",
        "coordenadaY": "1136.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5851,
        "colorId": 0,
        "numero": "70-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2275.48",
        "coordenadaY": "1145.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5852,
        "colorId": 0,
        "numero": "71-E",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "E",
        "cantidadSillas": 70,
        "color": "#3C5B6F",
        "coordenadaX": "2297.70",
        "coordenadaY": "1153.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5853,
        "colorId": 0,
        "numero": "01-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "390.66",
        "coordenadaY": "1105.56",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5854,
        "colorId": 0,
        "numero": "02-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "413.46",
        "coordenadaY": "1097.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5855,
        "colorId": 0,
        "numero": "03-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "436.25",
        "coordenadaY": "1088.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5856,
        "colorId": 0,
        "numero": "04-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "459.05",
        "coordenadaY": "1080.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5857,
        "colorId": 0,
        "numero": "05-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "481.84",
        "coordenadaY": "1074.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5858,
        "colorId": 0,
        "numero": "06-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "504.64",
        "coordenadaY": "1066.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5859,
        "colorId": 0,
        "numero": "07-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "527.43",
        "coordenadaY": "1059.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5860,
        "colorId": 0,
        "numero": "08-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "550.23",
        "coordenadaY": "1052.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5861,
        "colorId": 0,
        "numero": "09-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "573.02",
        "coordenadaY": "1045.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5862,
        "colorId": 0,
        "numero": "10-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "595.82",
        "coordenadaY": "1039.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5863,
        "colorId": 0,
        "numero": "11-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "618.61",
        "coordenadaY": "1032.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5864,
        "colorId": 0,
        "numero": "12-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "641.41",
        "coordenadaY": "1026.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5865,
        "colorId": 0,
        "numero": "13-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "664.20",
        "coordenadaY": "1019.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5866,
        "colorId": 0,
        "numero": "14-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "687.00",
        "coordenadaY": "1014.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5867,
        "colorId": 0,
        "numero": "15-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "709.79",
        "coordenadaY": "1008.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5868,
        "colorId": 0,
        "numero": "16-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "732.59",
        "coordenadaY": "1003.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5869,
        "colorId": 0,
        "numero": "17-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "755.38",
        "coordenadaY": "996.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5870,
        "colorId": 0,
        "numero": "18-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "778.18",
        "coordenadaY": "991.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5871,
        "colorId": 0,
        "numero": "19-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "800.97",
        "coordenadaY": "987.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5872,
        "colorId": 0,
        "numero": "20-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "823.77",
        "coordenadaY": "982.75",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5873,
        "colorId": 0,
        "numero": "21-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "939.63",
        "coordenadaY": "957.33",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5874,
        "colorId": 0,
        "numero": "22-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "965.26",
        "coordenadaY": "953.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5875,
        "colorId": 0,
        "numero": "23-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "989.07",
        "coordenadaY": "950.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5876,
        "colorId": 0,
        "numero": "24-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1014.70",
        "coordenadaY": "948.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5877,
        "colorId": 0,
        "numero": "25-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1043.09",
        "coordenadaY": "944.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5878,
        "colorId": 0,
        "numero": "26-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1069.64",
        "coordenadaY": "940.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5879,
        "colorId": 0,
        "numero": "27-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1094.36",
        "coordenadaY": "937.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5880,
        "colorId": 0,
        "numero": "28-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1120.91",
        "coordenadaY": "936.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5881,
        "colorId": 0,
        "numero": "29-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1147.46",
        "coordenadaY": "934.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5882,
        "colorId": 0,
        "numero": "30-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1173.10",
        "coordenadaY": "932.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5883,
        "colorId": 0,
        "numero": "31-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1199.65",
        "coordenadaY": "930.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5884,
        "colorId": 0,
        "numero": "32-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1226.21",
        "coordenadaY": "930.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5885,
        "colorId": 0,
        "numero": "33-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1252.76",
        "coordenadaY": "929.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5886,
        "colorId": 0,
        "numero": "34-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1277.48",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5887,
        "colorId": 0,
        "numero": "35-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1306.78",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5888,
        "colorId": 0,
        "numero": "36-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1331.49",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5889,
        "colorId": 0,
        "numero": "37-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1356.21",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5890,
        "colorId": 0,
        "numero": "38-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1381.85",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5891,
        "colorId": 0,
        "numero": "39-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1410.23",
        "coordenadaY": "927.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5892,
        "colorId": 0,
        "numero": "40-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1434.95",
        "coordenadaY": "928.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5893,
        "colorId": 0,
        "numero": "41-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1461.51",
        "coordenadaY": "929.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5894,
        "colorId": 0,
        "numero": "42-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1488.97",
        "coordenadaY": "930.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5895,
        "colorId": 0,
        "numero": "43-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1512.29",
        "coordenadaY": "930.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5896,
        "colorId": 0,
        "numero": "44-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1537.01",
        "coordenadaY": "934.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5897,
        "colorId": 0,
        "numero": "45-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1563.56",
        "coordenadaY": "936.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5898,
        "colorId": 0,
        "numero": "46-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1590.11",
        "coordenadaY": "937.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5899,
        "colorId": 0,
        "numero": "47-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1613.92",
        "coordenadaY": "940.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5900,
        "colorId": 0,
        "numero": "48-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1638.64",
        "coordenadaY": "944.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5901,
        "colorId": 0,
        "numero": "49-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1660.61",
        "coordenadaY": "946.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5902,
        "colorId": 0,
        "numero": "50-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1688.08",
        "coordenadaY": "949.02",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5903,
        "colorId": 0,
        "numero": "51-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1715.55",
        "coordenadaY": "952.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5904,
        "colorId": 0,
        "numero": "52-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1742.10",
        "coordenadaY": "956.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5905,
        "colorId": 0,
        "numero": "53-F",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#D03325",
        "coordenadaX": "1766.82",
        "coordenadaY": "960.10",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5906,
        "colorId": 0,
        "numero": "54-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "1884.48",
        "coordenadaY": "980.63",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5907,
        "colorId": 0,
        "numero": "55-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "1906.87",
        "coordenadaY": "984.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5908,
        "colorId": 0,
        "numero": "56-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "1930.19",
        "coordenadaY": "991.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5909,
        "colorId": 0,
        "numero": "57-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "1952.58",
        "coordenadaY": "995.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5910,
        "colorId": 0,
        "numero": "58-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "1975.90",
        "coordenadaY": "1000.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5911,
        "colorId": 0,
        "numero": "59-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2001.08",
        "coordenadaY": "1006.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5912,
        "colorId": 0,
        "numero": "60-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2023.47",
        "coordenadaY": "1012.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5913,
        "colorId": 0,
        "numero": "61-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2046.79",
        "coordenadaY": "1018.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5914,
        "colorId": 0,
        "numero": "62-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2068.25",
        "coordenadaY": "1025.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5915,
        "colorId": 0,
        "numero": "63-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2091.57",
        "coordenadaY": "1031.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5916,
        "colorId": 0,
        "numero": "64-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2113.96",
        "coordenadaY": "1036.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5917,
        "colorId": 0,
        "numero": "65-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2136.35",
        "coordenadaY": "1045.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5918,
        "colorId": 0,
        "numero": "66-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2159.67",
        "coordenadaY": "1051.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5919,
        "colorId": 0,
        "numero": "67-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2182.05",
        "coordenadaY": "1060.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5920,
        "colorId": 0,
        "numero": "68-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2204.44",
        "coordenadaY": "1066.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5921,
        "colorId": 0,
        "numero": "69-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2225.90",
        "coordenadaY": "1073.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5922,
        "colorId": 0,
        "numero": "70-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2249.22",
        "coordenadaY": "1082.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5923,
        "colorId": 0,
        "numero": "71-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2271.61",
        "coordenadaY": "1090.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5924,
        "colorId": 0,
        "numero": "72-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2292.13",
        "coordenadaY": "1099.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5925,
        "colorId": 0,
        "numero": "73-F",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "F",
        "cantidadSillas": 72,
        "color": "#3C5B6F",
        "coordenadaX": "2314.95",
        "coordenadaY": "1106.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5926,
        "colorId": 0,
        "numero": "01-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "375.88",
        "coordenadaY": "1059.40",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5927,
        "colorId": 0,
        "numero": "02-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "397.67",
        "coordenadaY": "1050.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5928,
        "colorId": 0,
        "numero": "03-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "419.47",
        "coordenadaY": "1040.93",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5929,
        "colorId": 0,
        "numero": "04-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "441.26",
        "coordenadaY": "1032.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5930,
        "colorId": 0,
        "numero": "05-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "463.05",
        "coordenadaY": "1024.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5931,
        "colorId": 0,
        "numero": "06-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "484.85",
        "coordenadaY": "1017.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5932,
        "colorId": 0,
        "numero": "07-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "506.64",
        "coordenadaY": "1010.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5933,
        "colorId": 0,
        "numero": "08-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "529.34",
        "coordenadaY": "1004.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5934,
        "colorId": 0,
        "numero": "09-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "551.13",
        "coordenadaY": "996.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5935,
        "colorId": 0,
        "numero": "10-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "572.93",
        "coordenadaY": "990.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5936,
        "colorId": 0,
        "numero": "11-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "594.72",
        "coordenadaY": "983.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5937,
        "colorId": 0,
        "numero": "12-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "616.51",
        "coordenadaY": "977.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5938,
        "colorId": 0,
        "numero": "13-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "638.30",
        "coordenadaY": "971.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5939,
        "colorId": 0,
        "numero": "14-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "660.10",
        "coordenadaY": "965.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5940,
        "colorId": 0,
        "numero": "15-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "681.89",
        "coordenadaY": "960.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5941,
        "colorId": 0,
        "numero": "16-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "703.68",
        "coordenadaY": "954.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5942,
        "colorId": 0,
        "numero": "17-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "725.48",
        "coordenadaY": "949.51",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5943,
        "colorId": 0,
        "numero": "18-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "747.27",
        "coordenadaY": "944.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5944,
        "colorId": 0,
        "numero": "19-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "769.06",
        "coordenadaY": "939.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5945,
        "colorId": 0,
        "numero": "20-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "790.86",
        "coordenadaY": "933.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5946,
        "colorId": 0,
        "numero": "21-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "812.65",
        "coordenadaY": "928.27",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5947,
        "colorId": 0,
        "numero": "22-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "933.21",
        "coordenadaY": "910.20",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5948,
        "colorId": 0,
        "numero": "23-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "958.50",
        "coordenadaY": "906.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5949,
        "colorId": 0,
        "numero": "24-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "984.73",
        "coordenadaY": "902.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5950,
        "colorId": 0,
        "numero": "25-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1010.78",
        "coordenadaY": "900.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5951,
        "colorId": 0,
        "numero": "26-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1036.25",
        "coordenadaY": "897.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5952,
        "colorId": 0,
        "numero": "27-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1062.47",
        "coordenadaY": "893.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5953,
        "colorId": 0,
        "numero": "28-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1087.76",
        "coordenadaY": "890.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5954,
        "colorId": 0,
        "numero": "29-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1116.80",
        "coordenadaY": "887.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5955,
        "colorId": 0,
        "numero": "30-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1143.03",
        "coordenadaY": "886.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5956,
        "colorId": 0,
        "numero": "31-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1168.32",
        "coordenadaY": "883.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5957,
        "colorId": 0,
        "numero": "32-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1195.48",
        "coordenadaY": "882.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5958,
        "colorId": 0,
        "numero": "33-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1220.77",
        "coordenadaY": "881.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5959,
        "colorId": 0,
        "numero": "34-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1247.94",
        "coordenadaY": "881.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5960,
        "colorId": 0,
        "numero": "35-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1275.10",
        "coordenadaY": "880.65",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5961,
        "colorId": 0,
        "numero": "36-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1430.01",
        "coordenadaY": "876.95",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5962,
        "colorId": 0,
        "numero": "37-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1454.43",
        "coordenadaY": "877.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5963,
        "colorId": 0,
        "numero": "38-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1481.67",
        "coordenadaY": "878.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5964,
        "colorId": 0,
        "numero": "39-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1508.90",
        "coordenadaY": "880.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5965,
        "colorId": 0,
        "numero": "40-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1534.26",
        "coordenadaY": "880.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5966,
        "colorId": 0,
        "numero": "41-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1561.49",
        "coordenadaY": "882.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5967,
        "colorId": 0,
        "numero": "42-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1586.84",
        "coordenadaY": "885.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5968,
        "colorId": 0,
        "numero": "43-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1614.08",
        "coordenadaY": "888.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5969,
        "colorId": 0,
        "numero": "44-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1640.37",
        "coordenadaY": "890.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5970,
        "colorId": 0,
        "numero": "45-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1665.73",
        "coordenadaY": "893.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5971,
        "colorId": 0,
        "numero": "46-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1693.90",
        "coordenadaY": "894.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5972,
        "colorId": 0,
        "numero": "47-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1719.26",
        "coordenadaY": "899.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5973,
        "colorId": 0,
        "numero": "48-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1745.55",
        "coordenadaY": "901.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5974,
        "colorId": 0,
        "numero": "49-G",
        "idVarianteShopify": "49320688681243",
        "idVarianteShopifyNino": "51305771434267",
        "area": "Travesía Premium",
        "areaId": 10,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#D03325",
        "coordenadaX": "1771.85",
        "coordenadaY": "907.42",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 169,
        "precioDolarNinos": 99,
        "precioDolarLocal": 99,
        "precioDolarLocalNinos": 59,
        "precioDolarEspecial": 79,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 5975,
        "colorId": 0,
        "numero": "50-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1893.81",
        "coordenadaY": "930.74",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5976,
        "colorId": 0,
        "numero": "51-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1916.44",
        "coordenadaY": "936.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5977,
        "colorId": 0,
        "numero": "52-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1940.02",
        "coordenadaY": "941.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5978,
        "colorId": 0,
        "numero": "53-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1963.60",
        "coordenadaY": "945.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5979,
        "colorId": 0,
        "numero": "54-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "1986.23",
        "coordenadaY": "951.73",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5980,
        "colorId": 0,
        "numero": "55-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2011.69",
        "coordenadaY": "958.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5981,
        "colorId": 0,
        "numero": "56-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2035.27",
        "coordenadaY": "964.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5982,
        "colorId": 0,
        "numero": "57-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2057.90",
        "coordenadaY": "970.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5983,
        "colorId": 0,
        "numero": "58-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2080.54",
        "coordenadaY": "977.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5984,
        "colorId": 0,
        "numero": "59-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2104.11",
        "coordenadaY": "984.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5985,
        "colorId": 0,
        "numero": "60-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2126.75",
        "coordenadaY": "990.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5986,
        "colorId": 0,
        "numero": "61-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2149.38",
        "coordenadaY": "996.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5987,
        "colorId": 0,
        "numero": "62-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2172.96",
        "coordenadaY": "1004.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5988,
        "colorId": 0,
        "numero": "63-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2194.65",
        "coordenadaY": "1010.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5989,
        "colorId": 0,
        "numero": "64-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2218.23",
        "coordenadaY": "1018.51",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5990,
        "colorId": 0,
        "numero": "65-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2239.92",
        "coordenadaY": "1027.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5991,
        "colorId": 0,
        "numero": "66-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2262.55",
        "coordenadaY": "1033.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5992,
        "colorId": 0,
        "numero": "67-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2286.13",
        "coordenadaY": "1042.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5993,
        "colorId": 0,
        "numero": "68-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2307.82",
        "coordenadaY": "1051.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5994,
        "colorId": 0,
        "numero": "69-G",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "G",
        "cantidadSillas": 68,
        "color": "#3C5B6F",
        "coordenadaX": "2330.45",
        "coordenadaY": "1060.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5995,
        "colorId": 0,
        "numero": "01-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "348.938",
        "coordenadaY": "969.663",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5996,
        "colorId": 0,
        "numero": "02-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "370.176",
        "coordenadaY": "961.352",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5997,
        "colorId": 0,
        "numero": "03-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "392.338",
        "coordenadaY": "953.963",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5998,
        "colorId": 0,
        "numero": "04-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "414.5",
        "coordenadaY": "944.729",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 5999,
        "colorId": 0,
        "numero": "05-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "436.662",
        "coordenadaY": "937.342",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6000,
        "colorId": 0,
        "numero": "06-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "458.824",
        "coordenadaY": "929.956",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6001,
        "colorId": 0,
        "numero": "07-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "480.986",
        "coordenadaY": "922.569",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6002,
        "colorId": 0,
        "numero": "08-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "503.147",
        "coordenadaY": "916.104",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6003,
        "colorId": 0,
        "numero": "09-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "525.31",
        "coordenadaY": "909.641",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6004,
        "colorId": 0,
        "numero": "10-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "547.471",
        "coordenadaY": "903.176",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6005,
        "colorId": 0,
        "numero": "11-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "569.633",
        "coordenadaY": "896.713",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6006,
        "colorId": 0,
        "numero": "12-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "591.795",
        "coordenadaY": "889.325",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6007,
        "colorId": 0,
        "numero": "13-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "613.957",
        "coordenadaY": "882.862",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6008,
        "colorId": 0,
        "numero": "14-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "636.119",
        "coordenadaY": "877.321",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6009,
        "colorId": 0,
        "numero": "15-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "658.281",
        "coordenadaY": "871.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6010,
        "colorId": 0,
        "numero": "16-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "680.442",
        "coordenadaY": "867.163",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6011,
        "colorId": 0,
        "numero": "17-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "702.604",
        "coordenadaY": "861.624",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6012,
        "colorId": 0,
        "numero": "18-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "724.766",
        "coordenadaY": "856.083",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6013,
        "colorId": 0,
        "numero": "19-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "746.928",
        "coordenadaY": "851.465",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6014,
        "colorId": 0,
        "numero": "20-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "769.09",
        "coordenadaY": "845.924",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6015,
        "colorId": 0,
        "numero": "21-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "791.251",
        "coordenadaY": "841.307",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6016,
        "colorId": 0,
        "numero": "22-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "927.21",
        "coordenadaY": "818.80",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6017,
        "colorId": 0,
        "numero": "23-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "950.30",
        "coordenadaY": "815.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6018,
        "colorId": 0,
        "numero": "24-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "971.54",
        "coordenadaY": "812.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6019,
        "colorId": 0,
        "numero": "25-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "995.55",
        "coordenadaY": "808.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6020,
        "colorId": 0,
        "numero": "26-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1019.55",
        "coordenadaY": "806.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6021,
        "colorId": 0,
        "numero": "27-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1042.64",
        "coordenadaY": "804.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6022,
        "colorId": 0,
        "numero": "28-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1065.72",
        "coordenadaY": "801.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6023,
        "colorId": 0,
        "numero": "29-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1089.73",
        "coordenadaY": "798.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6024,
        "colorId": 0,
        "numero": "30-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1112.82",
        "coordenadaY": "795.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6025,
        "colorId": 0,
        "numero": "31-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1138.67",
        "coordenadaY": "793.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6026,
        "colorId": 0,
        "numero": "32-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1161.76",
        "coordenadaY": "792.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6027,
        "colorId": 0,
        "numero": "33-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1185.77",
        "coordenadaY": "791.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6028,
        "colorId": 0,
        "numero": "34-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1209.78",
        "coordenadaY": "788.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6029,
        "colorId": 0,
        "numero": "35-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1232.86",
        "coordenadaY": "787.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6030,
        "colorId": 0,
        "numero": "36-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1256.87",
        "coordenadaY": "785.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6031,
        "colorId": 0,
        "numero": "37-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1280.88",
        "coordenadaY": "784.64",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6032,
        "colorId": 0,
        "numero": "38-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1437.86",
        "coordenadaY": "784.64",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6033,
        "colorId": 0,
        "numero": "39-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1460.95",
        "coordenadaY": "784.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6034,
        "colorId": 0,
        "numero": "40-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1485.88",
        "coordenadaY": "787.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6035,
        "colorId": 0,
        "numero": "41-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1508.96",
        "coordenadaY": "789.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6036,
        "colorId": 0,
        "numero": "42-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1532.05",
        "coordenadaY": "791.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6037,
        "colorId": 0,
        "numero": "43-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1556.06",
        "coordenadaY": "792.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6038,
        "colorId": 0,
        "numero": "44-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1580.95",
        "coordenadaY": "794.829",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6039,
        "colorId": 0,
        "numero": "45-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1604.07",
        "coordenadaY": "796.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6040,
        "colorId": 0,
        "numero": "46-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1628.08",
        "coordenadaY": "799.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6041,
        "colorId": 0,
        "numero": "47-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1652.09",
        "coordenadaY": "801.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6042,
        "colorId": 0,
        "numero": "48-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1672.41",
        "coordenadaY": "804.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6043,
        "colorId": 0,
        "numero": "49-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1696.42",
        "coordenadaY": "806.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6044,
        "colorId": 0,
        "numero": "50-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1720.42",
        "coordenadaY": "809.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6045,
        "colorId": 0,
        "numero": "51-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1744.43",
        "coordenadaY": "812.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6046,
        "colorId": 0,
        "numero": "52-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1768.44",
        "coordenadaY": "815.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6047,
        "colorId": 0,
        "numero": "53-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1791.53",
        "coordenadaY": "817.88",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6048,
        "colorId": 0,
        "numero": "54-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1909.29",
        "coordenadaY": "842.022",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6049,
        "colorId": 0,
        "numero": "55-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1930.53",
        "coordenadaY": "846.639",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6050,
        "colorId": 0,
        "numero": "56-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1952.69",
        "coordenadaY": "852.179",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6051,
        "colorId": 0,
        "numero": "57-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1978.54",
        "coordenadaY": "856.796",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6052,
        "colorId": 0,
        "numero": "58-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1999.78",
        "coordenadaY": "862.337",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6053,
        "colorId": 0,
        "numero": "59-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2022.87",
        "coordenadaY": "868.802",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6054,
        "colorId": 0,
        "numero": "60-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2045.95",
        "coordenadaY": "874.341",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6055,
        "colorId": 0,
        "numero": "61-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2068.11",
        "coordenadaY": "879.882",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6056,
        "colorId": 0,
        "numero": "62-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2091.2",
        "coordenadaY": "885.423",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6057,
        "colorId": 0,
        "numero": "63-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2114.29",
        "coordenadaY": "891.886",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6058,
        "colorId": 0,
        "numero": "64-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2136.45",
        "coordenadaY": "898.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6059,
        "colorId": 0,
        "numero": "65-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2158.61",
        "coordenadaY": "905.737",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6060,
        "colorId": 0,
        "numero": "66-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2180.77",
        "coordenadaY": "912.202",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6061,
        "colorId": 0,
        "numero": "67-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2203.86",
        "coordenadaY": "918.665",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6062,
        "colorId": 0,
        "numero": "68-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2226.02",
        "coordenadaY": "925.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6063,
        "colorId": 0,
        "numero": "69-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2247.26",
        "coordenadaY": "933.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6064,
        "colorId": 0,
        "numero": "70-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2270.34",
        "coordenadaY": "940.827",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6065,
        "colorId": 0,
        "numero": "71-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2291.58",
        "coordenadaY": "948.214",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6066,
        "colorId": 0,
        "numero": "72-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2313.74",
        "coordenadaY": "955.602",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6067,
        "colorId": 0,
        "numero": "73-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2335.9",
        "coordenadaY": "963.913",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6068,
        "colorId": 0,
        "numero": "74-H",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "H",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2357.14",
        "coordenadaY": "972.223",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6069,
        "colorId": 0,
        "numero": "01-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "329.546",
        "coordenadaY": "923.491",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6070,
        "colorId": 0,
        "numero": "02-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "352.632",
        "coordenadaY": "914.258",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6071,
        "colorId": 0,
        "numero": "03-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "375.717",
        "coordenadaY": "905.946",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6072,
        "colorId": 0,
        "numero": "04-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "398.802",
        "coordenadaY": "897.635",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6073,
        "colorId": 0,
        "numero": "05-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "420.964",
        "coordenadaY": "890.249",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6074,
        "colorId": 0,
        "numero": "06-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "444.049",
        "coordenadaY": "882.862",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6075,
        "colorId": 0,
        "numero": "07-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "467.135",
        "coordenadaY": "875.475",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6076,
        "colorId": 0,
        "numero": "08-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "490.22",
        "coordenadaY": "869.934",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6077,
        "colorId": 0,
        "numero": "09-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "513.305",
        "coordenadaY": "862.547",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6078,
        "colorId": 0,
        "numero": "10-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "536.391",
        "coordenadaY": "855.159",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6079,
        "colorId": 0,
        "numero": "11-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "559.476",
        "coordenadaY": "848.696",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6080,
        "colorId": 0,
        "numero": "12-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "581.638",
        "coordenadaY": "843.155",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6081,
        "colorId": 0,
        "numero": "13-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "604.723",
        "coordenadaY": "837.614",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6082,
        "colorId": 0,
        "numero": "14-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "627.808",
        "coordenadaY": "830.227",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6083,
        "colorId": 0,
        "numero": "15-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "650.894",
        "coordenadaY": "825.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6084,
        "colorId": 0,
        "numero": "16-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "673.979",
        "coordenadaY": "820.069",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6085,
        "colorId": 0,
        "numero": "17-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "697.064",
        "coordenadaY": "814.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6086,
        "colorId": 0,
        "numero": "18-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "720.149",
        "coordenadaY": "808.989",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6087,
        "colorId": 0,
        "numero": "19-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "743.235",
        "coordenadaY": "804.372",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6088,
        "colorId": 0,
        "numero": "20-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "765.396",
        "coordenadaY": "799.754",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6089,
        "colorId": 0,
        "numero": "21-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "788.482",
        "coordenadaY": "795.137",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6090,
        "colorId": 0,
        "numero": "22-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "918.14",
        "coordenadaY": "765.09",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6091,
        "colorId": 0,
        "numero": "23-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "943.07",
        "coordenadaY": "761.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6092,
        "colorId": 0,
        "numero": "24-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "966.16",
        "coordenadaY": "758.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6093,
        "colorId": 0,
        "numero": "25-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "989.24",
        "coordenadaY": "754.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6094,
        "colorId": 0,
        "numero": "26-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1014.18",
        "coordenadaY": "752.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6095,
        "colorId": 0,
        "numero": "27-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1038.18",
        "coordenadaY": "749.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6096,
        "colorId": 0,
        "numero": "28-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1061.27",
        "coordenadaY": "746.62",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6097,
        "colorId": 0,
        "numero": "29-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1085.28",
        "coordenadaY": "744.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6098,
        "colorId": 0,
        "numero": "30-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1108.36",
        "coordenadaY": "742.01",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6099,
        "colorId": 0,
        "numero": "31-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1130.52",
        "coordenadaY": "741.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6100,
        "colorId": 0,
        "numero": "32-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1154.53",
        "coordenadaY": "739.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6101,
        "colorId": 0,
        "numero": "33-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1179.47",
        "coordenadaY": "737.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6102,
        "colorId": 0,
        "numero": "34-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1202.55",
        "coordenadaY": "736.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6103,
        "colorId": 0,
        "numero": "35-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1224.71",
        "coordenadaY": "736.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6104,
        "colorId": 0,
        "numero": "36-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1249.64",
        "coordenadaY": "735.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6105,
        "colorId": 0,
        "numero": "37-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1273.65",
        "coordenadaY": "734.62",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6106,
        "colorId": 0,
        "numero": "38-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1441.72",
        "coordenadaY": "733.70",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6107,
        "colorId": 0,
        "numero": "39-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1466.65",
        "coordenadaY": "733.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6108,
        "colorId": 0,
        "numero": "40-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1491.58",
        "coordenadaY": "735.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6109,
        "colorId": 0,
        "numero": "41-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1514.66",
        "coordenadaY": "736.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6110,
        "colorId": 0,
        "numero": "42-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1536.83",
        "coordenadaY": "738.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6111,
        "colorId": 0,
        "numero": "43-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1561.76",
        "coordenadaY": "741.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6112,
        "colorId": 0,
        "numero": "44-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1585.77",
        "coordenadaY": "742.93",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6113,
        "colorId": 0,
        "numero": "45-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1608.85",
        "coordenadaY": "743.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6114,
        "colorId": 0,
        "numero": "46-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1632.86",
        "coordenadaY": "745.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6115,
        "colorId": 0,
        "numero": "47-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1654.10",
        "coordenadaY": "747.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6116,
        "colorId": 0,
        "numero": "48-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1679.95",
        "coordenadaY": "750.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6117,
        "colorId": 0,
        "numero": "49-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1703.04",
        "coordenadaY": "753.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6118,
        "colorId": 0,
        "numero": "50-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1727.05",
        "coordenadaY": "756.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6119,
        "colorId": 0,
        "numero": "51-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1750.13",
        "coordenadaY": "759.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6120,
        "colorId": 0,
        "numero": "52-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1774.14",
        "coordenadaY": "763.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6121,
        "colorId": 0,
        "numero": "53-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1797.23",
        "coordenadaY": "766.02",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6122,
        "colorId": 0,
        "numero": "54-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2006.98",
        "coordenadaY": "812.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6123,
        "colorId": 0,
        "numero": "55-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1960.67",
        "coordenadaY": "801.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6124,
        "colorId": 0,
        "numero": "56-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1937.52",
        "coordenadaY": "796.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6125,
        "colorId": 0,
        "numero": "57-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1915.30",
        "coordenadaY": "791.68",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6126,
        "colorId": 0,
        "numero": "58-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "1984.75",
        "coordenadaY": "807.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6127,
        "colorId": 0,
        "numero": "59-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2031.98",
        "coordenadaY": "818.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6128,
        "colorId": 0,
        "numero": "60-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2055.13",
        "coordenadaY": "824.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6129,
        "colorId": 0,
        "numero": "61-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2077.35",
        "coordenadaY": "830.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6130,
        "colorId": 0,
        "numero": "62-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2101.43",
        "coordenadaY": "836.01",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6131,
        "colorId": 0,
        "numero": "63-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2124.58",
        "coordenadaY": "841.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6132,
        "colorId": 0,
        "numero": "64-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2146.81",
        "coordenadaY": "848.01",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6133,
        "colorId": 0,
        "numero": "65-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2169.96",
        "coordenadaY": "854.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6134,
        "colorId": 0,
        "numero": "66-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2193.11",
        "coordenadaY": "860.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6135,
        "colorId": 0,
        "numero": "67-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2216.26",
        "coordenadaY": "867.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6136,
        "colorId": 0,
        "numero": "68-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2238.49",
        "coordenadaY": "874.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6137,
        "colorId": 0,
        "numero": "69-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2260.71",
        "coordenadaY": "882.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6138,
        "colorId": 0,
        "numero": "70-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2283.86",
        "coordenadaY": "889.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6139,
        "colorId": 0,
        "numero": "71-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2307.01",
        "coordenadaY": "897.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6140,
        "colorId": 0,
        "numero": "72-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2329.24",
        "coordenadaY": "906.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6141,
        "colorId": 0,
        "numero": "73-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2351.46",
        "coordenadaY": "913.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6142,
        "colorId": 0,
        "numero": "74-I",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "I",
        "cantidadSillas": 74,
        "color": "#3C5B6F",
        "coordenadaX": "2373.69",
        "coordenadaY": "921.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6143,
        "colorId": 0,
        "numero": "01-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "315.695",
        "coordenadaY": "874.551",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6144,
        "colorId": 0,
        "numero": "02-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "337.857",
        "coordenadaY": "866.241",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6145,
        "colorId": 0,
        "numero": "03-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "360.019",
        "coordenadaY": "857.006",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6146,
        "colorId": 0,
        "numero": "04-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "382.181",
        "coordenadaY": "849.618",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6147,
        "colorId": 0,
        "numero": "05-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "404.343",
        "coordenadaY": "843.155",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6148,
        "colorId": 0,
        "numero": "06-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "426.504",
        "coordenadaY": "835.768",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6149,
        "colorId": 0,
        "numero": "07-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "448.667",
        "coordenadaY": "828.379",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6150,
        "colorId": 0,
        "numero": "08-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "470.828",
        "coordenadaY": "820.993",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6151,
        "colorId": 0,
        "numero": "09-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "492.99",
        "coordenadaY": "814.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6152,
        "colorId": 0,
        "numero": "10-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "515.152",
        "coordenadaY": "808.065",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6153,
        "colorId": 0,
        "numero": "11-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "537.314",
        "coordenadaY": "801.602",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6154,
        "colorId": 0,
        "numero": "12-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "559.476",
        "coordenadaY": "795.137",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6155,
        "colorId": 0,
        "numero": "13-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "581.638",
        "coordenadaY": "788.674",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6156,
        "colorId": 0,
        "numero": "14-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "603.799",
        "coordenadaY": "782.209",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6157,
        "colorId": 0,
        "numero": "15-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "625.961",
        "coordenadaY": "776.668",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6158,
        "colorId": 0,
        "numero": "16-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "648.123",
        "coordenadaY": "771.129",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6159,
        "colorId": 0,
        "numero": "17-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "670.285",
        "coordenadaY": "765.588",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6160,
        "colorId": 0,
        "numero": "18-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "692.447",
        "coordenadaY": "760.047",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6161,
        "colorId": 0,
        "numero": "19-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "714.609",
        "coordenadaY": "755.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6162,
        "colorId": 0,
        "numero": "20-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "736.771",
        "coordenadaY": "749.891",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6163,
        "colorId": 0,
        "numero": "21-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "758.932",
        "coordenadaY": "745.274",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6164,
        "colorId": 0,
        "numero": "22-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "781.094",
        "coordenadaY": "740.657",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6165,
        "colorId": 0,
        "numero": "23-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "915.29",
        "coordenadaY": "718.08",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6166,
        "colorId": 0,
        "numero": "24-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "937.45",
        "coordenadaY": "715.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6167,
        "colorId": 0,
        "numero": "25-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "962.38",
        "coordenadaY": "711.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6168,
        "colorId": 0,
        "numero": "26-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "986.39",
        "coordenadaY": "709.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6169,
        "colorId": 0,
        "numero": "27-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1008.55",
        "coordenadaY": "707.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6170,
        "colorId": 0,
        "numero": "28-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1031.63",
        "coordenadaY": "703.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6171,
        "colorId": 0,
        "numero": "29-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1055.64",
        "coordenadaY": "700.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6172,
        "colorId": 0,
        "numero": "30-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1078.72",
        "coordenadaY": "698.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6173,
        "colorId": 0,
        "numero": "31-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1101.81",
        "coordenadaY": "695.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6174,
        "colorId": 0,
        "numero": "32-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1125.82",
        "coordenadaY": "694.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6175,
        "colorId": 0,
        "numero": "33-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1147.98",
        "coordenadaY": "693.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6176,
        "colorId": 0,
        "numero": "34-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1172.91",
        "coordenadaY": "691.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6177,
        "colorId": 0,
        "numero": "35-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1195.07",
        "coordenadaY": "690.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6178,
        "colorId": 0,
        "numero": "36-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1219.08",
        "coordenadaY": "689.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6179,
        "colorId": 0,
        "numero": "37-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1243.09",
        "coordenadaY": "689.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6180,
        "colorId": 0,
        "numero": "38-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1265.25",
        "coordenadaY": "687.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6181,
        "colorId": 0,
        "numero": "39-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1290.19",
        "coordenadaY": "686.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6182,
        "colorId": 0,
        "numero": "40-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1313.27",
        "coordenadaY": "685.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6183,
        "colorId": 0,
        "numero": "41-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1336.36",
        "coordenadaY": "685.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6184,
        "colorId": 0,
        "numero": "42-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1359.44",
        "coordenadaY": "684.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6185,
        "colorId": 0,
        "numero": "43-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1382.53",
        "coordenadaY": "685.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6186,
        "colorId": 0,
        "numero": "44-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1405.61",
        "coordenadaY": "685.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6187,
        "colorId": 0,
        "numero": "45-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1429.62",
        "coordenadaY": "686.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6188,
        "colorId": 0,
        "numero": "46-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1451.78",
        "coordenadaY": "688.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6189,
        "colorId": 0,
        "numero": "47-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1475.79",
        "coordenadaY": "689.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6190,
        "colorId": 0,
        "numero": "48-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1500.69",
        "coordenadaY": "690.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6191,
        "colorId": 0,
        "numero": "49-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1522.89",
        "coordenadaY": "691.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6192,
        "colorId": 0,
        "numero": "50-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1546.89",
        "coordenadaY": "693.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6193,
        "colorId": 0,
        "numero": "51-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1569.06",
        "coordenadaY": "693.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6194,
        "colorId": 0,
        "numero": "52-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1593.06",
        "coordenadaY": "694.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6195,
        "colorId": 0,
        "numero": "53-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1617.07",
        "coordenadaY": "696.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6196,
        "colorId": 0,
        "numero": "54-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1640.16",
        "coordenadaY": "698.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6197,
        "colorId": 0,
        "numero": "55-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1663.24",
        "coordenadaY": "701.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6198,
        "colorId": 0,
        "numero": "56-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1687.25",
        "coordenadaY": "705.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6199,
        "colorId": 0,
        "numero": "57-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1709.41",
        "coordenadaY": "707.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6200,
        "colorId": 0,
        "numero": "58-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1734.35",
        "coordenadaY": "709.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6201,
        "colorId": 0,
        "numero": "59-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1755.58",
        "coordenadaY": "712.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6202,
        "colorId": 0,
        "numero": "60-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1780.52",
        "coordenadaY": "715.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6203,
        "colorId": 0,
        "numero": "61-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1802.68",
        "coordenadaY": "718.08",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6204,
        "colorId": 0,
        "numero": "62-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1925.35",
        "coordenadaY": "741.05",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6205,
        "colorId": 0,
        "numero": "63-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1950.76",
        "coordenadaY": "745.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6206,
        "colorId": 0,
        "numero": "64-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1973.34",
        "coordenadaY": "750.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6207,
        "colorId": 0,
        "numero": "65-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "1997.81",
        "coordenadaY": "755.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6208,
        "colorId": 0,
        "numero": "66-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2020.40",
        "coordenadaY": "760.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6209,
        "colorId": 0,
        "numero": "67-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2044.86",
        "coordenadaY": "766.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6210,
        "colorId": 0,
        "numero": "68-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2067.45",
        "coordenadaY": "772.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6211,
        "colorId": 0,
        "numero": "69-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2091.92",
        "coordenadaY": "778.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6212,
        "colorId": 0,
        "numero": "70-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2114.50",
        "coordenadaY": "784.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6213,
        "colorId": 0,
        "numero": "71-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2138.97",
        "coordenadaY": "789.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6214,
        "colorId": 0,
        "numero": "72-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2160.62",
        "coordenadaY": "798.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6215,
        "colorId": 0,
        "numero": "73-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2184.14",
        "coordenadaY": "803.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6216,
        "colorId": 0,
        "numero": "74-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2207.67",
        "coordenadaY": "810.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6217,
        "colorId": 0,
        "numero": "75-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2230.26",
        "coordenadaY": "818.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6218,
        "colorId": 0,
        "numero": "76-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2253.78",
        "coordenadaY": "825.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6219,
        "colorId": 0,
        "numero": "77-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2276.37",
        "coordenadaY": "831.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6220,
        "colorId": 0,
        "numero": "78-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2300.33",
        "coordenadaY": "840.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6221,
        "colorId": 0,
        "numero": "79-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2323.86",
        "coordenadaY": "848.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6222,
        "colorId": 0,
        "numero": "80-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2345.07",
        "coordenadaY": "854.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6223,
        "colorId": 0,
        "numero": "81-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2367.65",
        "coordenadaY": "863.86",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6224,
        "colorId": 0,
        "numero": "82-J",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "J",
        "cantidadSillas": 81,
        "color": "#3C5B6F",
        "coordenadaX": "2390.24",
        "coordenadaY": "872.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6225,
        "colorId": 0,
        "numero": "01-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "299.997",
        "coordenadaY": "826.534",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6226,
        "colorId": 0,
        "numero": "02-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "322.159",
        "coordenadaY": "818.223",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6227,
        "colorId": 0,
        "numero": "03-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "344.321",
        "coordenadaY": "809.913",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6228,
        "colorId": 0,
        "numero": "04-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "366.483",
        "coordenadaY": "801.602",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6229,
        "colorId": 0,
        "numero": "05-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "388.645",
        "coordenadaY": "794.213",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6230,
        "colorId": 0,
        "numero": "06-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "410.807",
        "coordenadaY": "787.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6231,
        "colorId": 0,
        "numero": "07-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "432.968",
        "coordenadaY": "779.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6232,
        "colorId": 0,
        "numero": "08-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "455.13",
        "coordenadaY": "773.899",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6233,
        "colorId": 0,
        "numero": "09-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "477.292",
        "coordenadaY": "766.512",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6234,
        "colorId": 0,
        "numero": "10-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "499.454",
        "coordenadaY": "760.047",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6235,
        "colorId": 0,
        "numero": "11-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "521.616",
        "coordenadaY": "753.584",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6236,
        "colorId": 0,
        "numero": "12-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "543.778",
        "coordenadaY": "747.12",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6237,
        "colorId": 0,
        "numero": "13-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "565.939",
        "coordenadaY": "740.657",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6238,
        "colorId": 0,
        "numero": "14-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "588.102",
        "coordenadaY": "734.192",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6239,
        "colorId": 0,
        "numero": "15-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "610.263",
        "coordenadaY": "728.651",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6240,
        "colorId": 0,
        "numero": "16-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "632.425",
        "coordenadaY": "723.112",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6241,
        "colorId": 0,
        "numero": "17-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "654.587",
        "coordenadaY": "718.495",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6242,
        "colorId": 0,
        "numero": "18-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "676.749",
        "coordenadaY": "712.954",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6243,
        "colorId": 0,
        "numero": "19-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "698.911",
        "coordenadaY": "708.336",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6244,
        "colorId": 0,
        "numero": "20-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "721.073",
        "coordenadaY": "702.795",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6245,
        "colorId": 0,
        "numero": "21-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "743.235",
        "coordenadaY": "698.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6246,
        "colorId": 0,
        "numero": "22-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "765.396",
        "coordenadaY": "693.563",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6247,
        "colorId": 0,
        "numero": "23-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "894.48",
        "coordenadaY": "668.00",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6248,
        "colorId": 0,
        "numero": "24-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "917.54",
        "coordenadaY": "664.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6249,
        "colorId": 0,
        "numero": "25-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "941.53",
        "coordenadaY": "661.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6250,
        "colorId": 0,
        "numero": "26-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "964.60",
        "coordenadaY": "657.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6251,
        "colorId": 0,
        "numero": "27-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "987.67",
        "coordenadaY": "654.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6252,
        "colorId": 0,
        "numero": "28-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1011.67",
        "coordenadaY": "652.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6253,
        "colorId": 0,
        "numero": "29-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1036.58",
        "coordenadaY": "648.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6254,
        "colorId": 0,
        "numero": "30-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1058.73",
        "coordenadaY": "646.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6255,
        "colorId": 0,
        "numero": "31-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1082.73",
        "coordenadaY": "644.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6256,
        "colorId": 0,
        "numero": "32-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1106.73",
        "coordenadaY": "643.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6257,
        "colorId": 0,
        "numero": "33-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1128.88",
        "coordenadaY": "640.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6258,
        "colorId": 0,
        "numero": "34-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1153.81",
        "coordenadaY": "639.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6259,
        "colorId": 0,
        "numero": "35-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1175.96",
        "coordenadaY": "637.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6260,
        "colorId": 0,
        "numero": "36-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1199.96",
        "coordenadaY": "636.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6261,
        "colorId": 0,
        "numero": "37-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1223.96",
        "coordenadaY": "635.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6262,
        "colorId": 0,
        "numero": "38-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1247.97",
        "coordenadaY": "634.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6263,
        "colorId": 0,
        "numero": "39-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1271.97",
        "coordenadaY": "633.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6264,
        "colorId": 0,
        "numero": "40-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1295.06",
        "coordenadaY": "633.51",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6265,
        "colorId": 0,
        "numero": "41-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1319.06",
        "coordenadaY": "632.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6266,
        "colorId": 0,
        "numero": "42-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1343.07",
        "coordenadaY": "632.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6267,
        "colorId": 0,
        "numero": "43-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1366.15",
        "coordenadaY": "632.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6268,
        "colorId": 0,
        "numero": "44-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1388.31",
        "coordenadaY": "632.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6269,
        "colorId": 0,
        "numero": "45-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1413.25",
        "coordenadaY": "631.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6270,
        "colorId": 0,
        "numero": "46-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1437.26",
        "coordenadaY": "632.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6271,
        "colorId": 0,
        "numero": "47-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1459.43",
        "coordenadaY": "634.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6272,
        "colorId": 0,
        "numero": "48-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1483.44",
        "coordenadaY": "635.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6273,
        "colorId": 0,
        "numero": "49-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1507.46",
        "coordenadaY": "636.97",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6274,
        "colorId": 0,
        "numero": "50-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1530.55",
        "coordenadaY": "637.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6275,
        "colorId": 0,
        "numero": "51-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1554.57",
        "coordenadaY": "639.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6276,
        "colorId": 0,
        "numero": "52-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1577.67",
        "coordenadaY": "641.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6277,
        "colorId": 0,
        "numero": "53-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1600.76",
        "coordenadaY": "642.93",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6278,
        "colorId": 0,
        "numero": "54-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1624.78",
        "coordenadaY": "644.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6279,
        "colorId": 0,
        "numero": "55-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1648.80",
        "coordenadaY": "647.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6280,
        "colorId": 0,
        "numero": "56-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1670.98",
        "coordenadaY": "649.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6281,
        "colorId": 0,
        "numero": "57-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1695.00",
        "coordenadaY": "651.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6282,
        "colorId": 0,
        "numero": "58-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1718.10",
        "coordenadaY": "655.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6283,
        "colorId": 0,
        "numero": "59-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1741.20",
        "coordenadaY": "657.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6284,
        "colorId": 0,
        "numero": "60-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1765.23",
        "coordenadaY": "661.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6285,
        "colorId": 0,
        "numero": "61-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1789.25",
        "coordenadaY": "664.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6286,
        "colorId": 0,
        "numero": "62-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1810.94",
        "coordenadaY": "668.57",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6287,
        "colorId": 0,
        "numero": "63-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1979.47",
        "coordenadaY": "702.587",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6288,
        "colorId": 0,
        "numero": "64-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1957.31",
        "coordenadaY": "698.893",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6289,
        "colorId": 0,
        "numero": "65-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1934.22",
        "coordenadaY": "693.352",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6290,
        "colorId": 0,
        "numero": "66-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2025.64",
        "coordenadaY": "713.667",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6291,
        "colorId": 0,
        "numero": "67-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2002.55",
        "coordenadaY": "708.128",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6292,
        "colorId": 0,
        "numero": "68-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2051.49",
        "coordenadaY": "719.208",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6293,
        "colorId": 0,
        "numero": "69-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2071.81",
        "coordenadaY": "723.825",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6294,
        "colorId": 0,
        "numero": "70-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2093.97",
        "coordenadaY": "730.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6295,
        "colorId": 0,
        "numero": "71-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2117.06",
        "coordenadaY": "735.829",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6296,
        "colorId": 0,
        "numero": "72-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2139.22",
        "coordenadaY": "742.294",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6297,
        "colorId": 0,
        "numero": "73-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2161.38",
        "coordenadaY": "747.835",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6298,
        "colorId": 0,
        "numero": "74-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2184.47",
        "coordenadaY": "754.298",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6299,
        "colorId": 0,
        "numero": "75-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2206.63",
        "coordenadaY": "760.763",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6300,
        "colorId": 0,
        "numero": "76-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2228.79",
        "coordenadaY": "768.149",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6301,
        "colorId": 0,
        "numero": "77-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2250.95",
        "coordenadaY": "774.612",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6302,
        "colorId": 0,
        "numero": "78-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2272.19",
        "coordenadaY": "782.923",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6303,
        "colorId": 0,
        "numero": "79-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2295.27",
        "coordenadaY": "789.388",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6304,
        "colorId": 0,
        "numero": "80-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2317.44",
        "coordenadaY": "795.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6305,
        "colorId": 0,
        "numero": "81-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2339.6",
        "coordenadaY": "804.163",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6306,
        "colorId": 0,
        "numero": "82-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2360.84",
        "coordenadaY": "812.473",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6307,
        "colorId": 0,
        "numero": "83-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2383",
        "coordenadaY": "820.784",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6308,
        "colorId": 0,
        "numero": "84-K",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "K",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2404.24",
        "coordenadaY": "828.171",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0,
        "precioDolarNinos": 59
    },
    {
        "sillaId": 6309,
        "colorId": 0,
        "numero": "01-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "284.299",
        "coordenadaY": "779.44",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6310,
        "colorId": 0,
        "numero": "02-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "307.384",
        "coordenadaY": "771.129",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6311,
        "colorId": 0,
        "numero": "03-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "329.546",
        "coordenadaY": "762.819",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6312,
        "colorId": 0,
        "numero": "04-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "352.632",
        "coordenadaY": "754.506",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6313,
        "colorId": 0,
        "numero": "05-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "375.717",
        "coordenadaY": "747.12",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6314,
        "colorId": 0,
        "numero": "06-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "397.879",
        "coordenadaY": "740.657",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6315,
        "colorId": 0,
        "numero": "07-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "420.964",
        "coordenadaY": "732.346",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6316,
        "colorId": 0,
        "numero": "08-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "443.126",
        "coordenadaY": "725.881",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6317,
        "colorId": 0,
        "numero": "09-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "466.211",
        "coordenadaY": "718.495",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6318,
        "colorId": 0,
        "numero": "10-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "489.296",
        "coordenadaY": "712.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6319,
        "colorId": 0,
        "numero": "11-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "511.459",
        "coordenadaY": "705.567",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6320,
        "colorId": 0,
        "numero": "12-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "534.543",
        "coordenadaY": "699.102",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6321,
        "colorId": 0,
        "numero": "13-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "557.629",
        "coordenadaY": "692.639",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6322,
        "colorId": 0,
        "numero": "14-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "579.791",
        "coordenadaY": "687.098",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6323,
        "colorId": 0,
        "numero": "15-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "602.876",
        "coordenadaY": "680.635",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6324,
        "colorId": 0,
        "numero": "16-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "625.961",
        "coordenadaY": "675.094",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6325,
        "colorId": 0,
        "numero": "17-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "648.123",
        "coordenadaY": "669.553",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6326,
        "colorId": 0,
        "numero": "18-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "671.208",
        "coordenadaY": "664.012",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6327,
        "colorId": 0,
        "numero": "19-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "694.293",
        "coordenadaY": "658.473",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6328,
        "colorId": 0,
        "numero": "20-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "716.456",
        "coordenadaY": "653.856",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6329,
        "colorId": 0,
        "numero": "21-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "739.541",
        "coordenadaY": "648.315",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6330,
        "colorId": 0,
        "numero": "22-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "761.703",
        "coordenadaY": "643.698",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6331,
        "colorId": 0,
        "numero": "23-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "889.78",
        "coordenadaY": "611.96",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6332,
        "colorId": 0,
        "numero": "24-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "913.79",
        "coordenadaY": "608.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6333,
        "colorId": 0,
        "numero": "25-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "936.87",
        "coordenadaY": "605.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6334,
        "colorId": 0,
        "numero": "26-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "959.96",
        "coordenadaY": "602.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6335,
        "colorId": 0,
        "numero": "27-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "983.04",
        "coordenadaY": "599.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6336,
        "colorId": 0,
        "numero": "28-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1006.13",
        "coordenadaY": "597.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6337,
        "colorId": 0,
        "numero": "29-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1030.14",
        "coordenadaY": "595.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6338,
        "colorId": 0,
        "numero": "30-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1053.22",
        "coordenadaY": "593.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6339,
        "colorId": 0,
        "numero": "31-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1076.31",
        "coordenadaY": "590.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6340,
        "colorId": 0,
        "numero": "32-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1100.32",
        "coordenadaY": "587.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6341,
        "colorId": 0,
        "numero": "33-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1123.40",
        "coordenadaY": "587.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6342,
        "colorId": 0,
        "numero": "34-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1146.49",
        "coordenadaY": "585.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6343,
        "colorId": 0,
        "numero": "35-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1170.50",
        "coordenadaY": "584.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6344,
        "colorId": 0,
        "numero": "36-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1193.58",
        "coordenadaY": "583.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6345,
        "colorId": 0,
        "numero": "37-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1217.59",
        "coordenadaY": "582.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6346,
        "colorId": 0,
        "numero": "38-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1239.75",
        "coordenadaY": "581.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6347,
        "colorId": 0,
        "numero": "39-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1263.76",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6348,
        "colorId": 0,
        "numero": "40-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1287.77",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6349,
        "colorId": 0,
        "numero": "41-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1309.93",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6350,
        "colorId": 0,
        "numero": "42-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1333.94",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6351,
        "colorId": 0,
        "numero": "43-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1358.87",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6352,
        "colorId": 0,
        "numero": "44-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1382.88",
        "coordenadaY": "579.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6353,
        "colorId": 0,
        "numero": "45-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1407.81",
        "coordenadaY": "580.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6354,
        "colorId": 0,
        "numero": "46-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1431.82",
        "coordenadaY": "580.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6355,
        "colorId": 0,
        "numero": "47-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1455.83",
        "coordenadaY": "582.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6356,
        "colorId": 0,
        "numero": "48-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1479.81",
        "coordenadaY": "583.366",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6357,
        "colorId": 0,
        "numero": "49-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1503.85",
        "coordenadaY": "584.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6358,
        "colorId": 0,
        "numero": "50-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1527.86",
        "coordenadaY": "585.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6359,
        "colorId": 0,
        "numero": "51-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1551.87",
        "coordenadaY": "587.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6360,
        "colorId": 0,
        "numero": "52-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1575.88",
        "coordenadaY": "587.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6361,
        "colorId": 0,
        "numero": "53-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1599.88",
        "coordenadaY": "590.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6362,
        "colorId": 0,
        "numero": "54-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1623.89",
        "coordenadaY": "593.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6363,
        "colorId": 0,
        "numero": "55-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1648.82",
        "coordenadaY": "595.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6364,
        "colorId": 0,
        "numero": "56-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1672.83",
        "coordenadaY": "598.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6365,
        "colorId": 0,
        "numero": "57-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1696.84",
        "coordenadaY": "599.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6366,
        "colorId": 0,
        "numero": "58-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1720.85",
        "coordenadaY": "602.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6367,
        "colorId": 0,
        "numero": "59-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1745.78",
        "coordenadaY": "606.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6368,
        "colorId": 0,
        "numero": "60-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1768.87",
        "coordenadaY": "609.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6369,
        "colorId": 0,
        "numero": "61-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1792.88",
        "coordenadaY": "612.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6370,
        "colorId": 0,
        "numero": "62-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1815.47",
        "coordenadaY": "617.50",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6371,
        "colorId": 0,
        "numero": "63-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1943.98",
        "coordenadaY": "639.82",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6372,
        "colorId": 0,
        "numero": "64-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1965.17",
        "coordenadaY": "644.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6373,
        "colorId": 0,
        "numero": "65-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "1987.24",
        "coordenadaY": "648.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6374,
        "colorId": 0,
        "numero": "66-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2010.19",
        "coordenadaY": "653.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6375,
        "colorId": 0,
        "numero": "67-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2031.38",
        "coordenadaY": "659.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6376,
        "colorId": 0,
        "numero": "68-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2055.22",
        "coordenadaY": "663.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6377,
        "colorId": 0,
        "numero": "69-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2075.53",
        "coordenadaY": "669.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6378,
        "colorId": 0,
        "numero": "70-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2099.37",
        "coordenadaY": "675.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6379,
        "colorId": 0,
        "numero": "71-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2121.44",
        "coordenadaY": "680.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6380,
        "colorId": 0,
        "numero": "72-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2142.63",
        "coordenadaY": "685.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6381,
        "colorId": 0,
        "numero": "73-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2164.71",
        "coordenadaY": "693.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6382,
        "colorId": 0,
        "numero": "74-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2185.89",
        "coordenadaY": "698.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6383,
        "colorId": 0,
        "numero": "75-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2207.97",
        "coordenadaY": "705.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6384,
        "colorId": 0,
        "numero": "76-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2230.04",
        "coordenadaY": "711.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6385,
        "colorId": 0,
        "numero": "77-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2251.23",
        "coordenadaY": "718.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6386,
        "colorId": 0,
        "numero": "78-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2272.42",
        "coordenadaY": "725.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6387,
        "colorId": 0,
        "numero": "79-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2294.49",
        "coordenadaY": "731.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6388,
        "colorId": 0,
        "numero": "80-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2315.68",
        "coordenadaY": "739.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6389,
        "colorId": 0,
        "numero": "81-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2336.87",
        "coordenadaY": "747.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6390,
        "colorId": 0,
        "numero": "82-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2358.06",
        "coordenadaY": "755.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6391,
        "colorId": 0,
        "numero": "83-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2379.25",
        "coordenadaY": "762.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6392,
        "colorId": 0,
        "numero": "84-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2401.33",
        "coordenadaY": "769.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6393,
        "colorId": 0,
        "numero": "85-L",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "L",
        "cantidadSillas": 83,
        "color": "#3C5B6F",
        "coordenadaX": "2422.04",
        "coordenadaY": "780.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6394,
        "colorId": 0,
        "numero": "01-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "266.754",
        "coordenadaY": "732.346",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6395,
        "colorId": 0,
        "numero": "02-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "287.993",
        "coordenadaY": "724.036",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6396,
        "colorId": 0,
        "numero": "03-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "310.155",
        "coordenadaY": "714.801",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6397,
        "colorId": 0,
        "numero": "04-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "332.316",
        "coordenadaY": "706.491",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6398,
        "colorId": 0,
        "numero": "05-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "354.479",
        "coordenadaY": "699.102",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6399,
        "colorId": 0,
        "numero": "06-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "376.64",
        "coordenadaY": "692.639",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6400,
        "colorId": 0,
        "numero": "07-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "398.802",
        "coordenadaY": "684.329",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6401,
        "colorId": 0,
        "numero": "08-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "420.964",
        "coordenadaY": "677.864",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6402,
        "colorId": 0,
        "numero": "09-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "443.126",
        "coordenadaY": "670.477",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6403,
        "colorId": 0,
        "numero": "10-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "465.288",
        "coordenadaY": "663.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6404,
        "colorId": 0,
        "numero": "11-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "487.45",
        "coordenadaY": "656.625",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6405,
        "colorId": 0,
        "numero": "12-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "509.611",
        "coordenadaY": "651.084",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6406,
        "colorId": 0,
        "numero": "13-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "531.773",
        "coordenadaY": "644.622",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6407,
        "colorId": 0,
        "numero": "14-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "553.935",
        "coordenadaY": "639.081",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6408,
        "colorId": 0,
        "numero": "15-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "576.097",
        "coordenadaY": "632.618",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6409,
        "colorId": 0,
        "numero": "16-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "598.259",
        "coordenadaY": "627.077",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6410,
        "colorId": 0,
        "numero": "17-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "620.421",
        "coordenadaY": "621.536",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6411,
        "colorId": 0,
        "numero": "18-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "642.583",
        "coordenadaY": "615.997",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6412,
        "colorId": 0,
        "numero": "19-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "664.745",
        "coordenadaY": "611.379",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6413,
        "colorId": 0,
        "numero": "20-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "686.906",
        "coordenadaY": "605.838",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6414,
        "colorId": 0,
        "numero": "21-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "709.068",
        "coordenadaY": "601.221",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6415,
        "colorId": 0,
        "numero": "22-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "731.23",
        "coordenadaY": "597.528",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6416,
        "colorId": 0,
        "numero": "23-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "753.392",
        "coordenadaY": "592.911",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6417,
        "colorId": 0,
        "numero": "24-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "883.22",
        "coordenadaY": "566.81",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6418,
        "colorId": 0,
        "numero": "25-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "904.46",
        "coordenadaY": "563.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6419,
        "colorId": 0,
        "numero": "26-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "929.39",
        "coordenadaY": "560.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6420,
        "colorId": 0,
        "numero": "27-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "952.48",
        "coordenadaY": "556.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6421,
        "colorId": 0,
        "numero": "28-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "975.56",
        "coordenadaY": "552.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6422,
        "colorId": 0,
        "numero": "29-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "999.57",
        "coordenadaY": "552.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6423,
        "colorId": 0,
        "numero": "30-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1022.66",
        "coordenadaY": "549.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6424,
        "colorId": 0,
        "numero": "31-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1045.75",
        "coordenadaY": "546.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6425,
        "colorId": 0,
        "numero": "32-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1068.83",
        "coordenadaY": "544.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6426,
        "colorId": 0,
        "numero": "33-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1090.99",
        "coordenadaY": "541.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6427,
        "colorId": 0,
        "numero": "34-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1115.00",
        "coordenadaY": "540.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6428,
        "colorId": 0,
        "numero": "35-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1139.01",
        "coordenadaY": "539.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6429,
        "colorId": 0,
        "numero": "36-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1163.02",
        "coordenadaY": "537.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6430,
        "colorId": 0,
        "numero": "37-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1187.03",
        "coordenadaY": "536.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6431,
        "colorId": 0,
        "numero": "38-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1210.11",
        "coordenadaY": "535.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6432,
        "colorId": 0,
        "numero": "39-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1233.20",
        "coordenadaY": "534.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6433,
        "colorId": 0,
        "numero": "40-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1257.20",
        "coordenadaY": "532.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6434,
        "colorId": 0,
        "numero": "41-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1280.29",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6435,
        "colorId": 0,
        "numero": "42-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1303.37",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6436,
        "colorId": 0,
        "numero": "43-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1326.46",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6437,
        "colorId": 0,
        "numero": "44-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1350.47",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6438,
        "colorId": 0,
        "numero": "45-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1373.55",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6439,
        "colorId": 0,
        "numero": "46-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1396.64",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6440,
        "colorId": 0,
        "numero": "47-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1419.72",
        "coordenadaY": "531.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6441,
        "colorId": 0,
        "numero": "48-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1443.73",
        "coordenadaY": "532.64",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6442,
        "colorId": 0,
        "numero": "49-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1466.82",
        "coordenadaY": "533.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6443,
        "colorId": 0,
        "numero": "50-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1490.83",
        "coordenadaY": "534.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6444,
        "colorId": 0,
        "numero": "51-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1512.99",
        "coordenadaY": "535.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6445,
        "colorId": 0,
        "numero": "52-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1537.92",
        "coordenadaY": "537.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6446,
        "colorId": 0,
        "numero": "53-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1560.08",
        "coordenadaY": "538.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6447,
        "colorId": 0,
        "numero": "54-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1584.09",
        "coordenadaY": "540.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6448,
        "colorId": 0,
        "numero": "55-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1607.18",
        "coordenadaY": "540.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6449,
        "colorId": 0,
        "numero": "56-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1629.34",
        "coordenadaY": "542.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6450,
        "colorId": 0,
        "numero": "57-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1653.35",
        "coordenadaY": "545.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6451,
        "colorId": 0,
        "numero": "58-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1675.51",
        "coordenadaY": "548.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6452,
        "colorId": 0,
        "numero": "59-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1699.52",
        "coordenadaY": "550.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6453,
        "colorId": 0,
        "numero": "60-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1721.68",
        "coordenadaY": "552.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6454,
        "colorId": 0,
        "numero": "61-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1745.69",
        "coordenadaY": "556.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6455,
        "colorId": 0,
        "numero": "62-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1767.85",
        "coordenadaY": "558.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6456,
        "colorId": 0,
        "numero": "63-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1792.78",
        "coordenadaY": "561.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6457,
        "colorId": 0,
        "numero": "64-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1815.87",
        "coordenadaY": "564.04",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6458,
        "colorId": 0,
        "numero": "65-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1951.55",
        "coordenadaY": "592.01",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6459,
        "colorId": 0,
        "numero": "66-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1974.80",
        "coordenadaY": "597.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6460,
        "colorId": 0,
        "numero": "67-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "1998.06",
        "coordenadaY": "602.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6461,
        "colorId": 0,
        "numero": "68-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2024.10",
        "coordenadaY": "607.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6462,
        "colorId": 0,
        "numero": "69-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2045.50",
        "coordenadaY": "613.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6463,
        "colorId": 0,
        "numero": "70-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2069.68",
        "coordenadaY": "617.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6464,
        "colorId": 0,
        "numero": "71-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2094.80",
        "coordenadaY": "625.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6465,
        "colorId": 0,
        "numero": "72-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2118.06",
        "coordenadaY": "630.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6466,
        "colorId": 0,
        "numero": "73-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2141.31",
        "coordenadaY": "637.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6467,
        "colorId": 0,
        "numero": "74-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2164.57",
        "coordenadaY": "642.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6468,
        "colorId": 0,
        "numero": "75-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2187.83",
        "coordenadaY": "649.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6469,
        "colorId": 0,
        "numero": "76-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2211.08",
        "coordenadaY": "655.73",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6470,
        "colorId": 0,
        "numero": "77-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2234.34",
        "coordenadaY": "662.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6471,
        "colorId": 0,
        "numero": "78-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2257.59",
        "coordenadaY": "669.58",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6472,
        "colorId": 0,
        "numero": "79-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2280.85",
        "coordenadaY": "676.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6473,
        "colorId": 0,
        "numero": "80-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2304.10",
        "coordenadaY": "683.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6474,
        "colorId": 0,
        "numero": "81-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2327.36",
        "coordenadaY": "690.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6475,
        "colorId": 0,
        "numero": "82-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2349.69",
        "coordenadaY": "699.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6476,
        "colorId": 0,
        "numero": "83-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2372.94",
        "coordenadaY": "706.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6477,
        "colorId": 0,
        "numero": "84-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2393.41",
        "coordenadaY": "713.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6478,
        "colorId": 0,
        "numero": "85-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2415.73",
        "coordenadaY": "721.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6479,
        "colorId": 0,
        "numero": "86-M",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "M",
        "cantidadSillas": 85,
        "color": "#3C5B6F",
        "coordenadaX": "2438.06",
        "coordenadaY": "730.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6480,
        "colorId": 0,
        "numero": "01-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "252.903",
        "coordenadaY": "684.33",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6481,
        "colorId": 0,
        "numero": "02-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "274.142",
        "coordenadaY": "676.019",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6482,
        "colorId": 0,
        "numero": "03-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "297.227",
        "coordenadaY": "667.709",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6483,
        "colorId": 0,
        "numero": "04-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "319.389",
        "coordenadaY": "659.396",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6484,
        "colorId": 0,
        "numero": "05-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "342.474",
        "coordenadaY": "652.009",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6485,
        "colorId": 0,
        "numero": "06-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "364.636",
        "coordenadaY": "644.623",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6486,
        "colorId": 0,
        "numero": "07-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "387.721",
        "coordenadaY": "637.236",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6487,
        "colorId": 0,
        "numero": "08-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "409.883",
        "coordenadaY": "629.847",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6488,
        "colorId": 0,
        "numero": "09-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "432.968",
        "coordenadaY": "623.384",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6489,
        "colorId": 0,
        "numero": "10-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "455.13",
        "coordenadaY": "616.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6490,
        "colorId": 0,
        "numero": "11-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "478.215",
        "coordenadaY": "610.457",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6491,
        "colorId": 0,
        "numero": "12-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "500.377",
        "coordenadaY": "603.068",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6492,
        "colorId": 0,
        "numero": "13-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "523.462",
        "coordenadaY": "597.529",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6493,
        "colorId": 0,
        "numero": "14-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "545.625",
        "coordenadaY": "591.064",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6494,
        "colorId": 0,
        "numero": "15-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "568.71",
        "coordenadaY": "585.525",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6495,
        "colorId": 0,
        "numero": "16-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "590.872",
        "coordenadaY": "579.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6496,
        "colorId": 0,
        "numero": "17-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "613.957",
        "coordenadaY": "573.519",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6497,
        "colorId": 0,
        "numero": "18-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "636.119",
        "coordenadaY": "568.902",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6498,
        "colorId": 0,
        "numero": "19-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "659.204",
        "coordenadaY": "563.363",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6499,
        "colorId": 0,
        "numero": "20-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "681.366",
        "coordenadaY": "557.822",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6500,
        "colorId": 0,
        "numero": "21-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "704.452",
        "coordenadaY": "553.205",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6501,
        "colorId": 0,
        "numero": "22-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "726.613",
        "coordenadaY": "548.588",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6502,
        "colorId": 0,
        "numero": "23-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "749.699",
        "coordenadaY": "543.97",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6503,
        "colorId": 0,
        "numero": "24-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "876.72",
        "coordenadaY": "525.37",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6504,
        "colorId": 0,
        "numero": "25-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "900.19",
        "coordenadaY": "521.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6505,
        "colorId": 0,
        "numero": "26-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "922.76",
        "coordenadaY": "517.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6506,
        "colorId": 0,
        "numero": "27-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "945.33",
        "coordenadaY": "513.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6507,
        "colorId": 0,
        "numero": "28-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "967.92",
        "coordenadaY": "511.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6508,
        "colorId": 0,
        "numero": "29-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "991.40",
        "coordenadaY": "508.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6509,
        "colorId": 0,
        "numero": "30-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1013.98",
        "coordenadaY": "505.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6510,
        "colorId": 0,
        "numero": "31-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1036.57",
        "coordenadaY": "503.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6511,
        "colorId": 0,
        "numero": "32-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1059.15",
        "coordenadaY": "500.09",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6512,
        "colorId": 0,
        "numero": "33-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1082.63",
        "coordenadaY": "497.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6513,
        "colorId": 0,
        "numero": "34-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1105.22",
        "coordenadaY": "494.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6514,
        "colorId": 0,
        "numero": "35-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1127.82",
        "coordenadaY": "493.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6515,
        "colorId": 0,
        "numero": "36-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1151.32",
        "coordenadaY": "491.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6516,
        "colorId": 0,
        "numero": "37-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1173.01",
        "coordenadaY": "490.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6517,
        "colorId": 0,
        "numero": "38-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1196.52",
        "coordenadaY": "489.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6518,
        "colorId": 0,
        "numero": "39-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1220.02",
        "coordenadaY": "487.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6519,
        "colorId": 0,
        "numero": "40-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1242.62",
        "coordenadaY": "486.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6520,
        "colorId": 0,
        "numero": "41-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1266.13",
        "coordenadaY": "485.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6521,
        "colorId": 0,
        "numero": "42-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1289.65",
        "coordenadaY": "485.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6522,
        "colorId": 0,
        "numero": "43-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1311.35",
        "coordenadaY": "485.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6523,
        "colorId": 0,
        "numero": "44-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1334.86",
        "coordenadaY": "483.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6524,
        "colorId": 0,
        "numero": "45-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1359.28",
        "coordenadaY": "483.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6525,
        "colorId": 0,
        "numero": "46-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1381.90",
        "coordenadaY": "484.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6526,
        "colorId": 0,
        "numero": "47-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1403.61",
        "coordenadaY": "483.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6527,
        "colorId": 0,
        "numero": "48-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1427.14",
        "coordenadaY": "484.58",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6528,
        "colorId": 0,
        "numero": "49-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1451.57",
        "coordenadaY": "485.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6529,
        "colorId": 0,
        "numero": "50-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1474.19",
        "coordenadaY": "485.86",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6530,
        "colorId": 0,
        "numero": "51-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1496.81",
        "coordenadaY": "486.51",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6531,
        "colorId": 0,
        "numero": "52-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1520.35",
        "coordenadaY": "488.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6532,
        "colorId": 0,
        "numero": "53-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1543.88",
        "coordenadaY": "488.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6533,
        "colorId": 0,
        "numero": "54-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1565.61",
        "coordenadaY": "490.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6534,
        "colorId": 0,
        "numero": "55-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1589.15",
        "coordenadaY": "491.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6535,
        "colorId": 0,
        "numero": "56-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1612.69",
        "coordenadaY": "493.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6536,
        "colorId": 0,
        "numero": "57-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1635.32",
        "coordenadaY": "495.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6537,
        "colorId": 0,
        "numero": "58-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1658.87",
        "coordenadaY": "497.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6538,
        "colorId": 0,
        "numero": "59-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1681.51",
        "coordenadaY": "499.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6539,
        "colorId": 0,
        "numero": "60-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1704.16",
        "coordenadaY": "502.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6540,
        "colorId": 0,
        "numero": "61-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1727.71",
        "coordenadaY": "504.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6541,
        "colorId": 0,
        "numero": "62-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1749.46",
        "coordenadaY": "508.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6542,
        "colorId": 0,
        "numero": "63-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1773.02",
        "coordenadaY": "511.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6543,
        "colorId": 0,
        "numero": "64-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1797.48",
        "coordenadaY": "515.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6544,
        "colorId": 0,
        "numero": "65-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1822.39",
        "coordenadaY": "520.46",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6545,
        "colorId": 0,
        "numero": "66-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1957.32",
        "coordenadaY": "541.90",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6546,
        "colorId": 0,
        "numero": "67-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "1979.52",
        "coordenadaY": "547.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6547,
        "colorId": 0,
        "numero": "68-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2002.65",
        "coordenadaY": "552.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6548,
        "colorId": 0,
        "numero": "69-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2026.70",
        "coordenadaY": "557.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6549,
        "colorId": 0,
        "numero": "70-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2047.97",
        "coordenadaY": "563.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6550,
        "colorId": 0,
        "numero": "71-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2072.03",
        "coordenadaY": "568.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6551,
        "colorId": 0,
        "numero": "72-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2096.08",
        "coordenadaY": "574.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6552,
        "colorId": 0,
        "numero": "73-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2117.36",
        "coordenadaY": "578.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6553,
        "colorId": 0,
        "numero": "74-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2140.48",
        "coordenadaY": "585.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6554,
        "colorId": 0,
        "numero": "75-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2163.61",
        "coordenadaY": "590.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6555,
        "colorId": 0,
        "numero": "76-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2184.88",
        "coordenadaY": "597.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6556,
        "colorId": 0,
        "numero": "77-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2208.01",
        "coordenadaY": "603.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6557,
        "colorId": 0,
        "numero": "78-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2230.21",
        "coordenadaY": "610.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6558,
        "colorId": 0,
        "numero": "79-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2253.34",
        "coordenadaY": "616.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6559,
        "colorId": 0,
        "numero": "80-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2275.54",
        "coordenadaY": "623.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6560,
        "colorId": 0,
        "numero": "81-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2299.59",
        "coordenadaY": "630.55",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6561,
        "colorId": 0,
        "numero": "82-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2320.87",
        "coordenadaY": "637.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6562,
        "colorId": 0,
        "numero": "83-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2343.99",
        "coordenadaY": "644.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6563,
        "colorId": 0,
        "numero": "84-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2365.27",
        "coordenadaY": "651.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6564,
        "colorId": 0,
        "numero": "85-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2387.47",
        "coordenadaY": "659.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6565,
        "colorId": 0,
        "numero": "86-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2409.67",
        "coordenadaY": "666.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6566,
        "colorId": 0,
        "numero": "87-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2430.95",
        "coordenadaY": "674.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6567,
        "colorId": 0,
        "numero": "88-N",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "N",
        "cantidadSillas": 87,
        "color": "#3C5B6F",
        "coordenadaX": "2452.65",
        "coordenadaY": "683.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6568,
        "colorId": 0,
        "numero": "01-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "237.695",
        "coordenadaY": "635.695",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6569,
        "colorId": 0,
        "numero": "02-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "260.695",
        "coordenadaY": "627.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6570,
        "colorId": 0,
        "numero": "03-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "282.695",
        "coordenadaY": "618.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6571,
        "colorId": 0,
        "numero": "04-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "305.695",
        "coordenadaY": "611.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6572,
        "colorId": 0,
        "numero": "05-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "327.695",
        "coordenadaY": "602.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6573,
        "colorId": 0,
        "numero": "06-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "350.695",
        "coordenadaY": "596.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6574,
        "colorId": 0,
        "numero": "07-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "372.695",
        "coordenadaY": "589.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6575,
        "colorId": 0,
        "numero": "08-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "395.695",
        "coordenadaY": "581.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6576,
        "colorId": 0,
        "numero": "09-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "418.695",
        "coordenadaY": "575.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6577,
        "colorId": 0,
        "numero": "10-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "441.695",
        "coordenadaY": "567.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6578,
        "colorId": 0,
        "numero": "11-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "464.695",
        "coordenadaY": "561.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6579,
        "colorId": 0,
        "numero": "12-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "486.695",
        "coordenadaY": "555.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6580,
        "colorId": 0,
        "numero": "13-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "509.695",
        "coordenadaY": "549.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6581,
        "colorId": 0,
        "numero": "14-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "531.695",
        "coordenadaY": "542.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6582,
        "colorId": 0,
        "numero": "15-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "554.695",
        "coordenadaY": "536.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6583,
        "colorId": 0,
        "numero": "16-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "577.695",
        "coordenadaY": "530.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6584,
        "colorId": 0,
        "numero": "17-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "599.695",
        "coordenadaY": "526.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6585,
        "colorId": 0,
        "numero": "18-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "622.695",
        "coordenadaY": "520.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6586,
        "colorId": 0,
        "numero": "19-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "645.695",
        "coordenadaY": "515.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6587,
        "colorId": 0,
        "numero": "20-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "668.695",
        "coordenadaY": "509.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6588,
        "colorId": 0,
        "numero": "21-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "690.695",
        "coordenadaY": "504.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6589,
        "colorId": 0,
        "numero": "22-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "713.695",
        "coordenadaY": "500.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6590,
        "colorId": 0,
        "numero": "23-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "736.695",
        "coordenadaY": "496.695",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6591,
        "colorId": 0,
        "numero": "24-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "869.30",
        "coordenadaY": "476.38",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6592,
        "colorId": 0,
        "numero": "25-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "892.44",
        "coordenadaY": "471.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6593,
        "colorId": 0,
        "numero": "26-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "915.58",
        "coordenadaY": "468.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6594,
        "colorId": 0,
        "numero": "27-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "938.72",
        "coordenadaY": "463.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6595,
        "colorId": 0,
        "numero": "28-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "960.93",
        "coordenadaY": "460.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6596,
        "colorId": 0,
        "numero": "29-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "984.07",
        "coordenadaY": "456.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6597,
        "colorId": 0,
        "numero": "30-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1008.13",
        "coordenadaY": "455.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6598,
        "colorId": 0,
        "numero": "31-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1029.42",
        "coordenadaY": "451.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6599,
        "colorId": 0,
        "numero": "32-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1053.48",
        "coordenadaY": "449.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6600,
        "colorId": 0,
        "numero": "33-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1075.69",
        "coordenadaY": "446.83",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6601,
        "colorId": 0,
        "numero": "34-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1099.76",
        "coordenadaY": "444.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6602,
        "colorId": 0,
        "numero": "35-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1123.82",
        "coordenadaY": "443.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6603,
        "colorId": 0,
        "numero": "36-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1146.96",
        "coordenadaY": "442.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6604,
        "colorId": 0,
        "numero": "37-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1170.09",
        "coordenadaY": "441.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6605,
        "colorId": 0,
        "numero": "38-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1192.31",
        "coordenadaY": "439.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6606,
        "colorId": 0,
        "numero": "39-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1217.30",
        "coordenadaY": "438.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6607,
        "colorId": 0,
        "numero": "40-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1239.51",
        "coordenadaY": "436.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6608,
        "colorId": 0,
        "numero": "41-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1263.57",
        "coordenadaY": "435.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6609,
        "colorId": 0,
        "numero": "42-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1286.71",
        "coordenadaY": "435.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6610,
        "colorId": 0,
        "numero": "43-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1308.92",
        "coordenadaY": "435.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6611,
        "colorId": 0,
        "numero": "44-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1332.06",
        "coordenadaY": "435.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6612,
        "colorId": 0,
        "numero": "45-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1356.12",
        "coordenadaY": "436.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6613,
        "colorId": 0,
        "numero": "46-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1380.18",
        "coordenadaY": "436.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6614,
        "colorId": 0,
        "numero": "47-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1402.40",
        "coordenadaY": "436.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6615,
        "colorId": 0,
        "numero": "48-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1426.46",
        "coordenadaY": "435.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6616,
        "colorId": 0,
        "numero": "49-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1450.52",
        "coordenadaY": "436.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6617,
        "colorId": 0,
        "numero": "50-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1474.58",
        "coordenadaY": "437.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6618,
        "colorId": 0,
        "numero": "51-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1497.72",
        "coordenadaY": "437.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6619,
        "colorId": 0,
        "numero": "52-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1520.86",
        "coordenadaY": "438.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6620,
        "colorId": 0,
        "numero": "53-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1543.99",
        "coordenadaY": "440.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6621,
        "colorId": 0,
        "numero": "54-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1568.06",
        "coordenadaY": "442.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6622,
        "colorId": 0,
        "numero": "55-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1592.12",
        "coordenadaY": "444.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6623,
        "colorId": 0,
        "numero": "56-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1615.26",
        "coordenadaY": "445.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6624,
        "colorId": 0,
        "numero": "57-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1638.40",
        "coordenadaY": "447.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6625,
        "colorId": 0,
        "numero": "58-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1661.53",
        "coordenadaY": "448.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6626,
        "colorId": 0,
        "numero": "59-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1685.60",
        "coordenadaY": "451.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6627,
        "colorId": 0,
        "numero": "60-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1709.66",
        "coordenadaY": "454.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6628,
        "colorId": 0,
        "numero": "61-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1733.72",
        "coordenadaY": "457.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6629,
        "colorId": 0,
        "numero": "62-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1757.79",
        "coordenadaY": "459.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6630,
        "colorId": 0,
        "numero": "63-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1780.00",
        "coordenadaY": "462.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6631,
        "colorId": 0,
        "numero": "64-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1803.14",
        "coordenadaY": "465.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6632,
        "colorId": 0,
        "numero": "65-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1827.20",
        "coordenadaY": "468.99",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6633,
        "colorId": 0,
        "numero": "66-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1968.07",
        "coordenadaY": "490.68",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6634,
        "colorId": 0,
        "numero": "67-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "1991.58",
        "coordenadaY": "495.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6635,
        "colorId": 0,
        "numero": "68-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2013.22",
        "coordenadaY": "499.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6636,
        "colorId": 0,
        "numero": "69-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2037.67",
        "coordenadaY": "505.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6637,
        "colorId": 0,
        "numero": "70-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2061.18",
        "coordenadaY": "510.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6638,
        "colorId": 0,
        "numero": "71-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2084.69",
        "coordenadaY": "517.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6639,
        "colorId": 0,
        "numero": "72-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2110.09",
        "coordenadaY": "521.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6640,
        "colorId": 0,
        "numero": "73-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2132.66",
        "coordenadaY": "528.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6641,
        "colorId": 0,
        "numero": "74-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2154.29",
        "coordenadaY": "533.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6642,
        "colorId": 0,
        "numero": "75-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2179.68",
        "coordenadaY": "540.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6643,
        "colorId": 0,
        "numero": "76-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2202.26",
        "coordenadaY": "546.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6644,
        "colorId": 0,
        "numero": "77-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2224.83",
        "coordenadaY": "552.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6645,
        "colorId": 0,
        "numero": "78-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2247.40",
        "coordenadaY": "559.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6646,
        "colorId": 0,
        "numero": "79-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2270.92",
        "coordenadaY": "566.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6647,
        "colorId": 0,
        "numero": "80-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2292.55",
        "coordenadaY": "573.58",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6648,
        "colorId": 0,
        "numero": "81-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2316.06",
        "coordenadaY": "580.17",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6649,
        "colorId": 0,
        "numero": "82-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2339.57",
        "coordenadaY": "588.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6650,
        "colorId": 0,
        "numero": "83-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2362.14",
        "coordenadaY": "595.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6651,
        "colorId": 0,
        "numero": "84-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2384.72",
        "coordenadaY": "602.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6652,
        "colorId": 0,
        "numero": "85-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2406.35",
        "coordenadaY": "610.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6653,
        "colorId": 0,
        "numero": "86-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2429.86",
        "coordenadaY": "618.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6654,
        "colorId": 0,
        "numero": "87-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2453.37",
        "coordenadaY": "627.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6655,
        "colorId": 0,
        "numero": "88-O",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "O",
        "cantidadSillas": 88,
        "color": "#3C5B6F",
        "coordenadaX": "2475.01",
        "coordenadaY": "634.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6656,
        "colorId": 0,
        "numero": "01-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "207.656",
        "coordenadaY": "547.664",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6657,
        "colorId": 0,
        "numero": "02-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "228.895",
        "coordenadaY": "539.353",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6658,
        "colorId": 0,
        "numero": "03-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "251.98",
        "coordenadaY": "532.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6659,
        "colorId": 0,
        "numero": "04-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "273.218",
        "coordenadaY": "525.502",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6660,
        "colorId": 0,
        "numero": "05-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "296.304",
        "coordenadaY": "516.269",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6661,
        "colorId": 0,
        "numero": "06-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "318.465",
        "coordenadaY": "508.881",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6662,
        "colorId": 0,
        "numero": "07-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "340.627",
        "coordenadaY": "502.418",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6663,
        "colorId": 0,
        "numero": "08-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "362.789",
        "coordenadaY": "494.107",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6664,
        "colorId": 0,
        "numero": "09-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "385.875",
        "coordenadaY": "487.642",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6665,
        "colorId": 0,
        "numero": "10-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "408.036",
        "coordenadaY": "480.256",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6666,
        "colorId": 0,
        "numero": "11-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "430.198",
        "coordenadaY": "473.791",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6667,
        "colorId": 0,
        "numero": "12-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "452.36",
        "coordenadaY": "467.328",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6668,
        "colorId": 0,
        "numero": "13-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "475.445",
        "coordenadaY": "460.863",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6669,
        "colorId": 0,
        "numero": "14-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "497.607",
        "coordenadaY": "454.4",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6670,
        "colorId": 0,
        "numero": "15-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "518.846",
        "coordenadaY": "448.859",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6671,
        "colorId": 0,
        "numero": "16-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "542.696",
        "coordenadaY": "442.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6672,
        "colorId": 0,
        "numero": "17-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "564.093",
        "coordenadaY": "437.779",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6673,
        "colorId": 0,
        "numero": "18-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "587.178",
        "coordenadaY": "432.238",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6674,
        "colorId": 0,
        "numero": "19-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "608.417",
        "coordenadaY": "426.697",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6675,
        "colorId": 0,
        "numero": "20-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "631.502",
        "coordenadaY": "422.08",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6676,
        "colorId": 0,
        "numero": "21-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "653.664",
        "coordenadaY": "416.541",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6677,
        "colorId": 0,
        "numero": "22-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "676.749",
        "coordenadaY": "413.769",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6678,
        "colorId": 0,
        "numero": "23-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "697.987",
        "coordenadaY": "408.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6679,
        "colorId": 0,
        "numero": "24-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "721.073",
        "coordenadaY": "403.613",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6680,
        "colorId": 0,
        "numero": "25-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "859.30",
        "coordenadaY": "381.12",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6681,
        "colorId": 0,
        "numero": "26-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "881.40",
        "coordenadaY": "377.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6682,
        "colorId": 0,
        "numero": "27-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "904.41",
        "coordenadaY": "373.73",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6683,
        "colorId": 0,
        "numero": "28-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "927.42",
        "coordenadaY": "371.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6684,
        "colorId": 0,
        "numero": "29-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "951.36",
        "coordenadaY": "369.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6685,
        "colorId": 0,
        "numero": "30-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "976.21",
        "coordenadaY": "366.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6686,
        "colorId": 0,
        "numero": "31-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "998.30",
        "coordenadaY": "363.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6687,
        "colorId": 0,
        "numero": "32-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1021.31",
        "coordenadaY": "360.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6688,
        "colorId": 0,
        "numero": "33-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1045.25",
        "coordenadaY": "358.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6689,
        "colorId": 0,
        "numero": "34-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1069.18",
        "coordenadaY": "356.19",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6690,
        "colorId": 0,
        "numero": "35-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1092.19",
        "coordenadaY": "354.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6691,
        "colorId": 0,
        "numero": "36-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1116.13",
        "coordenadaY": "352.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6692,
        "colorId": 0,
        "numero": "37-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1138.22",
        "coordenadaY": "350.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6693,
        "colorId": 0,
        "numero": "38-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1160.31",
        "coordenadaY": "349.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6694,
        "colorId": 0,
        "numero": "39-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1184.25",
        "coordenadaY": "348.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6695,
        "colorId": 0,
        "numero": "40-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1208.18",
        "coordenadaY": "346.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6696,
        "colorId": 0,
        "numero": "41-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1231.20",
        "coordenadaY": "346.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6697,
        "colorId": 0,
        "numero": "42-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1256.05",
        "coordenadaY": "346.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6698,
        "colorId": 0,
        "numero": "43-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1279.98",
        "coordenadaY": "345.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6699,
        "colorId": 0,
        "numero": "44-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1303.92",
        "coordenadaY": "345.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6700,
        "colorId": 0,
        "numero": "45-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1326.93",
        "coordenadaY": "344.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6701,
        "colorId": 0,
        "numero": "46-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1351.79",
        "coordenadaY": "344.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6702,
        "colorId": 0,
        "numero": "47-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1375.72",
        "coordenadaY": "344.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6703,
        "colorId": 0,
        "numero": "48-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1398.73",
        "coordenadaY": "344.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6704,
        "colorId": 0,
        "numero": "49-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1421.75",
        "coordenadaY": "345.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6705,
        "colorId": 0,
        "numero": "50-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1445.68",
        "coordenadaY": "346.03",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6706,
        "colorId": 0,
        "numero": "51-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1469.61",
        "coordenadaY": "346.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6707,
        "colorId": 0,
        "numero": "52-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1494.47",
        "coordenadaY": "346.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6708,
        "colorId": 0,
        "numero": "53-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1518.40",
        "coordenadaY": "348.80",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6709,
        "colorId": 0,
        "numero": "54-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1541.42",
        "coordenadaY": "349.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6710,
        "colorId": 0,
        "numero": "55-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1564.43",
        "coordenadaY": "351.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6711,
        "colorId": 0,
        "numero": "56-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1588.36",
        "coordenadaY": "353.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6712,
        "colorId": 0,
        "numero": "57-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1611.38",
        "coordenadaY": "355.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6713,
        "colorId": 0,
        "numero": "58-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1634.39",
        "coordenadaY": "357.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6714,
        "colorId": 0,
        "numero": "59-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1656.48",
        "coordenadaY": "358.96",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6715,
        "colorId": 0,
        "numero": "60-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1679.50",
        "coordenadaY": "361.73",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6716,
        "colorId": 0,
        "numero": "61-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1703.43",
        "coordenadaY": "364.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6717,
        "colorId": 0,
        "numero": "62-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1727.37",
        "coordenadaY": "366.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6718,
        "colorId": 0,
        "numero": "63-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1750.38",
        "coordenadaY": "369.11",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6719,
        "colorId": 0,
        "numero": "64-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1775.23",
        "coordenadaY": "371.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6720,
        "colorId": 0,
        "numero": "65-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1797.33",
        "coordenadaY": "374.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6721,
        "colorId": 0,
        "numero": "66-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1820.34",
        "coordenadaY": "377.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6722,
        "colorId": 0,
        "numero": "67-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1843.35",
        "coordenadaY": "382.04",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6723,
        "colorId": 0,
        "numero": "68-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "1981.21",
        "coordenadaY": "402.55",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6724,
        "colorId": 0,
        "numero": "69-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2003.90",
        "coordenadaY": "406.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6725,
        "colorId": 0,
        "numero": "70-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2025.70",
        "coordenadaY": "411.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6726,
        "colorId": 0,
        "numero": "71-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2048.58",
        "coordenadaY": "417.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6727,
        "colorId": 0,
        "numero": "72-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2071.10",
        "coordenadaY": "421.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6728,
        "colorId": 0,
        "numero": "73-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2092.90",
        "coordenadaY": "426.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6729,
        "colorId": 0,
        "numero": "74-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2116.51",
        "coordenadaY": "431.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6730,
        "colorId": 0,
        "numero": "75-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2139.23",
        "coordenadaY": "438.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6731,
        "colorId": 0,
        "numero": "76-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2164.01",
        "coordenadaY": "443.18",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6732,
        "colorId": 0,
        "numero": "77-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2186.47",
        "coordenadaY": "450.58",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6733,
        "colorId": 0,
        "numero": "78-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2209.17",
        "coordenadaY": "455.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6734,
        "colorId": 0,
        "numero": "79-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2230.49",
        "coordenadaY": "462.57",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6735,
        "colorId": 0,
        "numero": "80-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2253.69",
        "coordenadaY": "467.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6736,
        "colorId": 0,
        "numero": "81-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2274.60",
        "coordenadaY": "474.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6737,
        "colorId": 0,
        "numero": "82-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2296.98",
        "coordenadaY": "481.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6738,
        "colorId": 0,
        "numero": "83-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2320.94",
        "coordenadaY": "488.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6739,
        "colorId": 0,
        "numero": "84-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2343.67",
        "coordenadaY": "496.27",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6740,
        "colorId": 0,
        "numero": "85-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2366.40",
        "coordenadaY": "503.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6741,
        "colorId": 0,
        "numero": "86-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2388.20",
        "coordenadaY": "509.72",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6742,
        "colorId": 0,
        "numero": "87-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2410.93",
        "coordenadaY": "516.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6743,
        "colorId": 0,
        "numero": "88-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2433.67",
        "coordenadaY": "525.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6744,
        "colorId": 0,
        "numero": "89-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2455.48",
        "coordenadaY": "533.13",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6745,
        "colorId": 0,
        "numero": "90-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2475.20",
        "coordenadaY": "541.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6746,
        "colorId": 0,
        "numero": "91-P",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "P",
        "cantidadSillas": 89,
        "color": "#3C5B6F",
        "coordenadaX": "2498.28",
        "coordenadaY": "550.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6747,
        "colorId": 0,
        "numero": "01-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "191.957",
        "coordenadaY": "500.568",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6748,
        "colorId": 0,
        "numero": "02-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "214.119",
        "coordenadaY": "492.258",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6749,
        "colorId": 0,
        "numero": "03-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "235.358",
        "coordenadaY": "483.947",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6750,
        "colorId": 0,
        "numero": "04-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "258.443",
        "coordenadaY": "476.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6751,
        "colorId": 0,
        "numero": "05-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "279.681",
        "coordenadaY": "468.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6752,
        "colorId": 0,
        "numero": "06-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "302.767",
        "coordenadaY": "460.861",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6753,
        "colorId": 0,
        "numero": "07-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "325.852",
        "coordenadaY": "453.474",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6754,
        "colorId": 0,
        "numero": "08-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "348.014",
        "coordenadaY": "446.088",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6755,
        "colorId": 0,
        "numero": "09-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "371.099",
        "coordenadaY": "438.699",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6756,
        "colorId": 0,
        "numero": "10-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "393.261",
        "coordenadaY": "432.236",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6757,
        "colorId": 0,
        "numero": "11-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "415.423",
        "coordenadaY": "425.771",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6758,
        "colorId": 0,
        "numero": "12-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "438.508",
        "coordenadaY": "419.308",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6759,
        "colorId": 0,
        "numero": "13-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "460.67",
        "coordenadaY": "412.843",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6760,
        "colorId": 0,
        "numero": "14-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "483.755",
        "coordenadaY": "407.304",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6761,
        "colorId": 0,
        "numero": "15-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "505.917",
        "coordenadaY": "400.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6762,
        "colorId": 0,
        "numero": "16-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "529.926",
        "coordenadaY": "395.3",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6763,
        "colorId": 0,
        "numero": "17-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "551.164",
        "coordenadaY": "388.836",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6764,
        "colorId": 0,
        "numero": "18-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "573.326",
        "coordenadaY": "383.295",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6765,
        "colorId": 0,
        "numero": "19-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "597.335",
        "coordenadaY": "377.756",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6766,
        "colorId": 0,
        "numero": "20-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "620.42",
        "coordenadaY": "373.138",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6767,
        "colorId": 0,
        "numero": "21-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "643.506",
        "coordenadaY": "367.597",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6768,
        "colorId": 0,
        "numero": "22-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "665.667",
        "coordenadaY": "362.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6769,
        "colorId": 0,
        "numero": "23-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "689.676",
        "coordenadaY": "358.363",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6770,
        "colorId": 0,
        "numero": "24-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "711.838",
        "coordenadaY": "354.67",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6771,
        "colorId": 0,
        "numero": "25-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "850.78",
        "coordenadaY": "327.77",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6772,
        "colorId": 0,
        "numero": "26-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "873.55",
        "coordenadaY": "325.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6773,
        "colorId": 0,
        "numero": "27-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "897.24",
        "coordenadaY": "321.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6774,
        "colorId": 0,
        "numero": "28-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "919.11",
        "coordenadaY": "318.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6775,
        "colorId": 0,
        "numero": "29-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "942.80",
        "coordenadaY": "314.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6776,
        "colorId": 0,
        "numero": "30-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "966.48",
        "coordenadaY": "313.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6777,
        "colorId": 0,
        "numero": "31-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "989.26",
        "coordenadaY": "309.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6778,
        "colorId": 0,
        "numero": "32-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1012.94",
        "coordenadaY": "308.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6779,
        "colorId": 0,
        "numero": "33-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1036.63",
        "coordenadaY": "305.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6780,
        "colorId": 0,
        "numero": "34-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1057.59",
        "coordenadaY": "302.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6781,
        "colorId": 0,
        "numero": "35-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1082.18",
        "coordenadaY": "300.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6782,
        "colorId": 0,
        "numero": "36-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1105.87",
        "coordenadaY": "300.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6783,
        "colorId": 0,
        "numero": "37-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1128.65",
        "coordenadaY": "299.15",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6784,
        "colorId": 0,
        "numero": "38-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1151.43",
        "coordenadaY": "297.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6785,
        "colorId": 0,
        "numero": "39-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1175.11",
        "coordenadaY": "295.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6786,
        "colorId": 0,
        "numero": "40-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1198.80",
        "coordenadaY": "294.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6787,
        "colorId": 0,
        "numero": "41-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1221.58",
        "coordenadaY": "294.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6788,
        "colorId": 0,
        "numero": "42-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1246.18",
        "coordenadaY": "293.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6789,
        "colorId": 0,
        "numero": "43-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1268.95",
        "coordenadaY": "292.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6790,
        "colorId": 0,
        "numero": "44-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1291.73",
        "coordenadaY": "291.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6791,
        "colorId": 0,
        "numero": "45-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1314.51",
        "coordenadaY": "291.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6792,
        "colorId": 0,
        "numero": "46-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1338.19",
        "coordenadaY": "291.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6793,
        "colorId": 0,
        "numero": "47-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1362.79",
        "coordenadaY": "291.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6794,
        "colorId": 0,
        "numero": "48-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1385.57",
        "coordenadaY": "292.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6795,
        "colorId": 0,
        "numero": "49-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1409.26",
        "coordenadaY": "292.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6796,
        "colorId": 0,
        "numero": "50-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1432.03",
        "coordenadaY": "292.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6797,
        "colorId": 0,
        "numero": "51-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1455.72",
        "coordenadaY": "292.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6798,
        "colorId": 0,
        "numero": "52-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1478.50",
        "coordenadaY": "293.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6799,
        "colorId": 0,
        "numero": "53-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1501.27",
        "coordenadaY": "295.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6800,
        "colorId": 0,
        "numero": "54-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1524.96",
        "coordenadaY": "296.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6801,
        "colorId": 0,
        "numero": "55-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1547.74",
        "coordenadaY": "298.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6802,
        "colorId": 0,
        "numero": "56-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1571.43",
        "coordenadaY": "300.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6803,
        "colorId": 0,
        "numero": "57-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1595.12",
        "coordenadaY": "301.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6804,
        "colorId": 0,
        "numero": "58-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1617.89",
        "coordenadaY": "303.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6805,
        "colorId": 0,
        "numero": "59-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1640.67",
        "coordenadaY": "306.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6806,
        "colorId": 0,
        "numero": "60-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1664.36",
        "coordenadaY": "307.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6807,
        "colorId": 0,
        "numero": "61-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1688.04",
        "coordenadaY": "310.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6808,
        "colorId": 0,
        "numero": "62-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1710.82",
        "coordenadaY": "313.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6809,
        "colorId": 0,
        "numero": "63-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1734.51",
        "coordenadaY": "316.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6810,
        "colorId": 0,
        "numero": "64-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1758.20",
        "coordenadaY": "319.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6811,
        "colorId": 0,
        "numero": "65-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1780.06",
        "coordenadaY": "322.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6812,
        "colorId": 0,
        "numero": "66-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1802.84",
        "coordenadaY": "325.00",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6813,
        "colorId": 0,
        "numero": "67-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1826.53",
        "coordenadaY": "328.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6814,
        "colorId": 0,
        "numero": "68-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1850.21",
        "coordenadaY": "332.39",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6815,
        "colorId": 0,
        "numero": "69-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "1988.88",
        "coordenadaY": "352.23",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6816,
        "colorId": 0,
        "numero": "70-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2014.50",
        "coordenadaY": "356.23",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6817,
        "colorId": 0,
        "numero": "71-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2038.15",
        "coordenadaY": "360.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6818,
        "colorId": 0,
        "numero": "72-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2061.80",
        "coordenadaY": "366.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6819,
        "colorId": 0,
        "numero": "73-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2086.43",
        "coordenadaY": "371.26",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6820,
        "colorId": 0,
        "numero": "74-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2112.05",
        "coordenadaY": "378.28",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6821,
        "colorId": 0,
        "numero": "75-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2133.73",
        "coordenadaY": "383.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6822,
        "colorId": 0,
        "numero": "76-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2157.38",
        "coordenadaY": "389.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6823,
        "colorId": 0,
        "numero": "77-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2180.04",
        "coordenadaY": "394.31",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6824,
        "colorId": 0,
        "numero": "78-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2203.69",
        "coordenadaY": "400.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6825,
        "colorId": 0,
        "numero": "79-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2227.34",
        "coordenadaY": "406.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6826,
        "colorId": 0,
        "numero": "80-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2249.02",
        "coordenadaY": "412.34",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6827,
        "colorId": 0,
        "numero": "81-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2272.66",
        "coordenadaY": "419.36",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6828,
        "colorId": 0,
        "numero": "82-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2295.33",
        "coordenadaY": "425.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6829,
        "colorId": 0,
        "numero": "83-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2317.99",
        "coordenadaY": "432.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6830,
        "colorId": 0,
        "numero": "84-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2340.65",
        "coordenadaY": "439.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6831,
        "colorId": 0,
        "numero": "85-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2362.33",
        "coordenadaY": "445.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6832,
        "colorId": 0,
        "numero": "86-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2384.99",
        "coordenadaY": "453.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6833,
        "colorId": 0,
        "numero": "87-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2407.66",
        "coordenadaY": "461.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6834,
        "colorId": 0,
        "numero": "88-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2430.32",
        "coordenadaY": "469.46",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6835,
        "colorId": 0,
        "numero": "89-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2451.01",
        "coordenadaY": "477.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6836,
        "colorId": 0,
        "numero": "90-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2475.64",
        "coordenadaY": "485.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6837,
        "colorId": 0,
        "numero": "91-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2498.31",
        "coordenadaY": "492.50",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6838,
        "colorId": 0,
        "numero": "92-Q",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "Q",
        "cantidadSillas": 91,
        "color": "#3C5B6F",
        "coordenadaX": "2519.98",
        "coordenadaY": "500.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6839,
        "colorId": 0,
        "numero": "01-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "178.106",
        "coordenadaY": "451.629",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6840,
        "colorId": 0,
        "numero": "02-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "199.344",
        "coordenadaY": "443.316",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6841,
        "colorId": 0,
        "numero": "03-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "222.43",
        "coordenadaY": "435.006",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6842,
        "colorId": 0,
        "numero": "04-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "243.668",
        "coordenadaY": "426.695",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6843,
        "colorId": 0,
        "numero": "05-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "265.83",
        "coordenadaY": "419.308",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6844,
        "colorId": 0,
        "numero": "06-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "288.915",
        "coordenadaY": "411.922",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6845,
        "colorId": 0,
        "numero": "07-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "311.077",
        "coordenadaY": "403.611",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6846,
        "colorId": 0,
        "numero": "08-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "333.239",
        "coordenadaY": "396.222",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6847,
        "colorId": 0,
        "numero": "09-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "356.324",
        "coordenadaY": "388.836",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6848,
        "colorId": 0,
        "numero": "10-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "379.41",
        "coordenadaY": "382.373",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6849,
        "colorId": 0,
        "numero": "11-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "401.571",
        "coordenadaY": "374.984",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6850,
        "colorId": 0,
        "numero": "12-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "425.58",
        "coordenadaY": "368.521",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6851,
        "colorId": 0,
        "numero": "13-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "446.819",
        "coordenadaY": "362.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6852,
        "colorId": 0,
        "numero": "14-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "469.904",
        "coordenadaY": "356.517",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6853,
        "colorId": 0,
        "numero": "15-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "492.989",
        "coordenadaY": "350.052",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6854,
        "colorId": 0,
        "numero": "16-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "514.228",
        "coordenadaY": "345.435",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6855,
        "colorId": 0,
        "numero": "17-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "538.237",
        "coordenadaY": "338.972",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6856,
        "colorId": 0,
        "numero": "18-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "561.322",
        "coordenadaY": "333.431",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6857,
        "colorId": 0,
        "numero": "19-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "585.33",
        "coordenadaY": "327.89",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6858,
        "colorId": 0,
        "numero": "20-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "607.492",
        "coordenadaY": "322.349",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6859,
        "colorId": 0,
        "numero": "21-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "630.577",
        "coordenadaY": "316.81",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6860,
        "colorId": 0,
        "numero": "22-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "652.739",
        "coordenadaY": "313.117",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6861,
        "colorId": 0,
        "numero": "23-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "676.748",
        "coordenadaY": "306.652",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6862,
        "colorId": 0,
        "numero": "24-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "698.91",
        "coordenadaY": "302.959",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6863,
        "colorId": 0,
        "numero": "25-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "846.31",
        "coordenadaY": "279.61",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6864,
        "colorId": 0,
        "numero": "26-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "869.77",
        "coordenadaY": "276.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6865,
        "colorId": 0,
        "numero": "27-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "892.30",
        "coordenadaY": "274.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6866,
        "colorId": 0,
        "numero": "28-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "915.76",
        "coordenadaY": "270.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6867,
        "colorId": 0,
        "numero": "29-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "939.23",
        "coordenadaY": "267.61",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6868,
        "colorId": 0,
        "numero": "30-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "962.70",
        "coordenadaY": "264.84",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6869,
        "colorId": 0,
        "numero": "31-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "986.16",
        "coordenadaY": "262.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6870,
        "colorId": 0,
        "numero": "32-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1009.62",
        "coordenadaY": "260.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6871,
        "colorId": 0,
        "numero": "33-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1033.09",
        "coordenadaY": "257.45",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6872,
        "colorId": 0,
        "numero": "34-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1057.50",
        "coordenadaY": "255.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6873,
        "colorId": 0,
        "numero": "35-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1080.96",
        "coordenadaY": "252.83",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6874,
        "colorId": 0,
        "numero": "36-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1104.43",
        "coordenadaY": "250.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6875,
        "colorId": 0,
        "numero": "37-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1126.95",
        "coordenadaY": "250.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6876,
        "colorId": 0,
        "numero": "38-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1151.36",
        "coordenadaY": "248.21",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6877,
        "colorId": 0,
        "numero": "39-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1173.88",
        "coordenadaY": "247.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6878,
        "colorId": 0,
        "numero": "40-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1198.29",
        "coordenadaY": "245.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6879,
        "colorId": 0,
        "numero": "41-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1221.75",
        "coordenadaY": "245.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6880,
        "colorId": 0,
        "numero": "42-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1244.28",
        "coordenadaY": "244.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6881,
        "colorId": 0,
        "numero": "43-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1268.68",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6882,
        "colorId": 0,
        "numero": "44-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1293.09",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6883,
        "colorId": 0,
        "numero": "45-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1317.49",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6884,
        "colorId": 0,
        "numero": "46-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1339.08",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6885,
        "colorId": 0,
        "numero": "47-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1363.49",
        "coordenadaY": "241.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6886,
        "colorId": 0,
        "numero": "48-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1386.95",
        "coordenadaY": "241.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6887,
        "colorId": 0,
        "numero": "49-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1410.42",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6888,
        "colorId": 0,
        "numero": "50-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1434.82",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6889,
        "colorId": 0,
        "numero": "51-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1457.35",
        "coordenadaY": "242.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6890,
        "colorId": 0,
        "numero": "52-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1481.75",
        "coordenadaY": "244.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6891,
        "colorId": 0,
        "numero": "53-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1505.22",
        "coordenadaY": "245.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6892,
        "colorId": 0,
        "numero": "54-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1528.68",
        "coordenadaY": "245.44",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6893,
        "colorId": 0,
        "numero": "55-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1552.15",
        "coordenadaY": "247.29",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6894,
        "colorId": 0,
        "numero": "56-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1575.61",
        "coordenadaY": "249.14",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6895,
        "colorId": 0,
        "numero": "57-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1599.08",
        "coordenadaY": "250.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6896,
        "colorId": 0,
        "numero": "58-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1622.55",
        "coordenadaY": "250.98",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6897,
        "colorId": 0,
        "numero": "59-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1646.01",
        "coordenadaY": "253.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6898,
        "colorId": 0,
        "numero": "60-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1669.48",
        "coordenadaY": "256.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6899,
        "colorId": 0,
        "numero": "61-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1694.82",
        "coordenadaY": "258.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6900,
        "colorId": 0,
        "numero": "62-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1716.41",
        "coordenadaY": "260.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6901,
        "colorId": 0,
        "numero": "63-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1739.87",
        "coordenadaY": "262.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6902,
        "colorId": 0,
        "numero": "64-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1763.34",
        "coordenadaY": "265.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6903,
        "colorId": 0,
        "numero": "65-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1786.81",
        "coordenadaY": "268.53",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6904,
        "colorId": 0,
        "numero": "66-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1810.27",
        "coordenadaY": "271.30",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6905,
        "colorId": 0,
        "numero": "67-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1832.80",
        "coordenadaY": "274.07",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6906,
        "colorId": 0,
        "numero": "68-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1857.20",
        "coordenadaY": "277.76",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6907,
        "colorId": 0,
        "numero": "69-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "1994.14",
        "coordenadaY": "302.11",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6908,
        "colorId": 0,
        "numero": "70-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2017.38",
        "coordenadaY": "307.94",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6909,
        "colorId": 0,
        "numero": "71-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2039.65",
        "coordenadaY": "313.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6910,
        "colorId": 0,
        "numero": "72-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2064.85",
        "coordenadaY": "318.70",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6911,
        "colorId": 0,
        "numero": "73-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2088.10",
        "coordenadaY": "324.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6912,
        "colorId": 0,
        "numero": "74-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2114.26",
        "coordenadaY": "330.40",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6913,
        "colorId": 0,
        "numero": "75-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2138.47",
        "coordenadaY": "336.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6914,
        "colorId": 0,
        "numero": "76-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2161.71",
        "coordenadaY": "342.06",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6915,
        "colorId": 0,
        "numero": "77-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2185.94",
        "coordenadaY": "347.01",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6916,
        "colorId": 0,
        "numero": "78-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2211.10",
        "coordenadaY": "354.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6917,
        "colorId": 0,
        "numero": "79-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2234.34",
        "coordenadaY": "360.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6918,
        "colorId": 0,
        "numero": "80-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2259.51",
        "coordenadaY": "367.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6919,
        "colorId": 0,
        "numero": "81-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2281.76",
        "coordenadaY": "373.95",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6920,
        "colorId": 0,
        "numero": "82-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2304.99",
        "coordenadaY": "380.68",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6921,
        "colorId": 0,
        "numero": "83-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2329.20",
        "coordenadaY": "386.52",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6922,
        "colorId": 0,
        "numero": "84-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2352.39",
        "coordenadaY": "395.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6923,
        "colorId": 0,
        "numero": "85-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2376.59",
        "coordenadaY": "401.79",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6924,
        "colorId": 0,
        "numero": "86-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2399.80",
        "coordenadaY": "409.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6925,
        "colorId": 0,
        "numero": "87-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2423.98",
        "coordenadaY": "417.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6926,
        "colorId": 0,
        "numero": "88-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2446.21",
        "coordenadaY": "424.66",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6927,
        "colorId": 0,
        "numero": "89-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2471.38",
        "coordenadaY": "431.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6928,
        "colorId": 0,
        "numero": "90-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2493.60",
        "coordenadaY": "439.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6929,
        "colorId": 0,
        "numero": "91-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2515.80",
        "coordenadaY": "449.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6930,
        "colorId": 0,
        "numero": "92-R",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "R",
        "cantidadSillas": 93,
        "color": "#3C5B6F",
        "coordenadaX": "2538.72",
        "coordenadaY": "455.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6931,
        "colorId": 0,
        "numero": "01-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "160.561",
        "coordenadaY": "404.611",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6932,
        "colorId": 0,
        "numero": "02-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "180.876",
        "coordenadaY": "397.222",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6933,
        "colorId": 0,
        "numero": "03-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "202.115",
        "coordenadaY": "388.836",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6934,
        "colorId": 0,
        "numero": "04-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "224.277",
        "coordenadaY": "380.525",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6935,
        "colorId": 0,
        "numero": "05-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "246.439",
        "coordenadaY": "372.215",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6936,
        "colorId": 0,
        "numero": "06-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "267.677",
        "coordenadaY": "365.75",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6937,
        "colorId": 0,
        "numero": "07-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "289.839",
        "coordenadaY": "359.287",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6938,
        "colorId": 0,
        "numero": "08-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "310.154",
        "coordenadaY": "351.9",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6939,
        "colorId": 0,
        "numero": "09-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "333.239",
        "coordenadaY": "345.435",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6940,
        "colorId": 0,
        "numero": "10-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "353.554",
        "coordenadaY": "337.125",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6941,
        "colorId": 0,
        "numero": "11-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "375.716",
        "coordenadaY": "331.584",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6942,
        "colorId": 0,
        "numero": "12-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "397.878",
        "coordenadaY": "324.197",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6943,
        "colorId": 0,
        "numero": "13-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "420.04",
        "coordenadaY": "317.732",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6944,
        "colorId": 0,
        "numero": "14-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "443.125",
        "coordenadaY": "312.193",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6945,
        "colorId": 0,
        "numero": "15-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "464.363",
        "coordenadaY": "306.652",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6946,
        "colorId": 0,
        "numero": "16-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "487.449",
        "coordenadaY": "301.111",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6947,
        "colorId": 0,
        "numero": "17-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "511.458",
        "coordenadaY": "295.572",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6948,
        "colorId": 0,
        "numero": "18-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "533.619",
        "coordenadaY": "290.031",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6949,
        "colorId": 0,
        "numero": "19-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "554.858",
        "coordenadaY": "284.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6950,
        "colorId": 0,
        "numero": "20-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "577.02",
        "coordenadaY": "278.949",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6951,
        "colorId": 0,
        "numero": "21-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "599.181",
        "coordenadaY": "274.334",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6952,
        "colorId": 0,
        "numero": "22-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "621.343",
        "coordenadaY": "268.793",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6953,
        "colorId": 0,
        "numero": "23-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "643.506",
        "coordenadaY": "264.175",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6954,
        "colorId": 0,
        "numero": "24-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "665.667",
        "coordenadaY": "259.558",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6955,
        "colorId": 0,
        "numero": "25-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "688.753",
        "coordenadaY": "254.941",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6956,
        "colorId": 0,
        "numero": "26-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "839.16",
        "coordenadaY": "226.81",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6957,
        "colorId": 0,
        "numero": "27-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "861.42",
        "coordenadaY": "224.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6958,
        "colorId": 0,
        "numero": "28-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "886.56",
        "coordenadaY": "222.49",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6959,
        "colorId": 0,
        "numero": "29-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "910.75",
        "coordenadaY": "220.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6960,
        "colorId": 0,
        "numero": "30-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "935.90",
        "coordenadaY": "218.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6961,
        "colorId": 0,
        "numero": "31-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "960.08",
        "coordenadaY": "216.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6962,
        "colorId": 0,
        "numero": "32-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "984.28",
        "coordenadaY": "213.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6963,
        "colorId": 0,
        "numero": "33-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1007.49",
        "coordenadaY": "211.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6964,
        "colorId": 0,
        "numero": "34-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1032.64",
        "coordenadaY": "209.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6965,
        "colorId": 0,
        "numero": "35-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1056.81",
        "coordenadaY": "208.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6966,
        "colorId": 0,
        "numero": "36-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1081.96",
        "coordenadaY": "206.91",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6967,
        "colorId": 0,
        "numero": "37-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1106.14",
        "coordenadaY": "204.77",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6968,
        "colorId": 0,
        "numero": "38-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1129.35",
        "coordenadaY": "203.41",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6969,
        "colorId": 0,
        "numero": "39-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1154.48",
        "coordenadaY": "202.87",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6970,
        "colorId": 0,
        "numero": "40-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1178.65",
        "coordenadaY": "202.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6971,
        "colorId": 0,
        "numero": "41-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1202.82",
        "coordenadaY": "201.78",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6972,
        "colorId": 0,
        "numero": "42-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1226.99",
        "coordenadaY": "200.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6973,
        "colorId": 0,
        "numero": "43-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1253.09",
        "coordenadaY": "199.90",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6974,
        "colorId": 0,
        "numero": "44-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1277.25",
        "coordenadaY": "200.16",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6975,
        "colorId": 0,
        "numero": "45-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1302.39",
        "coordenadaY": "199.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6976,
        "colorId": 0,
        "numero": "46-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1326.54",
        "coordenadaY": "199.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6977,
        "colorId": 0,
        "numero": "47-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1350.71",
        "coordenadaY": "199.33",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6978,
        "colorId": 0,
        "numero": "48-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1374.87",
        "coordenadaY": "199.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6979,
        "colorId": 0,
        "numero": "49-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1398.07",
        "coordenadaY": "199.04",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6980,
        "colorId": 0,
        "numero": "50-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1422.22",
        "coordenadaY": "200.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6981,
        "colorId": 0,
        "numero": "51-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1448.31",
        "coordenadaY": "200.37",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6982,
        "colorId": 0,
        "numero": "52-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1472.46",
        "coordenadaY": "201.43",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6983,
        "colorId": 0,
        "numero": "53-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1496.61",
        "coordenadaY": "202.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6984,
        "colorId": 0,
        "numero": "54-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1520.76",
        "coordenadaY": "204.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6985,
        "colorId": 0,
        "numero": "55-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1544.91",
        "coordenadaY": "204.60",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6986,
        "colorId": 0,
        "numero": "56-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1570.02",
        "coordenadaY": "206.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6987,
        "colorId": 0,
        "numero": "57-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1595.13",
        "coordenadaY": "208.35",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6988,
        "colorId": 0,
        "numero": "58-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1618.32",
        "coordenadaY": "208.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6989,
        "colorId": 0,
        "numero": "59-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1644.40",
        "coordenadaY": "210.47",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6990,
        "colorId": 0,
        "numero": "60-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1667.57",
        "coordenadaY": "212.32",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6991,
        "colorId": 0,
        "numero": "61-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1691.72",
        "coordenadaY": "213.38",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6992,
        "colorId": 0,
        "numero": "62-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1715.86",
        "coordenadaY": "215.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6993,
        "colorId": 0,
        "numero": "63-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1741.93",
        "coordenadaY": "217.92",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6994,
        "colorId": 0,
        "numero": "64-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1766.06",
        "coordenadaY": "220.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6995,
        "colorId": 0,
        "numero": "65-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1790.20",
        "coordenadaY": "223.25",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6996,
        "colorId": 0,
        "numero": "66-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1812.39",
        "coordenadaY": "226.69",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6997,
        "colorId": 0,
        "numero": "67-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1838.46",
        "coordenadaY": "228.58",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6998,
        "colorId": 0,
        "numero": "68-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "1862.59",
        "coordenadaY": "231.24",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 6999,
        "colorId": 0,
        "numero": "69-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2001.67",
        "coordenadaY": "255.31",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7000,
        "colorId": 0,
        "numero": "70-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2022.98",
        "coordenadaY": "258.76",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7001,
        "colorId": 0,
        "numero": "71-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2045.18",
        "coordenadaY": "262.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7002,
        "colorId": 0,
        "numero": "72-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2066.50",
        "coordenadaY": "268.24",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7003,
        "colorId": 0,
        "numero": "73-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2088.70",
        "coordenadaY": "272.54",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7004,
        "colorId": 0,
        "numero": "74-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2110.01",
        "coordenadaY": "277.71",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7005,
        "colorId": 0,
        "numero": "75-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2132.21",
        "coordenadaY": "282.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7006,
        "colorId": 0,
        "numero": "76-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2153.52",
        "coordenadaY": "288.05",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7007,
        "colorId": 0,
        "numero": "77-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2174.84",
        "coordenadaY": "293.22",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7008,
        "colorId": 0,
        "numero": "78-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2197.04",
        "coordenadaY": "298.39",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7009,
        "colorId": 0,
        "numero": "79-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2218.35",
        "coordenadaY": "304.42",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7010,
        "colorId": 0,
        "numero": "80-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2238.77",
        "coordenadaY": "309.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7011,
        "colorId": 0,
        "numero": "81-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2260.97",
        "coordenadaY": "316.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7012,
        "colorId": 0,
        "numero": "82-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2281.40",
        "coordenadaY": "321.65",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7013,
        "colorId": 0,
        "numero": "83-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2302.71",
        "coordenadaY": "326.82",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7014,
        "colorId": 0,
        "numero": "84-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2323.13",
        "coordenadaY": "332.85",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7015,
        "colorId": 0,
        "numero": "85-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2345.33",
        "coordenadaY": "338.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7016,
        "colorId": 0,
        "numero": "86-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2365.76",
        "coordenadaY": "346.63",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7017,
        "colorId": 0,
        "numero": "87-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2387.96",
        "coordenadaY": "352.67",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7018,
        "colorId": 0,
        "numero": "88-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2408.38",
        "coordenadaY": "359.56",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7019,
        "colorId": 0,
        "numero": "89-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2429.70",
        "coordenadaY": "365.59",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7020,
        "colorId": 0,
        "numero": "90-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2451.01",
        "coordenadaY": "372.48",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7021,
        "colorId": 0,
        "numero": "91-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2472.32",
        "coordenadaY": "381.10",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7022,
        "colorId": 0,
        "numero": "92-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2493.63",
        "coordenadaY": "387.99",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7023,
        "colorId": 0,
        "numero": "93-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2516.25",
        "coordenadaY": "395.74",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7024,
        "colorId": 0,
        "numero": "94-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2536.17",
        "coordenadaY": "406.88",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7025,
        "colorId": 0,
        "numero": "95-S",
        "idVarianteShopify": "49320688648475",
        "idVarianteShopifyNino": "51305761964315",
        "area": "Travesía Experience",
        "areaId": 8,
        "nombreFila": "S",
        "cantidadSillas": 95,
        "color": "#3C5B6F",
        "coordenadaX": "2556.92",
        "coordenadaY": "416.20",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 59,
        "precioDolarLocal": 59,
        "precioDolarLocalNinos": 35,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7026,
        "colorId": 0,
        "numero": "01-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "274.142",
        "coordenadaY": "314.04",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7027,
        "colorId": 0,
        "numero": "02-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "338.78",
        "coordenadaY": "293.725",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7028,
        "colorId": 0,
        "numero": "03-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "398.802",
        "coordenadaY": "277.104",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7029,
        "colorId": 0,
        "numero": "04-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "461.594",
        "coordenadaY": "259.559",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7030,
        "colorId": 0,
        "numero": "05-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "524.386",
        "coordenadaY": "244.784",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7031,
        "colorId": 0,
        "numero": "06-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "588.101",
        "coordenadaY": "227.239",
        "sillaInicio": false,
        "sillaFin": true,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7032,
        "colorId": 0,
        "numero": "07-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2115.71",
        "coordenadaY": "220.561",
        "sillaInicio": true,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7033,
        "colorId": 0,
        "numero": "08-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2180.34",
        "coordenadaY": "234.413",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7034,
        "colorId": 0,
        "numero": "09-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2241.29",
        "coordenadaY": "249.186",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7035,
        "colorId": 0,
        "numero": "10-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2305.93",
        "coordenadaY": "269.501",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7036,
        "colorId": 0,
        "numero": "11-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2368.72",
        "coordenadaY": "284.276",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    },
    {
        "sillaId": 7037,
        "colorId": 0,
        "numero": "12-T",
        "idVarianteShopify": "50599444644123",
        "idVarianteShopifyNino": "51305775235355",
        "area": "Movilidad Reducida Experience",
        "areaId": 8,
        "nombreFila": "T",
        "cantidadSillas": 19,
        "color": "#0083FE",
        "coordenadaX": "2429.66",
        "coordenadaY": "301.821",
        "sillaInicio": false,
        "sillaFin": false,
        "precioDolar": 99,
        "precioDolarNinos": 0,
        "precioDolarLocal": 35,
        "precioDolarLocalNinos": 0,
        "precioDolarEspecial": 40,
        "Fila": "\u0000",
        "NumeroEnFila": 0,
        "Segmento": 0
    }
];
//FIN JSON SILLAS

const COLOR_SILLA_VENDIDA = "#e8e8e8";
const mapaEl = document.getElementById("contenedorMapa");
const FACTOR_TOLERANCIA_SALTO = 2;
const inputFecha = document.getElementById("dateInput");
const getCarrito = document.getElementById("getCarrito");
let asientosReserva = [];
let elementobase = [];
let jsonSillasOcupadas = [];
let areaResumen
let todasLasSillas = sillasTotal

// 🔹 Crear SVG dinámicamente (versión universal PC + móviles)
async function createSVG(zona) {
  try {
    const width = 2700;
    const height = 1500;
    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("id", "graderia");
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    svg.innerHTML = "";

    if (!zona) zona = "";

    let grupo = null;
    let filaActual = null;

    // Crear cada silla como un <circle>
    sillasTotal.forEach((item, index) => {
      const esNuevoGrupo = index === 0 || item.area !== sillasTotal[index - 1].area;
      if (esNuevoGrupo) {
        grupo = document.createElementNS(svgNS, "g");
        grupo.classList.add("contenedor-area");
        grupo.setAttribute("data-region", item.area);
        svg.appendChild(grupo);
      }

      const circle = document.createElementNS(svgNS, "circle");
      circle.setAttribute("data-position", "1");
      circle.setAttribute("data-silla-id", item.sillaId);
      circle.setAttribute("data-numberbd", item.numero);
      circle.setAttribute("data-area", item.area);

      // Validar zona seleccionada
      const zonasValidas = Array.isArray(zona) ? zona : (zona ? [zona] : []);
      const pertenece = zonasValidas.includes(Number(item.areaId));
      if (!pertenece) circle.classList.add("ocupada");

      // Coordenadas y precios
      circle.setAttribute("cx", item.coordenadaX);
      circle.setAttribute("cy", item.coordenadaY);
      //circle.setAttribute("precio", item.precio);
      //circle.setAttribute("precioNinos", item.precioNinos);
      //circle.setAttribute("precioLocal", item.precioLocal);
      //circle.setAttribute("precioLocalNinos", item.precioLocalNinos);      
      circle.setAttribute("precioDolar", item.precioDolar);
      circle.setAttribute("precioDolarNinos", item.precioDolarNinos);
      circle.setAttribute("precioDolarLocal", item.precioDolarLocal);
      circle.setAttribute("precioDolarLocalNinos", item.precioDolarLocalNinos);
      circle.setAttribute("precioDolarEspecial", item.precioDolarEspecial);
      circle.setAttribute("idVariant", item.idVarianteShopify);

      // Mantener tus variantes exactas
      if (item.idVarianteShopify == "49320688648475") { // EXPERIENCE
        circle.setAttribute("idVariantLocal", "50955643355419");
        circle.setAttribute("idVariantSpecial", "51123668910363");
        circle.setAttribute("idVariantNinos", "51305761964315");
        circle.setAttribute("idVariantLocalNinos", "51305771467035");
      } else if (item.idVarianteShopify == "49320688615707") { // PREFERENCE
        circle.setAttribute("idVariantLocal", "50955644829979");
        circle.setAttribute("idVariantSpecial", "51123668943131");
        circle.setAttribute("idVariantNinos", "51305771401499");
        circle.setAttribute("idVariantLocalNinos", "51305771499803");        
      } else if (item.idVarianteShopify == "49320688681243") { // PREMIUM
        circle.setAttribute("idVariantLocal", "50955644862747");
        circle.setAttribute("idVariantSpecial", "51123668975899");
        circle.setAttribute("idVariantNinos", "51305771434267");
        circle.setAttribute("idVariantLocalNinos", "51305771532571");        
      } else if (item.idVarianteShopify == "50599444644123") { // REDUCIDA
        circle.setAttribute("idVariantLocal", "50955644895515");
        circle.setAttribute("idVariantSpecial", "51123669008667");
        circle.setAttribute("idVariantNinos", "51305775235355");
        circle.setAttribute("idVariantLocalNinos", "51305775268123");        
      }

      // Estilo visual
      circle.setAttribute("r", "12");
      circle.setAttribute("fill", item.color || "#cccccc");
      circle.setAttribute("data-original-fill", item.color || "#cccccc");
      circle.setAttribute("data-area-id", item.areaId);
      grupo.appendChild(circle);

      // --- Texto con número de silla ---
      const numSilla = (item.numero || "").split("-")[0];
      const textNum = document.createElementNS(svgNS, "text");
      textNum.setAttribute("x", item.coordenadaX);
      textNum.setAttribute("y", item.coordenadaY);
      textNum.setAttribute("text-anchor", "middle");
      textNum.setAttribute("dy", ".35em");
      textNum.setAttribute("font-size", "14px");
      textNum.setAttribute("font-weight", "bold");
      textNum.setAttribute("fill", "#fff");
      textNum.setAttribute("pointer-events", "none");
      textNum.textContent = numSilla;
      grupo.appendChild(textNum);

      // --- Texto con letra de fila ---
      const fila = (item.numero || "").split("-")[1];
      if (fila !== filaActual) {
        filaActual = fila;
        const textFila = document.createElementNS(svgNS, "text");
        textFila.setAttribute("x", parseFloat(item.coordenadaX) - 30);
        textFila.setAttribute("y", parseFloat(item.coordenadaY) + 10);
        textFila.setAttribute("font-size", "15px");
        textFila.setAttribute("font-weight", "bold");
        textFila.setAttribute("fill", "#000");
        textFila.setAttribute("pointer-events", "none");
        textFila.textContent = fila;
        grupo.appendChild(textFila);
      }
    });

    // Insertar SVG
    const contenedorMapa = document.getElementById("contenedorMapa");
    contenedorMapa.innerHTML = ""; // limpiar si ya existía
    contenedorMapa.appendChild(svg);

    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // DIBUJAR "ARENA PANACA" (antes del fit/center para incluirlo)
    dibujarArenaPanaca(svg);
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

    // --- Detección de dispositivo ---
    const esMovil = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
      || (navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

    // --- Configuración panZoom ---
    const panZoom = svgPanZoom(svg, {
      zoomEnabled: true,
      controlIconsEnabled: false,
      fit: true,
      center: true,
      mouseWheelZoomEnabled: !esMovil,
      dblClickZoomEnabled: false,
      preventMouseEventsDefault: true,
      zoomScaleSensitivity: 0.3,
      minZoom: 1.2,
      maxZoom: 7,
      beforePan: function (oldPan, newPan) {
        const sizes = this.getSizes();
        const leftLimit = -((sizes.viewBox.width * sizes.realZoom) - sizes.width);
        const topLimit = -((sizes.viewBox.height * sizes.realZoom) - sizes.height);
        const rightLimit = 0;
        const bottomLimit = 0;
        return {
          x: Math.max(leftLimit, Math.min(rightLimit, newPan.x)),
          y: Math.max(topLimit, Math.min(bottomLimit, newPan.y))
        };
      }
    });

    // --- Deshabilitar gestos nativos del SVG ---
    svg.style.touchAction = 'none';
    svg.addEventListener('gesturestart', e => e.preventDefault());
    svg.addEventListener('gesturechange', e => e.preventDefault());
    svg.addEventListener('gestureend', e => e.preventDefault());

    // --- Pinch-to-zoom manual (móvil) ---
    if (esMovil) {
      let estadoInicial = null;
      const MIN_ZOOM = 1.0;
      const MAX_ZOOM = 7;

      svg.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault();
          e.stopPropagation();
          const [touch1, touch2] = [e.touches[0], e.touches[1]];
          estadoInicial = {
            distancia: Math.hypot(touch1.clientX - touch2.clientX, touch1.clientY - touch2.clientY),
            zoom: panZoom.getZoom()
          };
        }
      }, { passive: false });

      svg.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2 && estadoInicial) {
          e.preventDefault();
          e.stopPropagation();
          const [touch1, touch2] = [e.touches[0], e.touches[1]];
          const distanciaActual = Math.hypot(touch1.clientX - touch2.clientX, touch1.clientY - touch2.clientY);
          const escala = distanciaActual / estadoInicial.distancia;
          let nuevoZoom = estadoInicial.zoom * escala;
          nuevoZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, nuevoZoom));
          try { panZoom.zoom(nuevoZoom); } catch (err) { console.log("Error zoom:", err); }
        }
      }, { passive: false });

      svg.addEventListener('touchend', (e) => {
        if (e.touches.length < 2) estadoInicial = null;
      }, { passive: false });
    }

    window.svgPanZoomInstance = panZoom;

    // Centrar + fit DESPUÉS de todo (incluida la Arena)
    setTimeout(() => {
      panZoom.resize();
      panZoom.fit();
      panZoom.center();
    }, 300);

  } catch (error) {
    console.error("Error cargando escenario:", error);
  }
  showSubTotal();
}

// =============================
// Arena PANACA (integrada)
// =============================
function dibujarArenaPanaca(svg) {
  const existente = svg.querySelector("#arena-panaca");
  if (existente) existente.remove();

  const ns = "http://www.w3.org/2000/svg";
  const g = document.createElementNS(ns, "g");
  g.setAttribute("id", "arena-panaca");
  g.setAttribute("pointer-events", "none"); // no tapa clics

  const path = document.createElementNS(ns, "path");
  path.setAttribute("d", `
    M 325 2199
    Q 1366 1820 2375 2199
    L 2375 2270
    L 325 2270
    Z`);
  path.setAttribute("fill", "#ebd9ba");
  g.appendChild(path);

  const text = document.createElementNS(ns, "text");
  text.setAttribute("text-anchor", "middle");
  text.setAttribute("dominant-baseline", "middle");
  text.setAttribute("fill", "#000");
  text.setAttribute("font-size", "70px");
  text.setAttribute("font-weight", "700");
  text.setAttribute("font-family", "EuclidBold");
  text.textContent = "Arena PANACA";
  g.appendChild(text);

  // Asegura viewBox válido
  if (!svg.viewBox.baseVal || svg.viewBox.baseVal.width === 0) {
    const r = svg.getBoundingClientRect();
    svg.setAttribute("viewBox", `0 0 ${Math.max(1, r.width)} ${Math.max(1, r.height)}`);
  }
  svg.appendChild(g);

  // Posicionamiento del texto dentro del arco (antes de transformar el grupo)
  const bb = path.getBBox();
  const baseY = bb.y + bb.height;
  const cx = bb.x + bb.width / 2;
  text.setAttribute("x", cx);
  text.setAttribute("y", baseY - 110);

  // Transformación (mantengo tu matriz exacta)
  g.setAttribute("transform", `matrix(${1},0,0,${1},${0.878},${-740.566})`);
}



function deshabilitarSillasVendidas(sillasVendidas) {
  const svg = document.getElementById('graderia');
  if (!svg) return;

  const vendidasMap = new Set(sillasVendidas.map(s => String(s.sillaId)));

  // Actualizar solo si realmente cambia algo
  svg.querySelectorAll('circle').forEach(c => {
    const id = c.getAttribute('data-silla-id');
    const yaVendida = c.classList.contains('vendida');
    const debeSerVendida = vendidasMap.has(id);

    if (debeSerVendida && !yaVendida) {
      c.setAttribute("fill", COLOR_SILLA_VENDIDA);
      c.setAttribute("cursor", "not-allowed");
      c.classList.add("vendida");
      c.setAttribute("disabled", "true");
    } else if (!debeSerVendida && yaVendida) {
      c.setAttribute("fill", c.getAttribute("data-original-fill"));
      c.classList.remove("vendida");
      c.removeAttribute("disabled");
    }
  });
}

// Hacer que los toques en mobile disparen el mismo evento click
if ('ontouchstart' in window) {
    mapaEl.addEventListener("touchend", function (evento) {
        // Simular el mismo comportamiento del clic si el usuario tocó un círculo
        const touch = evento.changedTouches[0];
        const target = document.elementFromPoint(touch.clientX, touch.clientY);
        if (target && target.tagName.toLowerCase() === "circle") {
            target.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
        }
    });
}

function quitarCeroInicial(fechaFormat) {
    if (!fechaFormat) return fechaFormat;
    return fechaFormat[0] === '0' ? fechaFormat.slice(1) : fechaFormat;
}

const $loader = document.getElementById('loader');

getCarrito.addEventListener("click", async () => {
    // ===== VALIDACIÓN: TRANSPORTE SELECCIONADO PERO NO CONFIRMADO =====
    const includesTransport = document.getElementById('includesTransport');
    const visitorType = sessionStorage.getItem('visitorType');
    const esResidente = visitorType === 'resident';

    // Solo validar para turistas (residentes no tienen transporte)
    if (!esResidente && includesTransport && includesTransport.checked && !window.transportConfirmed) {
      $loader.style.display = "none";
      Swal.fire({
        icon: 'warning',
        title: 'Debes confirmar el transporte',
        html: 'Has seleccionado el transporte pero no has completado la selección de horario. Por favor selecciona un horario e haz click en "Confirmar".',
        confirmButtonText: 'Entendido'
      });
      return; // Detener el checkout
    }

    // Resetear el estado de transporte confirmado para próxima compra
    window.transportConfirmed = false;

    if ($loader) $loader.style.display = "flex";
    let checkBoxResidente = document.getElementById("checkBoxResidente").checked;

    let products = [];
    let sillas = ""
    let sillasDisplay = ""  // números de silla como "01-A, 02-B" para mostrar en checkout
    let sillasSeleccionadas = document.querySelectorAll('.seleccionada')

    // ============================================
    //  PLAZA/FIESTA: Productos sin silletería
    // ============================================
    // Obtener el tipo de producto con fallback a sessionStorage o ticketSelected
    // Usar globalThis para acceso confiable desde módulo
    const ticketSelectedProductType = (globalThis.ticketSelectedProductType || globalThis.ticketSelected || window.ticketSelected) || parseInt(sessionStorage.getItem('ticketSelectedProductType') || '0', 10);
    const esPlazaOFiesta = ticketSelectedProductType === 6 || ticketSelectedProductType === 7;

    
    // 🔴 ==== CÓDIGO DE DEPURACIÓN - PONER AQUÍ ==== 🔴
    console.log('=== CHECKOUT DEBUG ===');
    console.log('🟢 Product type:', ticketSelectedProductType);
    console.log('🟢 esPlazaOFiesta:', esPlazaOFiesta);
    console.log('🟢 jsonReservas antes:', jsonReservas);
    console.log('🟢 jsonTransporte antes:', jsonTransporte);
    console.log('🟢 includesTransport checked:', document.getElementById('includesTransport')?.checked);
    console.log('🟢 window._currentPlace:', window._currentPlace);
    console.log('🟢 window.horarioId:', window.horarioId);
    console.log('🟢 HORARIOS disponibles:', typeof HORARIOS !== 'undefined' ? HORARIOS : 'No definido');



    // For Plaza/Fiesta, skip seat validation and use hardcoded variant IDs
    if (esPlazaOFiesta) {
        // Variant IDs hardcoded for Plaza Herencia (7) and Fiesta Dominicana (6)
        const PLAZA_VARIANTS = {
            adultoIntl: 50542490583323,
            adultoLocal: 51053911933211,
            ninoIntl: 52327499399451,
            ninoLocal: 52327499432219,
            adultoIntlUS:25,
            adultoLocalUS:10,
            ninoIntlUS:15,
            ninoLocalUS:10
        };
        const FIESTA_VARIANTS = {
            adultoIntl: 50542557135131,
            adultoLocal: 50992478912795,
            ninoIntl: 52327636009243,
            ninoLocal: 52327636042011,
            adultoIntlUS:25,
            adultoLocalUS:10,
            ninoIntlUS:15,
            ninoLocalUS:10
        };

        const VARIANTS = ticketSelectedProductType === 7 ? PLAZA_VARIANTS : FIESTA_VARIANTS;

        const qtyAdult = parseInt(
            String(
                document.getElementById('qty-cart')?.value ??
                document.getElementById('qty-cart')?.textContent ??
                "0"
            ).trim(),
        10) || 0;

        const qtyNino = parseInt(
            String(
                document.getElementById('qty-cart-child')?.value ??
                document.getElementById('qty-cart-child')?.textContent ??
                "0"
            ).trim(),
        10) || 0;

        const totalPax = qtyAdult + qtyNino;

        if (totalPax === 0) {
            $loader.style.display = "none"
            Swal.fire({
                title: 'Debes seleccionar al menos un ticket.'
            });
            return;
        }

        // Format date — computed before products so it can be added as line-item property
        let fechaValor = document.getElementById("dateInput").value;
        const [m, d, y] = fechaValor.split("/");
        fechaValor = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;

        // Adult products
        if (qtyAdult > 0) {
            const precioUsd = checkBoxResidente ? VARIANTS.adultoLocalUS : VARIANTS.adultoIntlUS; // Precio adulto USD
            const precioTotalUsd = (qtyAdult * precioUsd).toFixed(2);
            products.push({
                id: checkBoxResidente ? VARIANTS.adultoLocal : VARIANTS.adultoIntl,
                quantity: qtyAdult,
                properties: {
                    note: 'Ticket sin silletería',
                    'Precio USD': `$${precioTotalUsd}`,
                    'Fecha': fechaValor,
                    '_DiscountEligibility': `${(checkBoxResidente ? VARIANTS.adultoLocal : VARIANTS.adultoIntl)}|${fechaValor}`
                }
            });
        }

        // Child products
        if (qtyNino > 0) {
            const precioUsd = checkBoxResidente ? VARIANTS.ninoLocalUS : VARIANTS.ninoIntlUS; // Precio adulto USD
            const precioTotalUsd = (qtyNino * precioUsd).toFixed(2);
            products.push({
                id: checkBoxResidente ? VARIANTS.ninoLocal : VARIANTS.ninoIntl,
                quantity: qtyNino,
                properties: {
                    note: 'Ticket sin silletería',
                    'Precio USD': `$${precioTotalUsd}`,
                    'Fecha': fechaValor,
                    '_DiscountEligibility': `${(checkBoxResidente ? VARIANTS.ninoLocal : VARIANTS.ninoIntl)}|${fechaValor}`
                }
            });
        }

        // Generate token (no seat reservation needed, just date-based)
        const fechaActual = new Date();
        const año = fechaActual.getFullYear();
        const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
        const dia = String(fechaActual.getDate()).padStart(2, '0');
        const horas = String(fechaActual.getHours()).padStart(2, '0');
        const minutos = String(fechaActual.getMinutes()).padStart(2, '0');
        const segundos = String(fechaActual.getSeconds()).padStart(2, '0');
        const fechaCompleta = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;

        const token = await generarTokenUnico(fechaCompleta + fechaValor + ticketSelectedProductType, 22);

        // Shopify flow
        await clearCart();

        for (const p of products) {
            await addToCart([p], fechaValor);
        }

        if (document.getElementById('includesTransport').checked) {
            // Para Fiesta/Plaza y Travesía: verificar si hay datos de transporte seleccionados
            const tieneDatosTransporte = window._currentPlace && window._currentPlace.id;

            if (tieneDatosTransporte) {
                // Transporte con selección de ubicación/horario (aplica para todos los tipos)
                window.jsonReservas.token = token;  // Agregar el token generado

                if (window.jsonTransporte) {
                    window.jsonTransporte.quantity = qtyAdult + qtyNino;
                } else {
                    window.jsonTransporte = {
                        id: Number(document.getElementById('map-container')?.dataset.variantRuta6) || 51214082769179,
                        quantity: qtyAdult + qtyNino
                    };
                }

                // Call global function from como-llegar-map.js
                try {
                    console.log('jsonTransporte before add:', window.jsonTransporte);
                    if (typeof window.addTicketToCart === 'function') {
                        await window.addTicketToCart(window.jsonTransporte);
                    } else {
                        if (window.jsonTransporte) {
                          window.jsonTransporte.properties = {
                            'Transporte': window.transporteNoteInfo || `Fecha: ${fechaValor} \n Ruta: Incluido`
                          };
                        }
                        await addToCart([window.jsonTransporte], fechaValor);
                    }
                } catch (err) {
                    console.error('Error adding transport:', err);
                    console.error('Transport variant ID:', window.jsonTransporte?.id);
                    $loader.style.display = "none";
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al agregar el transporte. Intente de nuevo. Variant ID: ' + window.jsonTransporte?.id
                    });
                    return;
                }
            } else {
                // No hay datos de ubicación - advertencia
                // Solo mostrar advertencia si no es residente (residentes no tienen transporte)
                const visitorType = sessionStorage.getItem('visitorType');
                if (visitorType !== 'resident') {
                    document.getElementById('includesTransport').checked = false;
                    $loader.style.display = "none";
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Debes seleccionar una ubicación y horario para el transporte',
                            confirmButtonText: 'Entendido'
                        });
                    }
                }
            }
        }
        $loader.style.display = "none";
        location.href = "/cart?finish&note=" + fechaValor + "&token=" + token;
        return;
    }

    // ============================================
    //  TRAVESÍA: Productos con silletería (original logic)
    // ============================================

    if (sillasSeleccionadas.length === 0) {
        $loader.style.display = "none"
        Swal.fire({
            title: 'Por favor selecciona un asiento.'
        });
        return
    }

    const qtyAdult = parseInt(
        String(
            document.getElementById('qty-cart')?.value ??
            document.getElementById('qty-cart')?.textContent ??
            "0"
        ).trim(),
    10) || 0;

    const qtyNino = parseInt(
        String(
            document.getElementById('qty-cart-child')?.value ??
            document.getElementById('qty-cart-child')?.textContent ??
            "0"
        ).trim(),
    10) || 0;


    const totalPax = qtyAdult + qtyNino;

    if (totalPax !== sillasSeleccionadas.length) {
        $loader.style.display = "none";
        Swal.fire({
            title: 'La cantidad seleccionada no coincide con los asientos.',
            text: `Adultos: ${qtyAdult}, Niños: ${qtyNino}, Asientos: ${sillasSeleccionadas.length}`
        });
        return;
    }

    // ===============================
    //   DEFINIR VARIANTS
    // ===============================
    let idVariantAdult;
    let idVariantNino;
    let adultoIntlUS;
    let adultoLocalUS;
    let ninoIntlUS;
    let ninoLocalUS;



    const esEspecial = (dateInput.value == fechaEspecial);
    // ADULTOS
    if (checkBoxResidente) {
        idVariantAdult = sillasSeleccionadas[0].getAttribute('idVariantLocal');
        adultoLocalUS= sillasSeleccionadas[0].getAttribute('precioDolarLocal');
    } else if (esEspecial) {
        idVariantAdult = sillasSeleccionadas[0].getAttribute('idVariantSpecial');
    } else {
        idVariantAdult = sillasSeleccionadas[0].getAttribute('idVariant');
        adultoIntlUS= sillasSeleccionadas[0].getAttribute('precioDolar');

    }

    // NIÑOS
    if (checkBoxResidente) {
        idVariantNino = sillasSeleccionadas[0].getAttribute('idVariantLocalNinos');
        ninoLocalUS= sillasSeleccionadas[0].getAttribute('precioDolarLocalNinos');

    } else if (esEspecial) {
        idVariantNino = sillasSeleccionadas[0].getAttribute('idVariantSpecialNinos');
    } else {
        idVariantNino = sillasSeleccionadas[0].getAttribute('idVariantNinos');
        ninoIntlUS= sillasSeleccionadas[0].getAttribute('precioDolarNinos');

    }

    // ===============================
    //   ARMAR LISTA DE SILLAS
    // ===============================
    // sillas  → IDs numéricos (sillaId) → va a la API de PanacaPos via reservarSillas()
    // sillasDisplay → números alfanuméricos (numero, ej. "01-A") → se muestra en el checkout
    for (let i = 0; i < sillasSeleccionadas.length; i++) {
        let sillaId = sillasSeleccionadas[i].getAttribute('data-silla-id') + ", ";
        let sillaNumero = sillasSeleccionadas[i].getAttribute('data-numberbd') + ", ";
        sillas += sillaId;
        sillasDisplay += sillaNumero;
    }

    // ===============================
    //   FORMATO FECHA — computed before products so it can be added as line-item property
    // ===============================
    let fechaValor = document.getElementById("dateInput").value;
    const [m, d, y] = fechaValor.split("/");
    fechaValor = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;

    // ===============================
    //   PRODUCTO ADULTOS
    // ===============================
    if (qtyAdult > 0) {
        const precioUsd = checkBoxResidente ? adultoLocalUS : adultoIntlUS; // Precio adulto USD
        const precioTotalUsd = (qtyAdult * precioUsd).toFixed(2);

        products.push({
            id: idVariantAdult,
            quantity: qtyAdult,
            properties: { note: `Sillas: ${sillasDisplay}`,
                          'Precio USD': `$${precioTotalUsd}`,
                          'Fecha': fechaValor,
                      '_DiscountEligibility': `${idVariantAdult}|${fechaValor}`
            }
        });
    }

    // ===============================
    //   PRODUCTO NIÑOS
    // ===============================
    if (qtyNino > 0) {
        const precioUsd = checkBoxResidente ? ninoLocalUS : ninoIntlUS; // Precio adulto USD
        const precioTotalUsd = (qtyNino * precioUsd).toFixed(2);
        products.push({
            id: idVariantNino,
            quantity: qtyNino,
            properties: { note: `Sillas: ${sillasDisplay}`,
                          'Precio USD': `$${precioTotalUsd}`,
                          'Fecha': fechaValor,
                      '_DiscountEligibility': `${idVariantNino}|${fechaValor}`
            }
        });
    }

    // ===============================
    //  RESERVA BACKEND
    // ===============================
    let token = await reservarSillas(sillas, fechaValor);

    if (token === null) {
        $loader.style.display = "flex"
        return;
    }

    // ===============================
    //  FLUJO SHOPIFY
    // ===============================

    await clearCart();

    // AGREGAR PRODUCTOS (adultos + niños)
    for (const p of products) {
        await addToCart([p], fechaValor);
    }

    
    if(document.getElementById('includesTransport').checked){
        jsonReservas.token = token;

        // El note con información del transporte ya se construye en showSubTotalTransporte() en como-llegar-map.js
        await addTicketToCart(jsonTransporte);
    }
    location.href = "/cart?finish&note=" + fechaValor + "&token=" + token;
});



 async function addToCart(items, fecha) {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "items": items, "note": fecha })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const json = await response.json();

        // Validación de error cuando el producto está agotado
        if (json.status === 422) {
            Swal.fire({
                title: 'Producto agotado.'
            });
        } else {
            // Redirección opcional al carrito (comentada)
            // window.location.replace('/cart');
        }

    } catch (error) {
        throw error;
    }
}

async function generarTokenUnico(input, length = 22) {
    const enc = new TextEncoder();
    const data = enc.encode(input);

    // Hash SHA-256
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Pasar a base64
    const hashBytes = new Uint8Array(hashBuffer);
    let b64 = btoa(String.fromCharCode(...hashBytes));

    // Hacerlo URL-safe y quitar "="
    let b64url = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    // Recortar a la longitud pedida
    return b64url.slice(0, length);
}

async function reservarSillas(sillas, fecha) {
    let fechaActual = new Date();

    // Crear timestamp completo
    let año = fechaActual.getFullYear();
    let mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
    let dia = String(fechaActual.getDate()).padStart(2, '0');
    let horas = String(fechaActual.getHours()).padStart(2, '0');
    let minutos = String(fechaActual.getMinutes()).padStart(2, '0');
    let segundos = String(fechaActual.getSeconds()).padStart(2, '0');
    let fechaCompleta = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;

    // Quitar coma(s) final
    const sinComaFinal = sillas.replace(/(?:,\s*)+$/, '');

    // Split y a enteros
    const sillasInt = sinComaFinal
        .split(',')
        .map(s => Number(s.trim()))
        .filter(Number.isFinite);

    // Crear token completo
    let tokenCompleto = fechaCompleta + fecha + sillas;

    // Generar versión corta y única
    const token = await generarTokenUnico(tokenCompleto, 22);

    // Construir cuerpo de la petición
    const body = JSON.stringify({
        SillasID: sillasInt,
        Fecha: fecha,
        TipoPasaporte: 'voucherPortalID',
        OrdenID: token,
        EventoID: 1,
    });

    try {
        let response = await fetch('https://grupopanaca.com.do/escenarioAPI/api/ReservasSillas/RegistrarSillasShopify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body,
        });

        let data = await response.text();

        if (data.includes('ocupadas')) {
            Swal.fire({
                icon: "error",
                title: "Las sillas seleccionadas ya están ocupadas."
            });
            return null;
        }

        if (!response.ok) {
            Swal.fire({
                icon: "error",
                title: "Ocurrió un error realizando la reserva."
            });
            return null;
        }
    } catch (error) {
        console.error('Error al realizar la solicitud:', error);
        return null;
    }

    return token;
}

  async function clearCart() {
    return await fetch('/cart/clear.js', { method: 'POST' })
        .then((response) => {
            if (!response.ok) throw new Error('Error al limpiar el carrito');
            return response.json();
        })
        .then((data) => {
            return true; // Confirmamos que se limpió correctamente
        })
        .catch((error) => {
            console.error('Error al limpiar el carrito:', error);
            return false; // En caso de error, retornamos false
        });
}

document.getElementById("loadSillas").addEventListener("click", (e) => {
    
    createSVG(ticketSelected)
    setTimeout(() => {
        getSillasOcupadas();
    }, 500);
    setTimeout(() => {
        zoomToZona(ticketSelected);
        seleccionarSillasAleatorias();
    }, 200);

})

document.getElementById("closeEscenario").addEventListener("click", (e) => {
    // Reset checkboxes when closing the purchase modal
    const checkBoxResidente = document.getElementById('checkBoxResidente');
    if (checkBoxResidente) checkBoxResidente.checked = false;
    const includesTransport = document.getElementById('includesTransport');
    if (includesTransport) includesTransport.checked = false;

    // Reset transport state completely
    if (typeof resetTransportState === 'function') {
        resetTransportState();
    }

    // Los términos permanecen aceptados durante la sesión
    // El botón mantiene su estado (habilitado si ya aceptó)
    // No resetiamos sessionStorage.termsAccepted

    document.getElementById("container-compra-ahora").style.display = "none";
    document.getElementById("container-compra-ahora").style.zIndex = "";
    document.getElementById("container-buttons").style.display = "none";
    document.getElementById("container-buttons").style.zIndex = "";
    document.getElementById('btn-buy-header').style.display = "flex"
    document.body.style.overflow = 'auto';
})
// 🔹 Función para calcular el precio según la lógica
function calcularPrecio(silla) {
    let precio
    let notaFechaUrl = document.getElementById("dateInput").value; // "10/4/2025"
    const [mm, dd, yyyy] = notaFechaUrl.split("/").map(n => parseInt(n, 10));
    const esMenor = new Date(yyyy, mm - 1, dd) < new Date(new Date().getFullYear(), 11, 31)
    if (document.getElementById("dateInput").value === fechaEspecial) {
        precio = "<p class='raya'>$ " + silla.precioDolar + "</p>" + "$ " + silla.precioDolarEspecial
    } else if (document.getElementById("checkBoxResidente").checked) {
        if (esMenor) {
            precio = "<p class='raya'>$ " + silla.precioDolarLocal + "</p>" + "$ " + Math.floor(Number(silla.precioDolarLocal) * 0.5)
        } else {
            precio = "<p class='raya'>$ " + silla.precioDolar + "</p>" + "$ " + silla.precioDolarLocal
        }
    } else {
        if (esMenor) {
            precio = "<p class='raya'>$ " + silla.precioDolar + "</p>" + "$ " + Math.floor(Number(silla.precioDolar) * 0.5)
        } else {
            precio = "$ " + silla.precioDolar
        }
    }

    return precio
}
 // 🔹 Función para agregar un nuevo <span> con el precio
function agregarPrecioEnSpan(elemento, precio) {
    const ultimo = elemento.lastElementChild // obtiene el último hijo tipo elemento

    // 🔹 Si el último hijo es un <span>, elimínalo
    if (ultimo && ultimo.tagName.toLowerCase() === "p") {
        elemento.removeChild(ultimo)
    }

    // 🔹 Agregar el nuevo <span> con el precio actualizado
    const nuevoSpan = document.createElement("p")
    nuevoSpan.innerHTML = `${precio}`
    elemento.appendChild(nuevoSpan)
}
 // 🔹 Función para calcular el sub total de los items seleccionados y mostrarlos





 // 🔹 Función para alertar al usuario condiciones de residente
document.getElementById('checkBoxResidente').addEventListener("click", (e) => {
    if (document.getElementById('checkBoxResidente').checked) {
        Swal.fire({
            icon: 'info',
            title: 'Ten en cuenta',
            text: 'Cuando llegues a nuestras taquillas, recuerda presentar tu documento de identidad dominicano. Es indispensable para validar tu nacionalidad y redimir tus entradas.',
        });
    }
    showSubTotal()
    showSubTotalTransporte();
})
// 🔹 Función para mostrar las sillas de las zonas seleccionadas
document.querySelectorAll('.checkPassports').forEach(el => {
    el.addEventListener('click', async (e) => {
    const areaSeleccionada = parseInt(e.target.id, 10); // convertir a número
    const idSeleccionado = areaSeleccionada;
  // 🔹 Mapeo de IDs a nombres
  let nombreZona = "";
  switch (Number(idSeleccionado)) {
    case 6:
      nombreZona = "fiesta";
      break;
    case 7:
      nombreZona = "herencia";
      break;
    case 8:
      nombreZona = "Experience";
      break;
    case 9:
      nombreZona = "Preferred";
      break;
    case 10:
      nombreZona = "Premium";
      break;
    default:
      nombreZona = ""; // por si no coincide
      break;
  }

  // 🔹 Formateo final (primera letra mayúscula, resto minúsculas)
  let ticketSelectedShow = nombreZona
    ? nombreZona.charAt(0).toLocaleUpperCase('es-ES') + nombreZona.slice(1).toLocaleLowerCase('es-ES')
    : "";

  // 🔹 Mostrar o usar el valor
 
  document.getElementById('primero').innerHTML = "Travesía "+ticketSelectedShow;
    document.querySelectorAll('.seleccionada').forEach(el => {
    el.classList.remove('seleccionada');
    showSubTotal()
    });

    const qtyStart = document.getElementById(`${ticketSelected}-qty`).value
    ticketSelected = areaSeleccionada; // ✅ asignar el id al ticket seleccionado
    const qtyElement = document.getElementById(`${ticketSelected}-qty`);
    qtyElement.value = qtyStart
    qtyElement.textContent = qtyStart
    // 🔹 Desmarcar otros checkboxes y liberar sillas
    document.querySelectorAll('.checkPassports').forEach(chk => {
      if (chk !== e.target) chk.checked = false;
    });

    // 🔹 Bloquear todas las sillas
    document.querySelectorAll('circle').forEach(silla => silla.classList.add('ocupada'));

    // 🔄 Determinar si hay zona complementaria
    let otraZona = 0;
    if (areaSeleccionada === 8) otraZona = 11;
    if (areaSeleccionada === 11) otraZona = 8;

    // 🔹 Si el checkbox fue marcado, mostrar las sillas de esa zona (y su complementaria)
    if (e.target.checked) {
      document.querySelectorAll(`circle[data-area-id="${areaSeleccionada}"], circle[data-area-id="${otraZona}"]`)
        .forEach(el => el.classList.remove('ocupada'));

      // 🔍 Aplicar zoom a la zona seleccionada
      zoomToZona(areaSeleccionada);
    }

    // 🔹 Actualizar estado de sillas ocupadas desde servidor o fuente local
    await getSillasOcupadas();
    seleccionarSillasAleatorias();
  });
  
});

// 🔍 Función para hacer zoom al área seleccionada
function zoomToZona(areaID) {
    
  const MATRICES = {
    8: 'matrix(0.6506326794624329,0,0,0.6506326794624329,-333.2238464355469,-9.909611701965332)',
    9: 'matrix(0.8031419515609741,0,0,0.8031419515609741,-548.6098022460938,-254.73147583007812)',
    10:'matrix(0.8031419515609741,0,0,0.8031419515609741,-561.6096801757812,-607.7315673828125)'
  };

  const svg = document.getElementById('graderia');
  if (!svg) return;
  const viewport = svg.querySelector('.svg-pan-zoom_viewport');
  if (!viewport) return;

  const m = MATRICES[Number(areaID)];
  if (m) viewport.setAttribute('transform', m);
}

async function getSillasOcupadas() {
  let fechaValor = document.getElementById("dateInput").value;
  fechaValor = fechaValor.split("/")[2] + "-" + fechaValor.split("/")[0] + "-" + fechaValor.split("/")[1];

  if (!fechaValor) return;

  try {
    const respO = await fetch(
      `https://grupopanaca.com.do/escenarioAPI/api/ReservasSillas/SillasEventoOcupadas?fecha=${fechaValor}&evento=1`
    );
    const data = await respO.json();
    jsonSillasOcupadas = data;

    /*// 🧠 suspender momentáneamente el repintado
    requestAnimationFrame(() => {
        });*/
    deshabilitarSillasVendidas(jsonSillasOcupadas);
            showSubTotal()
  } catch (err) {
    console.error(err);
  } finally {
    
  }
}
document.addEventListener("DOMContentLoaded", () => {

    const includesT = document.getElementById('includesTransport');
    const routt = document.getElementById('trace-route');
    const map = document.getElementById('map-container');
    const sel = document.getElementById('container-select-location');
    const contenedor = document.querySelector('#container-filters');
    const transportePrice = document.getElementById('subTotalTransporte');


    // 🔥 Función de scroll correcta
    function scrollBottom() {
        contenedor.scrollTo({
            top: contenedor.scrollHeight,
            behavior: 'smooth'
        });
    }

    // 🔥 Forzar display y bottom con prioridad
    function showMap(bottomValue) {
        map.style.setProperty("display", "flex", "important");
        sel.style.setProperty("bottom", bottomValue, "important");
        transportePrice.style.setProperty("display", "flex", "important");
        scrollBottom();
    }

    function hideMap() {
        sel.style.setProperty("bottom", "0", "important");
        map.style.setProperty("display", "none", "important");
        transportePrice.style.setProperty("display", "none", "important");
    }

    // ============================
    //   CLICK EN includesTransport (backup listener)
    // ============================
    // NOTA: La lógica principal está en como-llegar-map.js para evitar problemas de scope entre módulos
    includesT.addEventListener("change", async () => {
        if (includesT.checked) {
            showMap("");
        } else {
            hideMap();
        }
    });

    // ============================
    //   CLICK EN trace-route
    // ============================
    routt.addEventListener("click", () => {
        if (includesT.checked) {
            showMap("");
        } else {
            hideMap();
        }
    });

});


document.getElementById('changeFecha').addEventListener('click',(e)=>{
     e.preventDefault();
    openCalendar(ticketSelected)
})

// ================== Helpers ==================
function parseSeat(el) {
  // data-numberbd="22-G" -> { num: 22, fila: 'G' }
  const nb = (el.getAttribute("data-numberbd") || "").trim();
  const [numStr, filaStr] = nb.split("-");
  return { num: parseInt(numStr, 10), fila: (filaStr || "").toUpperCase() };
}

function disponible(el) {
  return !el.classList.contains("vendida") && !el.classList.contains("ocupada");
}

function getQtyFromCart() {
  const el = document.getElementById("qty-cart");
  const elChild = document.getElementById("qty-cart-child");

  const qtyAdult = parseInt((el?.textContent || el?.value || "0").trim(), 10) || 0;
  const qtyChild = parseInt((elChild?.textContent || elChild?.value || "0").trim(), 10) || 0;

  return qtyAdult + qtyChild;
}


function byNumAsc(a, b) {
  return a.num - b.num;
}

// Runs de asientos contiguos por número (gap==1), sólo disponibles
function buildRunsDisponibles(rowSeats) {
  const disp = rowSeats.filter(s => disponible(s.el)).sort(byNumAsc);
  const runs = [];
  let cur = [];
  for (let i = 0; i < disp.length; i++) {
    if (!cur.length) { cur.push(disp[i]); continue; }
    const prev = cur[cur.length - 1];
    if (disp[i].num === prev.num + 1) {
      cur.push(disp[i]);
    } else {
      runs.push(cur);
      cur = [disp[i]];
    }
  }
  if (cur.length) runs.push(cur);
  return runs;
}

// Tomar bloque de N dentro de un run, centrado en pivotNum, evitando dejar resto de 1 (huérfana)
function pickBlockFromRunNoOrphans(run, N, pivotNum) {
  if (run.length < N) return [];

  // ventana centrada en el pivot
  let pivotIdx = 0, best = Infinity;
  for (let i = 0; i < run.length; i++) {
    const d = Math.abs(run[i].num - pivotNum);
    if (d < best) { best = d; pivotIdx = i; }
  }
  let start = Math.max(0, Math.min(pivotIdx - Math.floor((N - 1) / 2), run.length - N));

  const okNoOrphans = (st) => {
    const leftLen  = st;                      // elementos a la izquierda del bloque
    const rightLen = run.length - (st + N);   // … a la derecha
    return leftLen !== 1 && rightLen !== 1;   // no dejar exactamente 1
  };

  if (!okNoOrphans(start)) {
    // probar otras posiciones cercanas al pivot
    const candidates = [];
    for (let st = 0; st <= run.length - N; st++) {
      candidates.push({
        st,
        cost: Math.abs(run[st + Math.floor((N - 1) / 2)].num - pivotNum)
      });
    }
    candidates.sort((a, b) => a.cost - b.cost);
    let found = false;
    for (const c of candidates) {
      if (okNoOrphans(c.st)) { start = c.st; found = true; break; }
    }
    if (!found) return []; // no hay forma sin huérfanas en este run con N exacto
  }

  return run.slice(start, start + N);
}

// Absorber huérfana pegada (exactamente 1 asiento) permitiendo rebasar el tope de fila
function absorberHuerfana(run, bloque, maxFila = Infinity) {
  if (!run?.length || !bloque?.length) return bloque;

  const idxStart = run.findIndex(s => s === bloque[0]);
  if (idxStart < 0) return bloque;
  const idxEnd = idxStart + bloque.length - 1;

  const leftRem  = idxStart;                       // disponibles a la izquierda
  const rightRem = run.length - (idxEnd + 1);      // disponibles a la derecha

  // exactamente 1 a la izquierda
  if (leftRem === 1 && bloque.length < maxFila) {
    return run.slice(idxStart - 1, idxEnd + 1);
  }
  // exactamente 1 a la derecha
  if (rightRem === 1 && bloque.length < maxFila) {
    return run.slice(idxStart, idxEnd + 2);
  }
  return bloque;
}

// Igual que arriba, pero setea una bandera cuando se absorbió 1 silla
function absorberHuerfanaConFlag(run, bloque, maxFila, setFlag) {
  const antes = bloque?.length || 0;
  const despuesArr = absorberHuerfana(run, bloque, maxFila);
  if (despuesArr.length > antes) setFlag(); // se absorbió 1 silla
  return despuesArr;
}

// Orden de filas: base, luego vecinas alternando arriba/abajo
function filasVecinasOrdenadas(filasMap, filaBase) {
  const letras = Object.keys(filasMap).sort();
  const idx = letras.indexOf(filaBase);
  const orden = [];
  if (idx >= 0) orden.push(filaBase);
  let L = idx - 1, R = idx + 1;
  while (L >= 0 || R < letras.length) {
    if (L >= 0) orden.push(letras[L--]);
    if (R < letras.length) orden.push(letras[R++]);
  }
  return orden;
}

// Selección “cuadrado”: máximo 5 por fila (permite 6 sólo para absorber 1 huérfana)
function seleccionarCuadrado(filasMap, filaClic, numClic, cantidadSolicitada, onAbsorb) {
  const porFila = 10;
  const maxFilaConHuerfana = porFila + 1; // 6 al absorber
  let restante = cantidadSolicitada;
  const seleccion = [];
  const ordenFilas = filasVecinasOrdenadas(filasMap, filaClic);

  for (const fila of ordenFilas) {
    if (restante <= 0) break;

    const filaSeats = filasMap[fila] || [];
    if (!filaSeats.length) continue;

    const runs = buildRunsDisponibles(filaSeats);
    if (!runs.length) continue;

    let objetivo = Math.min(porFila, restante);

    // runs cerca del número clicado
    const candidatos = runs
      .map(run => ({
        run,
        dist: Math.min(
          Math.abs(run[0].num - numClic),
          Math.abs(run[run.length - 1].num - numClic)
        )
      }))
      .sort((a, b) => a.dist - b.dist);

    // 1) intentar objetivo exacto sin huérfanas
    let bloque = [];
    let runUsado = null;
    for (const c of candidatos) {
      const b = pickBlockFromRunNoOrphans(c.run, objetivo, numClic);
      if (b.length === objetivo) { bloque = b; runUsado = c.run; break; }
    }

    // 2) si no se pudo objetivo exacto, reducir (se completará en filas siguientes)
    if (!bloque.length) {
      for (let take = objetivo - 1; take >= 1; take--) {
        for (const c of candidatos) {
          const b = pickBlockFromRunNoOrphans(c.run, take, numClic);
          if (b.length === take) { bloque = b; runUsado = c.run; break; }
        }
        if (bloque.length) break;
      }
    }

    // 3) absorber huérfana (permitiendo 6 máximo en esta fila)
    if (runUsado && bloque.length) {
      bloque = absorberHuerfanaConFlag(runUsado, bloque, maxFilaConHuerfana, onAbsorb);
    }

    if (!bloque.length) continue;

    bloque.forEach(s => seleccion.push(s));
    restante -= bloque.length;
  }

  return seleccion.slice(0, cantidadSolicitada); // en modo cuadrado no permitimos rebasar el total
}

// ======================================================
// =============== CONFIGURACIÓN DISTANCIA ==============
// ======================================================
const MAX_DISTANCIA = 120; // AJUSTA SEGÚN TU MAPA

function distanciaSeats(a, b) {
  const ax = parseFloat(a.el.getAttribute("cx"));
  const ay = parseFloat(a.el.getAttribute("cy"));
  const bx = parseFloat(b.el.getAttribute("cx"));
  const by = parseFloat(b.el.getAttribute("cy"));
  return Math.hypot(ax - bx, ay - by);
}

function validarDistanciaSeleccion(lista, maxDist) {
  for (let i = 0; i < lista.length; i++) {
    for (let j = i + 1; j < lista.length; j++) {
      if (distanciaSeats(lista[i], lista[j]) > maxDist) {
        return false;
      }
    }
  }
  return true;
}

function seleccionarSillasAleatorias() {
  console.log("Auto selección disparada");

  const disponibles = Array.from(document.querySelectorAll("circle"))
    .filter(c => !c.classList.contains("ocupada"));

  if (!disponibles.length) {
    console.warn("No hay sillas disponibles");
    return;
  }

  const randomCircle =
    disponibles[Math.floor(Math.random() * disponibles.length)];

  console.log("Circle elegido:", randomCircle);

  randomCircle.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );
}


// ================== Handler principal ==================
mapaEl.addEventListener("click", (e) => {
  const target = e.target;
  if ((target.tagName || "").toLowerCase() !== "circle") return;
  ultimoCircle = target;
  const btn = document.getElementById("getCarrito");
  // Botón siempre habilitado (términos implícitos, transporte gestionado por actualizarEstadoBotonFinalizarCompra)
  if (btn) btn.disabled = false;

  const cantidadSolicitada = getQtyFromCart();
  if (cantidadSolicitada <= 0) return;

  const areaID = target.getAttribute("data-area-id");
  const { num: numClic, fila: filaClic } = parseSeat(target);

  // Limpiar selección previa
  document.querySelectorAll(".seleccionada").forEach(el => el.classList.remove("seleccionada"));

  // Sillas del área
  const allArea = Array.from(document.querySelectorAll(`circle[data-area-id="${areaID}"]`))
    .map(el => ({ el, ...parseSeat(el) }))
    .filter(s => Number.isFinite(s.num) && s.fila);

  if (!allArea.length) return;

  // Agrupar por fila
  const filasMap = allArea.reduce((acc, s) => { (acc[s.fila] ||= []).push(s); return acc; }, {});
  Object.values(filasMap).forEach(arr => arr.sort(byNumAsc));

  let seleccion = [];
  let absorbedExtraSeat = false; // ← si se absorbe 1, permitimos N+1

  if (cantidadSolicitada > 5) {
    // MODO CUADRADO: 5 por fila (permite 6 al absorber 1)
    seleccion = seleccionarCuadrado(filasMap, filaClic, numClic, cantidadSolicitada, () => {
      absorbedExtraSeat = true;
    });
  } else {
    // MODO NORMAL (≤5) con anti-huérfanas y absorción

    // 1) Misma fila
    if (filasMap[filaClic]) {
      const runs = buildRunsDisponibles(filasMap[filaClic]);
      let runConClic = runs.find(run => run[0].num <= numClic && run[run.length - 1].num >= numClic);

      if (runConClic) {
        let bloque = pickBlockFromRunNoOrphans(runConClic, cantidadSolicitada, numClic);
        // permitir +1 si hay exactamente 1 pegada
        bloque = absorberHuerfanaConFlag(runConClic, bloque, cantidadSolicitada + 1, () => {
          absorbedExtraSeat = true;
        });
        if (bloque.length) seleccion = bloque;
      }

      // Si no alcanzó, otro run cercano en la misma fila
      if (seleccion.length < cantidadSolicitada) {
        const candidatos = runs
          .map(run => ({
            run,
            dist: Math.min(Math.abs(run[0].num - numClic), Math.abs(run[run.length - 1].num - numClic))
          }))
          .sort((a, b) => a.dist - b.dist);

        for (const c of candidatos) {
          const faltan = cantidadSolicitada - seleccion.length;
          let take = Math.min(faltan, c.run.length);
          let bloque = pickBlockFromRunNoOrphans(c.run, take, numClic);
          if (!bloque.length && take > 1) {
            bloque = pickBlockFromRunNoOrphans(c.run, take - 1, numClic);
          }
          bloque = absorberHuerfanaConFlag(c.run, bloque, take + 1, () => {
            absorbedExtraSeat = true;
          });
          if (bloque.length) {
            seleccion = seleccion.concat(bloque);
            if (seleccion.length >= cantidadSolicitada && !absorbedExtraSeat) break;
          }
        }
      }
    }

    // 2) Fila anterior / siguiente
    if (seleccion.length < cantidadSolicitada || absorbedExtraSeat) {
      const orden = filasVecinasOrdenadas(filasMap, filaClic).filter(f => f !== filaClic).slice(0, 2);
      for (const fila of orden) {
        const runs = buildRunsDisponibles(filasMap[fila] || []);
        const faltan = Math.max(0, cantidadSolicitada - seleccion.length);

        const candidatos = runs
          .map(run => ({
            run,
            dist: Math.min(Math.abs(run[0].num - numClic), Math.abs(run[run.length - 1].num - numClic))
          }))
          .sort((a, b) => a.dist - b.dist);

        let added = false;
        for (const c of candidatos) {
          let take = Math.min(faltan, c.run.length);
          if (take <= 0 && !absorbedExtraSeat) break; // ya está completo
          let bloque = pickBlockFromRunNoOrphans(c.run, Math.max(take, 1), numClic);
          bloque = absorberHuerfanaConFlag(c.run, bloque, (take || 1) + 1, () => { absorbedExtraSeat = true; });
          if (bloque.length) {
            seleccion = seleccion.concat(bloque);
            added = true;
            if (seleccion.length >= cantidadSolicitada && !absorbedExtraSeat) break;
          }
        }
        if ((seleccion.length >= cantidadSolicitada && !absorbedExtraSeat) || !added) break;
      }
    }

    // 3) Otras filas de la zona
    if (seleccion.length < cantidadSolicitada || absorbedExtraSeat) {
      const resto = filasVecinasOrdenadas(filasMap, filaClic).filter(f => f !== filaClic);
      for (const f of resto) {
        const runs = buildRunsDisponibles(filasMap[f] || []);
        const faltan = Math.max(0, cantidadSolicitada - seleccion.length);
        for (const r of runs) {
          let take = Math.min(faltan, r.length);
          if (take <= 0 && !absorbedExtraSeat) break;
          let bloque = pickBlockFromRunNoOrphans(r, Math.max(take, 1), numClic);
          if (!bloque.length && take > 1) bloque = pickBlockFromRunNoOrphans(r, take - 1, numClic);
          bloque = absorberHuerfanaConFlag(r, bloque, (take || 1) + 1, () => { absorbedExtraSeat = true; });
          if (bloque.length) {
            seleccion = seleccion.concat(bloque);
            if (seleccion.length >= cantidadSolicitada && !absorbedExtraSeat) break;
          }
        }
        if (seleccion.length >= cantidadSolicitada && !absorbedExtraSeat) break;
      }
    }
  }

  // 4) Último recurso: disponibles aleatorios (no aplica absorción aquí)
  if (seleccion.length < cantidadSolicitada && !absorbedExtraSeat) {
    const dispZona = allArea.filter(s => disponible(s.el));
    for (let i = dispZona.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [dispZona[i], dispZona[j]] = [dispZona[j], dispZona[i]];
    }
    const faltan = cantidadSolicitada - seleccion.length;
    seleccion = seleccion.concat(dispZona.slice(0, faltan));
  }

  // IMPORTANTE: si absorbimos 1 huérfana, permitimos N+1 (no recortar).
  if (!absorbedExtraSeat && seleccion.length > cantidadSolicitada) {
    seleccion = seleccion.slice(0, cantidadSolicitada);
  }

  // Selección final
  const seleccionFinal = seleccion.slice(0, cantidadSolicitada);

  // ======================================================
  // ========== VALIDAR DISTANCIA ANTES DE MARCAR ==========
  // ======================================================
  if (!validarDistanciaSeleccion(seleccionFinal, MAX_DISTANCIA)) {
    /* Swal.fire({
      icon: 'warning',
      title: 'Asientos separados',
      text: 'Las sillas seleccionadas están muy retiradas entre sí.'
    }); */
   // return; // NO continuar
  }

  // Marcar visualmente
  seleccionFinal.forEach(s => {
    const el = s.el;
    el.classList.add("seleccionada");
    showSubTotal();
  });

});
showSubTotal()


document.getElementById('openMap').addEventListener('click',(e)=>{
    const mapModal = document.getElementById('mapModal');
    const mapEl = document.getElementById('map');
    if (mapModal) {
      mapModal.style.display = "flex";
      // #mapModal (.modal) tiene z-index:9999 en CSS, pero container-compra-ahora tiene z-index:99999
      // Necesitamos que el mapa quede POR ENCIMA del modal de sillas
      mapModal.style.zIndex = "100001";
    }
    if (mapEl) mapEl.style.display = "flex";
});

// Cerrar modal
document.getElementById('closeMapModal').addEventListener('click', () => {
    const mapModal = document.getElementById('mapModal');
    if (mapModal) {
      mapModal.style.display = "none";
      mapModal.style.zIndex = ""; // restablecer al valor CSS base (9999)
    }
});